export const content = {
    home: {
        name: "الصفحة الأمامية",
        url: "/",
        priority: 0,
        notification: {
            name: "cookies",
            title: "هذاالموقعيستخدمالكوكيز 🍪",
            description: "نحن نستخدم ملفات تعريف الارتباط لتحسين تجربتك على موقعنا ولإظهار المحتوى الأكثر ملاءمة لك. لمعرفة المزيد ، يرجى قراءة سياسة الخصوصية وسياسة ملفات تعريف الارتباط الخاصة بنا.",
            actions: [
                {
                    name: "يلغي",
                    priority: "secondary",
                    type: "reject",
                },
                {
                    name: "يقبل",
                    priority: "primary",
                    type: "accept",
                },
            ],
        },
        sections: [
            {
                id: "content-frontpage-breaking-news",
                name: "أخبار عاجلة",
                articles: [
                    {
                        id: "8a6ed5ec-89f3-42ad-b948-189d36f278c9",
                        class: "columns-3-narrow",
                        header: "غير خاضعة للرقابة",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "الاستهداف الآن ، موز الحياة الحلق للغاية.",
                        type: "text",
                        content:
                            "الرجاء أعضاء كرة القدم كقوة كرة قدم.لكن الوقت هو جرة وجع.مجموعة غير من الفلفل الحار.عنصر الحياة الآن ولكن أعضاء كرة القدم في الهواء الطلق.في أي رعاية لسهم سريري.آخر ما تريد دعاية مطوري كرة القدم البيئية السلطة في بعض الأحيان.الاستهداف الآن ، موز الحياة الحلق للغاية أو .الآن مسح الحياة في الحلق.\n\nبشكل السفن ما يتم. جدول الإمداد أن جُل, هو دون اتفاقية باستحداث الدولارات. فقد في وشعار الأمريكي. اكتوبر بتطويق ليرتفع الى قد, غير بالرغم أفريقيا إستيلاء في. وحرمان باستخدام و لها, أن يعبأ بمباركة ولم, ان ومضى الجوي تحرّك حول.",
                    },
                    {
                        id: "d204d10c-879e-4991-802c-25020077e0de",
                        class: "columns-3-wide",
                        header: "المزيد من القصص العليا",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        title: "فقط بحاجة إلى كرة قدم رائعة لأعمال الاحماء ، ولا تتغذى على القطر.",
                        type: "text",
                        content:
                            "لان وتنصيب والفلبين التبرعات إذ. المواد وهولندا، إذ كلّ, دار السيطرة والكساد لم. عدد لم اللا الثالث استعملت, ذات من ويتّفق معاملة. قائمة معارضة قبل ما. قد الجو وهولندا، فقد. أخذ إذ كانتا وبالرغم, يبق هو مرجع ليركز ويكيبيديا،. جُل الفترة الأرواح ثم, بشكل وصغار غير بل, قام عل وباءت المسرح الجنوبي.\n\nتعد وجهان ميناء غينيا مع, و تجهيز وقدّموا فقد. المسرح الأرواح إذ ضرب, و تلك تسمّى وقامت الأهداف. أسر ثم وسمّيت وتتحمّل الانجليزية. بل قدما حالية مكن, الآلاف المتحدة مع به،. فكانت يعادل أن بلا, تكبّد لتقليعة بريطانيا-فرنسا كان قد.",
                    },
                    {
                        id: "e02d07e1-32e3-4ad1-b57c-b945f89d12d3",
                        class: "columns-3-narrow",
                        header: "الجريمة والعدالة",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "سلطة كرة القدم حياة مجرد عملية الاحماء العظيمة.",
                        type: "text",
                        content:
                            "هذا و كانتا مليارات الفرنسي, وبداية وبعدما فعل و. مليون وحرمان مما لم, الا مع تكبّد سبتمبر, جنوب قِبل إجلاء بـ عرض. إبّان مكثّفة واقتصار بعد أن, و ذلك غينيا تكتيكاً. ان أسر أفاق تعداد المسرح, و ببعض لتقليعة لان. في جُل بحشد الدّفاع, بل لهيمنة وتتحمّل بحث. عل وشعار أمدها قتيل، بين, تحت ان أجزاء وقامت المتحدة, دار إختار الأول أي. بـ أدنى وسمّيت الفرنسية شيء.\n\nولم واندونيسيا، تشيكوسلوفاكيا تم, ما ولم إنطلاق العالم الأثنان, وصل عالمية مشاركة الأوروبية، و. أي دأبوا الطريق الأثناء، حين. وانهاء مساعدة ومن ان, قبل و معارضة ألمانيا. به، مئات وباءت الربيع، في, دون اتّجة كُلفة الجنوب تم. أن هذه عليها اكتوبر العالمي. بحشد فبعد الدمج يبق من, ٣٠ أكثر ولاتّساع كان.",
                    },
                ],
            },
            {
                id: "content-frontpage-latest-news",
                name: "أحدث الأخبار",
                articles: [
                    {
                        id: "7af9e63d-d803-477b-ba8f-539f5d7ed1fe",
                        class: "columns-3-balanced",
                        header: "يحدث الآن",
                        type: "articles-list",
                        content: [
                            {
                                title: "لوريم الجزر جدا.",
                                content:
                                    "كانتا فرنسية استبدال أم فصل, أخر إذ الأراضي باستحداث. تلك أن استبدال لبلجيكا،, كل لكل وسوء الوزراء, وقام وجهان مساعدة وصل كل. كل فكان سياسة أساسي بعض, حيث أم الأخذ الشمل العسكري, ولم في هناك الآلاف. الا السبب الصفحات أم, لم خلاف ٢٠٠٤ عرض. للمجهود الأوربيين بريطانيا-فرنسا بحث قد, حتى لغزو اليها الإقتصادية إذ, وبغطاء الضروري استبدال إذ لكل. و دول دفّة الحرة للجزر, ضرب غرّة، المبرمة ثم, بالرّد البرية الأعمال ٣٠ حيث.",
                            },
                            {
                                title: "إجراءات المراقبة المحسنة.",
                                content:
                                    "تحت وبداية عالمية مسؤولية بل, بشرية نتيجة البولندي عن به،, ومضى الإنزال أسر بل. والكوري الخارجية ما أخذ, ٣٠ للصين أفريقيا ذلك. لكل تم وحتّى بلديهما. بالعمل بتطويق باستحداث أسر إذ. أضف عل الإثنان والفلبين, لدحر بتحدّي وفنلندا وتم ما, والنفيس العمليات الإكتفاء ثم جعل.",
                            },
                            {
                                title: "لكنني سأكون في.",
                                content:
                                    "ماذا باستخدام لم أما, مع لمّ بقسوة المشتّتون. يكن أن وعُرفت والإتحاد. ولاتّساع الرئيسية ما ذلك. كلا ترتيب لعملة لم, الضغوط محاولات استراليا، هو ضرب. الأسيوي, محاولات الباهضة واندونيسيا، مع جعل. عن بعد فقامت الخاسر التخطيط. يكن بهيئة أسابيع ولاتّساع",
                            },
                        ],
                    },
                    {
                        id: "cb7942ac-5ac8-40d1-90fd-7853a0a10d16",
                        class: "columns-3-balanced",
                        header: "جدير بالملاحظة",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "الدعاية أو الحامل في الاحماء والرعاية والسريرية.",
                        type: "list",
                        content: [
                            {
                                content: "معقل الواقعة عن غير, قد ومن صفحة تسمّى الرئيسية.",
                            },
                            {
                                content: "هو. بعض بقعة قدما عل, جُل دفّة بتخصيص قد. انه تزامناً لتقليعة ٣٠, إذ أثره، أراضي بالجانب فعل, إذ قام الذود مليون البرية.",
                            },
                            {
                                content: "عض بقعة قدما عل, جُل دفّة بتخصيص قد. انه تزامناً لتقليعة ٣٠, إذ أثره، أراضي بالجانب فعل, إذ قام الذود مليون",
                            },
                            {
                                content: "وتم و بزمام المتّبعة الدولارات, ان أسابيع الثالث، الثقيلة تلك, دول ٣٠ وجزر مشارف الآلاف. شاسعة النفط ولم ٣٠, مما عل رئيس مسؤولية وقدّموا. أن قائمة",
                            },
                        ],
                    },
                    {
                        id: "cd53f511-0251-4fb0-ae85-9ad228551dd6",
                        class: "columns-3-balanced",
                        header: "حول العالم",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "الآن فيليس الأرض ، كرة السلة تحتاج إلى كتلة كبيرة ، كارتون لوريه لوريم.",
                        type: "list",
                        content: [
                            {
                                content: "الخاصّة حدى, أم شاسعة غرّة، لها. بل وشعار مواقعها أضف, وشعار فرنسية المسرح حين بـ. الى الوزراء الشّعبين كل. بعض هاربر بتخصيص بمباركة بل, عل جُل وقبل قدما مسارح",
                            },
                            {
                                content: "أراض بالحرب الحيلولة بعض ثم, هو أسيا ضمنها فعل. قتيل، والنفيس غير بـ, هامش شواطيء الإتحاد ثم حدى, أي قبل هناك الأولى.",
                            },
                            {
                                content: "هو الفترة وفرنسا لليابان بحق. الآخر الإنزال ولاتّساع ثم حتى. أخر ما بسبب تصرّف مشاركة, كل حقول بوابة طوكيو ضرب, مرمى وزارة السبب دنو ثم. يعبأ القوى الاندونيسية لم يبق,",
                            },
                            {
                                content: "بـ أخر غينيا بتخصيص, كلا هو إبّان كنقطة  أن. ما بعض يقوم العالمي المنتصر. واُسدل ولكسمبورغ بـ ضرب, تم الا يعبأ السيطرة, بالرّد محاولات جهة أم.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-frontpage-latest-media",
                name: "أحدث الوسائط",
                articles: [
                    {
                        id: "b419e5f0-1707-4c0e-85b3-48f26a70f91b",
                        class: "columns-1",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-frontpage-highlights",
                name: "يسلط الضوء",
                articles: [
                    {
                        id: "1519cdfe-bb32-4f0a-aad1-2f4bb87096a4",
                        class: "columns-wrap",
                        header: "النقاط البارزة المحلية",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "يبق عن قدما حاملات, وفي عن هناك اعتداء والفلبين. كل تزامناً الجنوبي العالمية عدد, أعلنت بالمحور في دار. وبالرغم أفريقيا ان بال. أمام البولندي تشيكوسلوفاكيا ذلك هو. أساسي وصافرات إيو لم. وصل كردة وصافرات ما.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "بـ مسارح والفلبين التقليدية وتم, لدحر الشرقية الوزراء عدد ثم. كردة وإيطالي الصفحات بل حيث, بـ بحث بقصف مسرح أخرى. مدن الله وأكثرها ومطالبة بل, زهاء سقوط الأولية قد وصل, يقوم الصفحة مكن ٣٠. جديدة اكتوبر ان لها, تم الا بقصف لكون. قد اوروبا الخارجية عرض. بين كل وترك أمّا وسمّيت.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "لكل كُلفة حادثة كل, ما أراض حادثة التنازلي به،. الدمج الساحة تم مما, بشرية إعادة قد الى, به، جمعت بمباركة ما. وفي في مارد تمهيد, كلا تم حلّت أمام مدينة, جعل و الأرواح واشتدّت. من وعلى الصفحات حيث. فعل وصغار الشرقية المزيفة أن.",
                            },
                        ],
                    },
                    {
                        id: "0b9b6f8c-0dde-4c2f-82dd-b777fa84881d",
                        class: "columns-wrap",
                        header: "النقاط البارزة العالمية",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "كلّ أمّا الجو الصينية بل. إذ كما جسيمة اليابان، المتساقطة،, حين أملاً يتمكن ثم, لم تحت ميناء بالرغم. عرض للسيطرة لإنعدام من. ان القوى انتباه الإحتفاظ حيث, لان تم احداث الفترة الخاطفة, أوزار اوروبا والديون أضف ان. في منتصف والفلبين جُل, هذا عل الآخر بالحرب, بقعة مارد وسمّيت أضف ثم. مدينة المتاخمة بريطانيا-فرنسا تحت بل, تم كما بالإنزال بالولايات.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "كان إحتار اليها السادس و, تم هذا بوابة التقليدية, الحيلولة المتّبعة الولايات ٣٠ دول. يبق جنوب وقرى والحزب أن, ٣٠ الله دأبوا الضروري عدم, وتم رجوعهم وسمّيت المتساقطة، ٣٠. عل لمّ الدول بتحدّي, عجّل أعلنت ابتدعها تم يتم. ما الأخذ المتساقطة، كما. جنوب أكثر انه هو, عل وبعد وسوء يكن.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "فعل أي كثيرة والروسية, عن خطّة إحكام فرنسية وصل. هذه ٣٠ إعمار إبّان الانجليزية. مسرح عملية حول أم, كل قِبل سياسة مدينة لكل. تم يبق حقول تاريخ للجزر. أن كانت الأوروبية، بعض, عل بعض هامش لفشل بشرية, غينيا الأحمر السادس أي حدى. إذ وتم ثانية تجهيز, ٠٨٠٤ بقسوة عالمية حين في, بالحرب بأضرار مع كما.",
                            },
                        ],
                    },
                    {
                        id: "8eed7659-370e-4a45-8977-b21eb88ab793",
                        class: "columns-wrap",
                        header: "أبرز الأحداث المحلية",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ان لليابان الحكومة يبق. كل أثره، المضي الأهداف كلّ, أما تم غريمه الشمل. أم أهّل اوروبا شموليةً نفس, للصين ارتكبها بال تم. من كان المسرح يتعلّق, العالمي اتفاقية يكن تم. حيث عملية النفط الحدود لم. وأزيز وتزويده أي فعل, ٣٠ ومن احداث يتبقّ الخطّة. الجو تنفّس المتحدة في قام, حول قد سقوط للسيطرة والنرويج.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "قبل للمجهود بمباركة ٣٠, ثم ولم الذود الساحة إستيلاء. عدد و بالعمل وبالرغم الكونجرس, هذه المحيط استطاعوا التقليدية ان. دار الشهير وفرنسا بالولايات في. ثم كلا كردة فقامت الفرنسي, تم نفس الأمم الأولى الساحل. تكبّد الصينية وقد بل, ثم إحتار إستعمل التخطيط جهة, ذات أن تنفّس فكانت الشتاء،. الوراء الشرقية ماليزيا، قد فقد, يعبأ مشاركة الإنزال أن بعد.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "جهة التنازلي المتساقطة، ان, به، حقول ويتّفق معارضة إذ. أم كلا الخاطفة الشهيرة الأولية. أوروبا المجتمع وقد مع, تاريخ العالمية المشتّتون ما وتم, فسقط شدّت ان دول. يذكر تكبّد من قام. شمال دأبوا الكونجرس ٣٠ مدن, لكل مع شمال لدحر دأبوا. هذا و تعديل تجهيز الوزراء, ما يذكر لغزو دون.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-frontpage-top-stories",
                name: "أهم الأخبار",
                articles: [
                    {
                        id: "4e01d65b-b4f0-4b43-8d28-2fb8f918071c",
                        class: "columns-1",
                        type: "grid",
                        display: "grid-wrap",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "ما عشوائية سنغافورة غير, أي جهة الجنوب ابتدعها, بـ الا بزمام فشكّل يونيو. كل كان أمام وأزيز الحيلولة, دفّة الإمتعاض واندونيسيا، وتم ان. الأرض الحكومة المعاهدات مع أخذ. قد لفشل ابتدعها لان, لم يكن واعتلاء وبلجيكا،. في فعل يطول أسيا وأزيز, ان تعديل وزارة هذه.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "عجّل أراض الواقعة عدد في, طوكيو الأراضي التخطيط الا إذ. قبل ان ليركز مقاطعة. عدم اتّجة الأجل معزّزة ثم. نهاية الإتحاد ومن بـ, تحت أم الشرق، الأثنان الإمتعاض. أم مشروط بمعارضة والنرويج بحق, ان المضي بمعارضة حين. و أمام العظمى عدم, عل فصل نقطة حكومة, قامت تطوير الساحلية كل تلك.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "تم خلاف الأسيوي أسر, ضرب ووصف علاقة استبدال عل, وترك إعلان ما أما. التكاليف المشتّتون كل هذا, بعد وباءت الضغوط الثالث قد, و شعار وبريطانيا حدى. فصل ما لفشل جديداً, قد أمام استرجاع بحث. عن مدن تُصب ووصف, تلك أي واُسدل ارتكبها تشيكوسلوفاكيا, ذلك الحرة لمحاكم الأهداف تم. ديسمبر الخاصّة الإثنان أسر أم, يبق ألمّ بالمطالبة أن, تشكيل إتفاقية تلك ثم. و عليها ممثّلة مكثّفة أسر.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "عدد لعدم وفرنسا أي, وتزويده الأرضية يتم هو. جورج مسارح يكن ٣٠. نفس أملاً الشرقي بالولايات مع, تصرّف فرنسية مع الى, ثم الا .",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "عجّل الشطر النزاع ثم دنو, ومن عل لفرنسا الباهضة. مئات الأجل واشتدّت بحق كل, غضون وعُرفت نفس أي. انه وحتى أوزار والقرى قد. الخاصّة الأوروبية، من بها, مسرح علاقة الرئيسية ان حين, أن العاصمة ويكيبيديا الا.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-frontpage-international",
                name: "دولي",
                articles: [
                    {
                        id: "c5deda28-5da7-4641-80dd-e9859088c95d",
                        class: "columns-3-balanced",
                        header: "أوروبا",
                        type: "articles-list",
                        content: [
                            {
                                title: "يرجى المطور في تمويل الجزر طبقة وثيقة الهوية الوحيدة.أنواع نطاق تصنيع الشارع.",
                                content:
                                    "الا ان يقوم المشترك بالسيطرة, ثم تسبب وإقامة تغييرات هذا. كان أوسع يتبقّ الكونجرس أي, أسر وجزر بهيئة الأولى كل. أم العناد يتعلّق الخاصّة وصل, بقصف هاربر عدد أن. أي لعدم انتهت الاندونيسية وقد, يتم هو وبدون أملاً الخاطفة. يطول المشترك أن كما. كما وحتّى وقدّموا الوزراء مع, بـ النفط للإتحاد ومن.",
                            },
                            {
                                title: "هناك حقيقة مثبتة منذ زمن طويل وهي أن المحتوى المقروء لصفحة ما سيلهي القارئ عن التركيز",
                                content:
                                    "ببعض الوراء بـ حول. فصل هو الأول مهمّات محاولات. حتى عل إحكام الوراء, أن حول بلاده الشمل المدن, وقام شاسعة واستمرت ٣٠ قبل. بحث بتطويق بمباركة الشتوية ما, عُقر معزّزة أن حيث. مع ضرب حاول جسيمة علاقة. حدى في تعداد الآخر. أسر تم أعلنت القادة, تم لها معاملة الهادي.",
                            },
                            {
                                title: "ولكن إذا كانت حمامات كرة القدم ، ولكن البحيرة ، ولكن الكاريكاتير في.",
                                content:
                                    "حول عل الجنود الشتاء،, لها عليها بتخصيص الجنرال كل. نتيجة الشمل كل لها. الا بـ وبدون الإنزال بالمطالبة, حول لم هناك الإمداد. تحرّك بالعمل هو بين, عل على وسوء بزمام اليها. ٣٠ جعل تعداد وباءت وقوعها،, نتيجة أعلنت مشاركة بها تم, احداث والديون قام أي.",
                            },
                        ],
                    },
                    {
                        id: "387033b0-e832-48b3-a3fe-f104075cf93a",
                        class: "columns-3-balanced",
                        header: "أمريكا الجنوبية",
                        type: "articles-list",
                        content: [
                            {
                                title: "كانت دعاية الحاجة القوس متنوعة الواجب المنزلي.",
                                content:
                                    "وفي مكّن للسيطرة الإطلاق من. في وصل جسيمة المتحدة التجارية, عن ضرب الإمداد ولكسمبورغ, هو بالفشل والعتاد أضف. فبعد وعُرفت إنطلاق في ومن. وترك وبولندا بعض مع, للسيطرة العسكري الأوروبي مدن أن. بـ الجنود الأثناء، لبولندا، كان, مكن عن تحرّكت استطاعوا.",
                            },
                            {
                                title: "طريقة لوريم إيبسوم لأنها تعطي توزيعاَ طبيعياَ -إلى حد ما- للأحرف عوضاً عن استخدام هنا يوجد",
                                content:
                                    "دون ثم بداية حادثة ويكيبيديا. أما لهيمنة استبدال التكاليف عل, أي تحت جدول وبداية اتفاقية. عرض ما تمهيد مسارح وحلفاؤها, ان أثره، فشكّل مدن. صفحة لغات مشارف بل مدن, دون تم الجنود المبرمة. الذود بأضرار الأهداف انه أي, بالعمل وصافرات ومن تم, مئات مشروط بال من.",
                            },
                            {
                                title: "يشرب أو تريد كل منها.",
                                content: "فعل يونيو انتصارهم في, و أخر تعداد أوزار ليرتفع. لم حتى جسيمة وسمّيت والإتحاد. بفرض الصفحات لم لان, جسيمة السفن يكن كل. أن الفترة بريطانيا مدن.",
                            },
                        ],
                    },
                    {
                        id: "06fa8c40-6678-483b-bbb5-a8f73822d1e1",
                        class: "columns-3-balanced",
                        header: "آسيا",
                        type: "articles-list",
                        content: [
                            {
                                title: "قد يكون الأعضاء أيضًا لاعبيك الفلفل الحار.على سبيل المثال ، ولكن حلق القبيح في كرة القدم ، مشروب بلدي ، ولا.",
                                content:
                                    "الشمال سليمان، ان دول, قد ومضى وقبل عشوائية لمّ. البرية والعتاد وصل من, أن شيء وبدأت حالية. أم كما واحدة اتفاقية, أي بحق أراضي واقتصار. ثم وجزر تكاليف عشوائية الى, عل ولم سكان قائمة. ان حين رئيس مرمى وترك. نفس إعلان واتّجه سنغافورة ٣٠, المبرمة ماليزيا، قد إيو. بـ وقد وجزر قادة لبولندا،, تحت عل الثقيل الربيع،.",
                            },
                            {
                                title: "وادي هاريترا لتعيين وعاء الأسد الذي يرجع تاريخه.",
                                content:
                                    "حتى لم جورج عليها استدعى, جديدة وباءت الساحة ان كما, يبق عن فبعد والنفيس الاندونيسية. يكن بـ يتبقّ تغييرات, عدد بسبب علاقة الدّفاع إذ. أن رجوعهم اسبوعين جعل, أكثر مقاومة في بال. و مساعدة وتزويده العالمية لان, بحث خيار مساعدة عل, من بها بالفشل وإعلان مواقعها. سقطت مساعدة بين أي, أعلنت استرجاع بعد ثم.",
                            },
                            {
                                title: "في مختلف أو جعبة أو قبيح بحاجة الآن إلى ألم لوريم.",
                                content: "رجوعهم الجنوب أي بحث. بل مرجع وصغار شيء, بسبب جديدة دول بل. ان لإعادة المجتمع وايرلندا بال, مكن و يعبأ محاولات ومطالبة. جهة أم مايو سياسة الدمج. حول سبتمبر وبغطاء ومحاولة بل, فعل أي بلديهما لتقليعة للأراضي.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-frontpage-featured",
                name: "متميز",
                articles: [
                    {
                        id: "f0704a5e-cf35-4c2b-afc1-c07325577554",
                        class: "columns-3-balanced",
                        header: "واشنطن",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "عشوائي أخذتها من نص، لتكوّن كتيّب بمثابة دليل أو مرجع شكلي لهذه الأحرف. خمسة قرون من",
                        type: "list",
                        display: "bullets",
                        content: [
                            {
                                content: "تدليك كرة القدم الجذاب في الجبهة.",
                                url: "#",
                            },
                            {
                                content: "اضبط الجري القبيح في هذا الشارع العشور.",
                                url: "#",
                            },
                            {
                                content: "وفي مكّن للسيطرة الإطلاق من. في وصل جسيمة المتحدة التجارية, عن",
                                url: "#",
                            },
                            {
                                content: "الأداء على مجموعة الموجات فوق الصوتية للواجبات العقارية التغذوية حتى الآن.",
                                url: "#",
                            },
                            {
                                content: "من تصحيح فكي التدليك في بعض الأحيان.",
                                url: "#",
                            },
                            {
                                content: "الكثير من الضعف من أجل عدم وجود ضغوط طيران الموز.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "9f57970b-05f9-45c2-9e3c-ab0f66ce47f3",
                        class: "columns-3-balanced",
                        header: "نيويورك",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "الزمن لم تقضي على هذا النص، بل انه حتى صار مستخدماً وبشكله الأصلي في الطباعة والتنضيد",
                        type: "list",
                        display: "bullets",
                        content: [
                            {
                                content: "هذه دائمًا ابتسامة في المكياج حامل المكتب ليس الجميع كذلك.",
                                url: "#",
                            },
                            {
                                content: "وعُرفت إنطلاق في ومن. وترك وبولندا بعض مع, للسيطرة العسكر",
                                url: "#",
                            },
                            {
                                content: "دون ثم بداية حادثة ويكيبيديا. أما لهيمنة استبدال التكاليف عل, أي تحت ",
                                url: "#",
                            },
                            {
                                content: "فعل يونيو انتصارهم في, و أخر تعداد أوزار ليرتفع. لم حتى جسي",
                                url: "#",
                            },
                            {
                                content: "الشمال سليمان، ان دول, قد ومضى وقبل عشوائية لمّ. البرية والعتاد وصل",
                                url: "#",
                            },
                            {
                                content: "الكثير من الكتلة من صلصة ماكرو الحياة.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "bda30bf1-8032-4bfa-b17d-07571a7251f7",
                        class: "columns-3-balanced",
                        header: "الملائكة",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "يولد المورس لتفوت الماوس.",
                        type: "list",
                        display: "bullets",
                        content: [
                            {
                                content: "ماتيس هو السخرية من الأسهم العناصر.",
                                url: "#",
                            },
                            {
                                content: "الجزر المعقمة وعاء الجري تحتاج الآن كرتون الشوكولاتة موريس.",
                                url: "#",
                            },
                            {
                                content: "حتى لم جورج عليها استدعى, جديدة و",
                                url: "#",
                            },
                            {
                                content: "الآن كرتون الشوكولاتة موريس في بعض.",
                                url: "#",
                            },
                            {
                                content: "تريد التمويل ولكن الأداء ولكن بوابة لوريم لينة بعض.",
                                url: "#",
                            },
                            {
                                content: "المبرمة ماليزيا، قد إيو. بـ وقد وجزر قادة لبولندا،, تحت عل الثقيل الربيع،.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-frontpage-underscored",
                name: "يؤكد",
                articles: [
                    {
                        id: "affd2923-97de-4410-9258-bce3e4a19b87",
                        class: "columns-2-balanced",
                        header: "هذا أولا",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "تصفح يقوم الشهير عدد و. و وتم بوابة تطوير. إيو قد لعدم يعادل, ذلك لدحر وتنامت كل, قام وسوء أملاً المشتّتون في. بعد يذكر نتيجة اليابان، كل, أحدث أطراف البولندي كان أن. ذات لهيمنة الحدود و, أسابيع الحدود اليابانية ان حتى. دون مارد أجزاء المؤلّفة ٣٠.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "وتم بقيادة الواقعة باستحداث ما, أي انه العدّ ممثّلة استدعى. إيو ان وقرى لغزو, فكانت الشطر شموليةً يكن لم. دفّة الأخذ جهة ٣٠, مع بسبب بالفشل حين. أن والحزب والمانيا ضرب, لدحر التي إذ أخر, بين لم وقرى بهيئة. وجزر بالفشل الأوروبيّون قام أي, بل والتي التخطيط تحت.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "a196957d-d9fa-400a-a94c-dca3f6815700",
                        class: "columns-2-balanced",
                        header: "هذا الثاني",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "وعلى أفاق مهمّات من أما. أخذ ضمنها انتهت أفريقيا ان. في ا استمرار الدنمارك ذات, ما بينما معزّزة الا. قِبل وباءت والعتاد ان فعل, ٣٠ ومن وقبل بتخصيص. على حصدت ليبين تكاليف أم, بلا من حكومة الشرق،, لان لإعادة الثقيلة في. بين وبعض حكومة إعادة من, جنوب النفط ٣٠ على.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "وتم عُقر النفط الرئيسية عن, ضمنها ولكسمبورغ وبريطانيا ثم مما. ولم أم أكثر وبالتحديد،, عرض الحرة الطرفين اتفاقية إذ, لغزو التجارية التقليدية عل جعل. أي مدن غينيا وسمّيت, إبّان فرنسا أي فقد, على مع سليمان، والإتحاد بريطانيا-فرنسا. أي الإثنان العمليات جُل, ان سابق معاملة حيث. سكان تشكيل بقيادة هو دنو.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-frontpage-happening-now",
                name: "يحدث الآن",
                articles: [
                    {
                        id: "f07e6f59-5962-4410-b1a1-493770fa85c6",
                        class: "columns-wrap",
                        header: "سياسي",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "كنقطة الانجليزية كل حين, ٣٠ الجنوبي ايطاليا، التغييرات انه, عل هذه إنطلاق البرية. هُزم الفرنسي الأمريكية ٣٠ عدد, دون ما منتصف أوروبا بالإنزال. ٣٠ تحرّك الفرنسي فصل, بل كما ا البولندي. نهاية بالمحور حدى إذ, إذ أوسع تجهيز الشمال ذات, قد بلا الحكومة الواقعة الكونجرس. أم فقد وبدون المحيط. ومن بل قدما الشرق، الأمريكي, ٣٠ أواخر تشكيل وانهاء على.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "كل يعبأ بالرّد الولايات فعل, بلاده وباستثناء الإتفاقية قد على, أحكم لإعادة في تحت. جسيمة جديداً بالسيطرة ثم كان, بل يقوم وجهان واستمر وصل. ووصف واعتلاء و حيث, فقامت المحيط لتقليعة كان بـ. قدما جديداً إيطاليا بلا إذ, قد بأيدي الشرقي أسر. حول تم تحرير الثقيلة. تصرّف شاسعة مع عدم, أم العاصمة الشرقية المعاهدات به،.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ذات لم فكان فقامت والروسية. لمّ هُزم انتباه بل. دون مع لعدم ويتّفق المواد. كرسي اتّجة أطراف كلا من, بشرية وايرلندا كان ٣٠. ٣٠ وسفن قُدُماً الإيطالية بين, كل النفط يعادل هذا.",
                            },
                        ],
                    },
                    {
                        id: "3c3b206d-1b03-4fcc-9469-25b2caa64622",
                        class: "columns-wrap",
                        header: "صحة",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ما جُل هنا؟ وأكثرها, عن انه جزيرتي بالمطالبة. الله حقول كان في, بـ إيو ألمّ أخرى والمعدات, أخر بل تحرّك الضغوط والمانيا. ما سقوط نتيجة ويتّفق ومن. وفي ودول الواقعة ان, ٣٠ ذلك يذكر المتساقطة،, نفس و بقيادة بالحرب. بحث الأخذ وانهاء في, بالحرب وإيطالي لكل من.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "فكانت اعلان وإقامة قد وصل, ان يذكر قبضتهم والفلبين مكن. هو فقد وكسبت العصبة استبدال. أن الطرفين استراليا، انه. كانتا اكتوبر ان قبل, بقيادة وبولندا بريطانيا-فرنسا ما بين, عن أما لهيمنة والمانيا ماليزيا،. مع يبق بفرض وتنامت واستمرت, مع سياسة جديداً ذلك.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "هامش البرية الساحلية دنو في, مع شاسعة تعديل ومطالبة على. أي تمهيد عليها والكساد دول, أم ذات رئيس وصافرات. دار مرجع الأوروبية، قد, أملاً واُسدل حاملات أم بحث. من بشرية قُدُماً جُل, بها كل سياسة فقامت وانهاء. الستار للحكومة عل مدن, مشروط كُلفة المسرح من يكن, تحت بـ الجو وتتحمّل لبلجيكا،. غضون لفشل تحرّك ما جعل. حيث في قررت وباءت, قبل ثم الآخر بالفشل معزّزة, قد ترتيب استراليا، مكن.",
                            },
                        ],
                    },
                    {
                        id: "19a7a320-69b7-4ac6-b2b1-17206ccc8e67",
                        class: "columns-wrap",
                        header: "عمل",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "حيث عل وقرى بمباركة. لم بعض أمام ولاتّساع, العناد بمعارضة الإمتعاض تلك ما. ثم تمهيد كثيرة الشّعبين ذات, بـ كرسي أصقاع واتّجه لان, بقعة كانت الحرة كان و. مدن وزارة ميناء بمعارضة مع, جديداً تحرّكت باستخدام قد يتم.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "بها لم تونس جديدة الدّفاع, تم وصل مارد إجلاء اعلان. يبق في هامش المؤلّفة الدولارات, أم انه مليارات ولاتّساع الكونجرس. ترتيب الأخذ ممثّلة أسر ثم, الشمل الجنود عن كلا. وفنلندا الإثنان الجنوبي ثم حيث. وبعد لليابان ثم بعد. لم يكن الساحل التكاليف, حدى أجزاء الحيلولة عن, وأزيز مقاطعة الفرنسية كلا و. يعادل وإعلان واقتصار دول و.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "سقوط إحكام وبولندا أم جعل, جُل بـ فسقط تطوير سليمان،, وقرى الأجل الأوضاع ذلك ثم. أوسع الدنمارك ان أخر. العالمي مواقعها بال إذ, أما المحيط الاندونيسية هو. بل أخذ أواخر الآلاف القادة, أم استرجاع والنرويج غير, استدعى العالم، الأوربيين قد شيء. وجهان الدول وإعلان أما أم, ان رئيس مسارح اعلان يتم. تلك تُصب والنفيس هو, ماشاء الإثنان المتساقطة، عن شيء.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-frontpage-hot-topics",
                name: "مواضيع مثيرة",
                articles: [
                    {
                        id: "514e6188-22a4-4d01-ac19-342df74680e7",
                        class: "columns-2-balanced",
                        header: "هذا أولا",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "مع يبق المضي العالمية, كلّ هو جورج الآخر الغالي. انه ومضى القوى أي. كل غريمه بالمطالبة دول, بـ كلا قررت وعُرفت قُدُماً. نتيجة الشهيرة والفرنسي عدد كل, عدم ان وجزر وبدأت. بزمام الحيلولة بـ عرض, الى عُقر أفاق بالجانب هو, مكن أي تصفح التحالف. بال منتصف المؤلّفة قد, وقد وحلفاؤها المشتّتون أي.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "أي حدى بزمام العالم, المسرح الأبرياء في لها. ٣٠ ولم بخطوط تشكيل اعتداء, أم الوزراء التقليدي التقليدية دون. من بسبب العالمي كلا, ان يونيو التقليدي حول. كان أسيا وباءت واُسدل إذ, قتيل، شواطيء وتم من.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "df35d241-7b4e-41af-b4a8-aa5ac86a2625",
                        class: "columns-2-balanced",
                        header: "هذا الثاني",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "دنو صفحة أصقاع والكساد بل. بها ليبين بالولايات من, تعد أملاً وهولندا، ويكيبيديا، ان. كل أضف قِبل وبحلول استبدال, في الوراء للمجهود تلك. وبعض اعلان معاملة حول هو, مسؤولية الثانية في جهة. بها الوراء التّحول الأوروبية، في. الإنزال التّحول جُل من, مكّن مليون العدّ ٣٠ لان.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "دون قد بخطوط الشهير, قد يقوم الهادي والروسية جهة, أدنى الإطلاق الانجليزية عن تحت. بعد مسؤولية ارتكبها ان, لها العصبة المشتّتون بـ, أخرى وتزويده جُل ما. كل سقطت الصفحة وفنلندا إيو, حصدت اعلان وتنامت أم لمّ. وقد بحشد سقوط عليها في, عل تطوير للجزر المشترك فصل. ذات ٣٠ السفن اسبوعين.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-frontpage-paid-content",
                name: "المحتوى المدفوع",
                articles: [
                    {
                        id: "694bbfce-f1c9-4e10-95bc-a89023d5e1ea",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "الآن يشرب الموز لمضادات الأكسدة الحوامل أو.ولا  في الخميرة وضعت على الوعاء.م",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "تحتاج إلى كرة قدم ذكية أو قوس ابتسامة أي شخص.لا الدردشة القوس الحامل وأصول درجة الحرارة.",
                            },
                        ],
                    },
                    {
                        id: "6e110ab5-5d43-411b-a64e-3dae38960a60",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "من رقعة من فكي التدليك في بعض الأحيان.مجموعة التغذية الجماعية للعقارات التجمعات فوق الصوتيات حتى الآن.وادي الغد هو دائما المؤلف أو فترة الحياة.لارتجال الكثير من بعض المعرف.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "البيئي لا يحتاج إلى قطر كرة القدم حتى.كرة القد وصفة شبكة.",
                            },
                        ],
                    },
                    {
                        id: "e72adfa5-f82e-42b3-a0c6-c43f0c3f9393",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "أو حامل.لا يوجد مركبة من موبيليسي نولام نفسها من مسار طيران أو بعض كرة القدم.أي شخص هو شوكولاتة كرتون.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "هنالك العديد من الأنواع المتوفرة لنصوص لوريم إيبسوم، ولكن الغالبية تم تعديلها بشكل ما عبر",
                            },
                        ],
                    },
                    {
                        id: "96bc6b53-c533-4970-adb7-8dae30da76cc",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "عليك أن تتحقق أولاً أن ليس هناك أي كلمات أو عبارات محرجة أو غير لائقة مخبأة في هذا النص.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "طبقة ناعمة من أسد العبارة من قطر.الآن يشرب الموز لمضادات الأكسدة الحوامل أو الوادي.",
                            },
                        ],
                    },
                ],
            },
        ],
    },
    us: {
        name: "نحن",
        url: "/us",
        priority: 1,
        message: {
            title: "شاهد الأخبار العاجلة!",
            description: "حدث شيء مهم ويجب عليك مشاهدته!",
        },
        sections: [
            {
                id: "content-us-world-news",
                name: "اخبار العالم",
                articles: [
                    {
                        id: "31b24534-29f6-469f-8ce3-ff774997ef8a",
                        class: "columns-3-wide",
                        header: "يحدث اليوم",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        title: "لكن إنفاذ التنفيذ البيئي المغذي الحراري القابل للخصم.",
                        type: "text",
                        content:
                            "من غير حاول والفلبين اليابان،, فعل احداث اتفاقية في. في وصل وبعض عقبت وجهان, قائمة السيء ولكسمبورغ ومن أي, هاربر غرّة، هذه إذ. عل كلا الشمال وفنلندا, نفس كل لعملة التّحول ومحاولة, أوسع الجنوب الخاطفة دون هو. نفس مليون نهاية استعملت إذ, من الجنوبي وهولندا، أخر. جهة قد بالجانب بمحاولة ولاتّساع, أسر تم بوابة النفط وبحلول. فعل وبدأت اوروبا إذ. حقول وبعد وفي ٣٠, للجزر الأبرياء و شيء. دفّة العدّ الضروري دار أم, عل التي مقاومة الجنوبي بال. بـ ولم منتصف بالرّغم, عن أفاق الشرق، بريطانيا-فرنسا بال. مع نفس الأحمر الصعداء, بحث يقوم لهذه بـ.",
                    },
                    {
                        id: "06f7b876-6120-4273-8850-f60f817940f0",
                        class: "columns-3-narrow",
                        header: "الشائع",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "من أجل تنشيط سيناريو حياة فقط تحتاج إلى شيء عظيم.",
                        type: "text",
                        content:
                            "هذا ليس تصنيعًا معينًا لكرة القدم يركض ضحكًا في كرة السلة.بطولة وثيقة الهوية الوحيدة لايف الكحول تشرب الشراب كدبابات.فقط حتى الضعف القطر.تدليك كرة السلة حامل للغاية سريري للاستثمار.فالي تيلوس معرف البروتين معرف.\n\nلدحر السيء وهولندا، أم ولم, أما وإيطالي ألمانيا بالسيطرة بـ. ما رئيس الواقعة باستحداث حيث, أن الله قتيل، حول. عل الوراء الجنود أما, تعد قد اللازمة الأولية, أم تعديل والمانيا الإيطالية انه. تم لكل تعديل السيطرة ايطاليا،. لدحر والنفيس بريطانيا مع وتم, أوسع مليون أضف ٣٠, من وحرمان المشتّتون وقد.",
                    },
                    {
                        id: "e9f3877f-a2a6-41fb-898b-9acb0fdedc19",
                        class: "columns-3-narrow",
                        header: "طقس",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "هذا الفلفل الحار الطماطم إلى عنصر الكرة الطائرة الحلق.",
                        type: "list",
                        content: [
                            {
                                content: "سكان التغذية كرة القدم الحزين الشيخوخة.أو الفول السوداني Til ووقت الكراهية Orci بروتين كرة السلة في.",
                            },
                            {
                                content: "أنا أكره الراحة في نهاية الأسبوع في نهاية الأسبوع ، لكن إنفاذ إنفاذ التنفيذ البيئي.",
                            },
                            {
                                content:
                                    "لدحر السيء وهولندا، أم ولم, أما وإيطالي ألمانيا بالسيطرة بـ. ما رئيس الواقعة باستحداث حيث, أن الله قتيل، حول. عل الوراء الجنود أما, تعد قد اللازمة الأولية, أم تعديل والمانيا الإيطالية انه. تم لكل تعديل السيطرة ايطاليا،. لدحر والنفيس بريطانيا مع وتم, أوسع مليون أضف ٣٠, من وحرمان المشتّتون وقد.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-us-around-the-nation",
                name: "في جميع أنحاء البلاد",
                articles: [
                    {
                        id: "4e19c383-aff6-45de-b874-008c58a9667f",
                        class: "columns-3-balanced",
                        header: "أحدث",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "تم تكوين 1 فقرة، 5 كلمة، 27 بايت من نص لوريم إيبسوم",
                        type: "list",
                        content: [
                            {
                                content: "بال بالعمل جديداً ماليزيا، ان. عن بها مليارات المتحدة",
                            },
                            {
                                content: "آسف على كرة القدم التي تخرجت.",
                            },
                            {
                                content: "حين. خطّة بشرية أوراقهم حدى في, ما والتي أعمال العالمية دار. مكن",
                            },
                            {
                                content: "أنا لا الدردشة الكحول الحامل و.من المهم مضادات الأكسدة الكبيرة حتى وقت كرة القدم السريرية.",
                            },
                        ],
                    },
                    {
                        id: "53c3567d-6073-41e8-87ca-f76a282c38f9",
                        class: "columns-3-balanced",
                        header: "عمل",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "نطاق تصنيع مطور التغذية.للكرتون الشوكولاته الاحماء مع الرقبة.",
                        type: "list",
                        content: [
                            {
                                content: "جُل بشرية إستعمل إذ, بـ جعل خيار لغات تسبب. لم الإمتعاض الإتفاقية وتم, دنو كل",
                            },
                            {
                                content: "لأوربيين ثم ذات, و تشكيل إعلان أضف. جُل الضروري الخاصّة ان, الإمداد عشو",
                            },
                            {
                                content: "أوروبا ولاتّساع وحلفاؤها تم جهة, عل جعل وعلى وجهان والنرويج",
                            },
                        ],
                    },
                    {
                        id: "79344d21-3a1f-4531-87b7-971d0a01e959",
                        class: "columns-3-balanced",
                        header: "سياسة",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "آلام المكتب وظيفية رائعة.كما أنها ليست العقارات الآن هي أن أسهم عنصر المنطقة.",
                        type: "list",
                        content: [
                            {
                                content: "دون قد بخطوط الشهير, قد يقوم الهادي والروسية جهة, أدنى الإطلاق",
                            },
                            {
                                content: "بـ, أخرى وتزويده جُل ما. كل سقطت الصفحة وفنلندا إيو, حصدت ",
                            },
                            {
                                content: "قبل من الأمور الطرفين ولكسمبورغ, قبل غريمه أطراف إتفاقية عن, و",
                            },
                            {
                                content: "لم الإمتعاض الإتفاقية وتم, دنو كل وفنلندا وبالتحديد،, بخطوط وبلجيكا، بين بل. مشا",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-us-roundup",
                name: "جمع الشمل",
                articles: [
                    {
                        id: "660d5f2a-0977-423b-a585-dbd0f58695e4",
                        class: "columns-wrap",
                        header: "واشنطن",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "مرجع الأوروبيّون عن ذلك. بل لمّ بزمام تجهيز بمحاولة, يكن قد جيوب إستيلاء, ودول بينما الإطلاق ما حتى. بعد بل اسبوعين الإيطالية الإقتصادية. مما ان فرنسا ديسمبر إستيلاء, و منتصف تحرّكت أخذ.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "قبل من الأمور الطرفين ولكسمبورغ, قبل غريمه أطراف إتفاقية عن, و لمّ وجهان مشاركة. إذ لمّ الهادي بالمطالبة, إذ ٢٠٠٤ كنقطة اليها حين. خطّة بشرية أوراقهم حدى في, ما والتي أعمال العالمية دار. مكن ٣٠ ليبين قتيل، عسكرياً. ما الصفحات استرجاع مكن.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "بال بالعمل جديداً ماليزيا، ان. عن بها مليارات المتحدة, كردة واتّجه قُدُماً قام و. عل مارد الصين مساعدة كما. سابق الإنزال أي أسر, معزّزة بالحرب ضرب في. تم أضف خيار مواقعها.",
                            },
                        ],
                    },
                    {
                        id: "c88e0e0d-e323-4d4e-a0fb-b72c3fda9df8",
                        class: "columns-wrap",
                        header: "الساحل الشرقي",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "جُل بشرية إستعمل إذ, بـ جعل خيار لغات تسبب. لم الإمتعاض الإتفاقية وتم, دنو كل وفنلندا وبالتحديد،, بخطوط وبلجيكا، بين بل. مشارف الأوربيين ثم ذات, و تشكيل إعلان أضف. جُل الضروري الخاصّة ان, الإمداد عشوائية وقد ثم, عرض بل أملاً ديسمبر. مع لغزو بالعمل ذات, فاتّبع الأمور جعل كل.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "إذ قادة المضي النزاع قام, ما كلا وأكثرها ومطالبة الساحلية. قتيل، المضي ولم أم. ثم مما اتّجة الإكتفاء. قبل و أساسي بالسيطرة, حول أن بلاده معزّزة. و بقصف مسارح الإنذار، ذلك, تعد أمّا بهيئة الوراء مع.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "يكن الفترة وتنامت العالمي بـ, انتباه الربيع، باستحداث فصل عن. بعض ثم خطّة القادة. نقطة مرمى تم جُل, حيث قد تجهيز إستعمل التبرعات, يتبقّ رجوعهم إذ عدد. أسيا الشتاء عل شيء. معارضة وبالتحديد، قد أخذ. لان فكان بلديهما ثم, لدحر فهرست بل نفس.",
                            },
                        ],
                    },
                    {
                        id: "a2267128-dd86-4a98-8903-0a887d49104e",
                        class: "columns-wrap",
                        header: "الساحل الغربي",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "لها لغزو للمجهود لم. الخاصّة اقتصادية من حول, بعض قد لإعلان الإنزال الإمتعاض. بعض إذ إحكام الآلاف, أن هذا مقاطعة بالمحور. كل إحتار اعلان الى, بل به، مارد بخطوط المسرح.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "أوروبا ولاتّساع وحلفاؤها تم جهة, عل جعل وعلى وجهان والنرويج. بحشد أكثر هو به،, كان وإقامة استبدال لم. لمّ تصفح وفرنسا إذ, فقد أطراف إتفاقية ما, فصل اعتداء الطرفين ان. قُدُماً التجارية بـ مدن. مقاومة والروسية ايطاليا، كان أم, ان ومحاولة المشتّتون وقد, مما أم وحتى بتخصيص. دنو قد الجو ويتّفق, ثم الأولية الخارجية ويكيبيديا إيو, الأثنان واستمرت باستخدام من لكل.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "والنفيس التاريخ، بريطانيا، تم وقد, يذكر علاقة به، أم. أم يبق العدّ الساحة, المضي وكسبت انه قد, إتفاقية والديون الأراضي ما هذا. حول تم خيار الولايات, المجتمع المتحدة الأوروبية، بحق ما, تم للصين الأمور العمليات تحت. مليون هاربر المشتّتون لم عرض. بهيئة الغالي كما مع, ان بتخصيص مشاركة بالإنزال انه, وبعض مشروط ان بلا.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-us-crime+justice",
                name: "الجريمة والعدالة",
                articles: [
                    {
                        id: "bc92acd8-0cbb-42e6-88dc-7589e92eb218",
                        class: "columns-3-balanced",
                        header: "المحكمة العليا",
                        type: "articles-list",
                        content: [
                            {
                                title: "أو ابتسامة أو راحة سحب.",
                                content:
                                    "سابق أفريقيا الإتحاد في يكن, شمال لغات الحرة ٣٠ الى, أي بأضرار وحلفاؤها الرئيسية إيو. هو الى قامت البرية تزامناً, أم دفّة الحيلولة يبق. ان خلاف انذار مدن, مايو لإنعدام عل به،. المدن باستحداث لبلجيكا، من بحث, و أعمال الشرق، الجنرال بعض, و مارد بالرغم بالإنزال بعد. كل عقبت أكثر الربيع، شيء, ان أهّل ماشاء مدن. أحدث احداث بـ جُل, الحرة يتعلّق بلا هو.",
                            },
                            {
                                title: "الكثير من الضعف مات هو.",
                                content:
                                    "حتى ان لإعلان التغييرات, بـ وأزيز التجارية بريطانيا، بها. كل وبدأت يعادل لتقليعة حدى. ساعة ضمنها الفرنسي ٣٠ أضف. وصل في هُزم كانتا وإعلان, ما الى شواطيء اللازمة. بال كثيرة واتّجه الهادي ثم, بشكل ووصف الأرضية قام ما.",
                            },
                            {
                                title: "موريس في بعض السلطة البيئية مثل مطوري كرة القدم.",
                                content:
                                    "هو دول المضي الإحتفاظ الإمتعاض, بينما أعلنت قُدُماً جُل لم, الأحمر الخاسرة بل جُل. بل أخذ معقل الأجل الصعداء, الله اوروبا بالجانب أي عدم. الشتاء العظمى حاملات كل ضرب, عدم دخول مئات المزيفة في. بحشد اتفاق شيء أن, بـ أخذ تشكيل قبضتهم اللازمة. انه قد وحرمان الساحلية الأوروبي.",
                            },
                        ],
                    },
                    {
                        id: "190711e5-6bc8-4b26-920a-b6edd74a0847",
                        class: "columns-3-balanced",
                        header: "قانون محلي",
                        type: "articles-list",
                        content: [
                            {
                                title: "الكثير من العلاج حتى الضعف القطر.",
                                content:
                                    "مشروط العدّ المتحدة في جُل. مع شدّت تكبّد الإطلاق تلك, والكوري والمانيا الى عل, جعل تم مليون العسكري المجتمع. كلا شرسة البولندي الساحلية مع, الى هو بقعة تنفّس واقتصار. إذ لفشل ديسمبر لكل, و حتى إبّان بريطانيا-فرنسا. للسيطرة العسكري المنتصر أن عرض, وتم وصافرات التقليدي أي.",
                            },
                            {
                                title: "أحدث أسهم كرة السلة السريرية من الفلفل الحار تحتاج دائمًا إلى الواجب المنزلي.",
                                content:
                                    "أم الشرق، معزّزة الحيلولة الى. الصين شواطيء إذ قبل, مرمى الأهداف ثم الا, و بعض أراض والديون. أم كردة بقسوة وبالرغم على. إعادة ماشاء العسكري حتى عن, وإعلان العظمى عل كما, بحشد حقول لهذه أم فقد. لان العصبة والمعدات من, بقصف المضي المواد كل يتم. سكان ويتّفق وإيطالي فعل كل, ثم بال أوزار فشكّل, تكبّد التاريخ، التغييرات جعل عن.",
                            },
                            {
                                title: "الشوكولاتة الشوكولاتة الشوكولاتة في الأرز.",
                                content:
                                    "إحكام للمجهود جهة قد, وصل ووصف أوسع للحكومة عن. وشعار عسكرياً التقليدية لم كما, كما ما ماذا ومضى تطوير, تحرّك بالحرب قد بحق. أن أمّا اتفاق لها. ماذا ٠٨٠٤ وبولندا عن قبل, لها وقام التّحول استرجاع عن. قد سياسة غرّة، كلّ, و جُل أطراف إستيلاء.",
                            },
                        ],
                    },
                    {
                        id: "0233b0b6-69f1-4c51-81cd-b849e435f2c1",
                        class: "columns-3-balanced",
                        header: "رأي",
                        type: "articles-list",
                        content: [
                            {
                                title: "رائع وتصنيع العقارات المختارة.",
                                content:
                                    "ثم الجنرال الأوربيين يكن. تعد الذود تحرير وباءت ٣٠. تم لكل مليون سبتمبر شموليةً. وبعض سبتمبر يتعلّق بلا عن, إيو قائمة أجزاء و, ثم بعد للمجهود وبولندا. و أسر مرجع الخطّة اوروبا, من ذات وعُرفت الإنزال. اتفاق الشمل بمباركة بال أن, تلك أن السيطرة الأعمال, وحتّى السيطرة بريطانيا أن لها.",
                            },
                            {
                                title: "خلافاَ للإعتقاد السائد فإن لوريم إيبسوم ليس نصاَ عشوائياً،",
                                content:
                                    "لمّ إبّان وباءت الإثنان عل, مكن الطريق الشّعبين ٣٠. فقد خطّة وترك يتسنّى ان, الفرنسية ولكسمبورغ بـ حيث, أسر قد الأمريكي الإقتصادية. أي بين تطوير النزاع, المحيط النزاع عسكرياً بعد لم. كما معارضة للسيطرة انتصارهم و, عن وإقامة الإقتصادية أضف. من أسر الأوضاع الدنمارك انتصارهم, اليميني لإنعدام يكن إذ. تشكيل بريطانيا، لمّ بل, كل واُسدل للسيطرة بحث, انه ان هُزم التبرعات.",
                            },
                            {
                                title: "لكلاسيكي منذ العام 45 قبل الميلاد، مما يجعله أكثر",
                                content:
                                    "جمعت الأوروبيّون أخر مع, ترتيب يونيو واُسدل كلّ أن, وفي لم وباءت ديسمبر. ثم اعتداء المنتصر كلا. بل حدى بقصف عشوائية. إذ بالفشل واتّجه بها, ما عرفها للمجهود اتفاقية هذا, وانهاء الكونجرس ٣٠ بال. خطّة الأولى الباهضة لم مما, لم جهة إعلان الباهضة.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-us-around-the-us",
                name: "حول الولايات المتحدة",
                articles: [
                    {
                        id: "90e08554-f9b4-4606-8e36-55de40b39f9f",
                        class: "columns-3-balanced",
                        header: "أحدث",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "لجعل سعر الميكروفون لسحب القوية ، ودرجة الحرارة.",
                        type: "list",
                        content: [
                            {
                                content: "لقد كان مطور الراحة في التغذية في.الجزر المتخرج لكرة القدم هو عقار في.",
                            },
                            {
                                content: "وثيقة الهوية الوحيدة لتزيين الجزر المتدربين للاستثمار في الأرنب.من فضلك ومع ذلك ، إنفاذ التنفيذ الاحترافية البيئية.",
                            },
                            {
                                content: "مع, قبل أي اللا المنتصر والنفيس. أن حتى مئات وإيطالي تشيكوسلوفاكيا, في سابق",
                            },
                            {
                                content: "عجّل أصقاع الربيع، حيث قد. الخاطفة الأبرياء انه عن, بعض ما لفشل الأحمر",
                            },
                        ],
                    },
                    {
                        id: "9c6014cf-a577-4611-a2ce-97f2b4afc322",
                        class: "columns-3-balanced",
                        header: "عمل",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "في السرير دفع الواجب المنزلي وادي تيلوس معرف لاعبي الجزر قطر الجزر.",
                        type: "list",
                        content: [
                            {
                                content: "من الى الضغوط البرية الانجليزية, كل لهذه إبّان ضرب, هذا الوراء الإتحاد",
                            },
                            {
                                content: "أحتاج إلى الميكروويف الخاص بي ولكن مجاني ل.يحتاج الفلفل الحار الشوكولاتة دائمًا إلى الواجب المنزلي في المنطقة.",
                            },
                            {
                                content: "الحاضر الحزين العظيم هو الفلفل الحار المهم.الفول السوداني في سياق القداس المدرسي.",
                            },
                        ],
                    },
                    {
                        id: "48cabfe4-6408-488f-b942-8d59d35163f7",
                        class: "columns-3-balanced",
                        header: "سياسة",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "بينما تعمل جميع مولّدات نصوص لوريم إيبسوم على الإنترنت على",
                        type: "list",
                        content: [
                            {
                                content: "بل إيو وقبل مشروط الدولارات, عل أخرى لفرنسا نفس. أن وسوء الحكم الأمريكي لا",
                            },
                            {
                                content: "التغذية كتلة العقارات تعويض الواجب المنزلي.الميكروفون في مؤلف الوعاء الآن الذي يعمل.",
                            },
                            {
                                content: "مبروك الجري تحتاج الآن إلى الشوكولاتة الكرتون موريس.",
                            },
                            {
                                content: "أمراض الألم ليست قوسًا للابتسامة التي تتماشى لأن أي شخص آخر هو معرف.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-us-latest-media",
                name: "أحدث الوسائط",
                articles: [
                    {
                        id: "92371ddb-b2cf-43e2-8590-bda1440c7025",
                        class: "columns-1",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-us-business",
                name: "عمل",
                articles: [
                    {
                        id: "8e2a8c79-f1dc-4e6c-8542-04684ae08bce",
                        class: "columns-3-balanced",
                        header: "محلي",
                        type: "articles-list",
                        content: [
                            {
                                title: "ومع ذلك ، فإن منطقة الكرتون في هذا الشارع العشور.",
                                content: "وقد في وحتى الانجليزية. تعد أم الصين وانتهاءً. مارد أوزار للحكومة من بعض, ٣٠ أسر تكاليف وأكثرها, قبل شعار لغات وحلفاؤها مع. حتى ما وإقامة وإيطالي, أن إيو والتي الثالث واعتلاء.",
                            },
                            {
                                title: "وقت رعاية القطر الذي لاعبي كرة القدم.",
                                content:
                                    "في حيث وبغطاء الشتاء والعتاد, ولم عن دخول تطوير شواطيء. تحرير إحتار الطريق دار تم, حتى أكثر الربيع، كل. كل اللا ارتكبها الثالث، دار, ٣٠ عرض هاربر العالم, بل وصل سياسة ماشاء الجنود. الشمال والمانيا بـ بعض, انه مع الدول موالية, و المارق وتزويده ضرب. عن الله تُصب كما.",
                            },
                            {
                                title: "الأسد أو البوابة السريرية ليست وسادة أو.",
                                content: "السبب الشتاء، استمرار فقد هو. بل إيو يتمكن الباهضة, ان ذات اوروبا البرية. تعد الدّفاع المؤلّفة ان. قامت ليبين الأوضاع مع مدن, فكان المنتصر ما مدن.",
                            },
                        ],
                    },
                    {
                        id: "5acb5684-4b99-44ff-9668-2e5daec9133c",
                        class: "columns-3-balanced",
                        header: "عالمي",
                        type: "articles-list",
                        content: [
                            {
                                title: "كل أسهم جزر الفلفل الحار في نهاية الأسبوع التصوير الفوتوغرافي موريس.",
                                content: "الصين محاولات أم بعض, عن حيث خلاف ديسمبر. هو أوسع مقاطعة تشيكوسلوفاكيا بعد, عرض وسفن بقيادة أم. ما تحرّك بالتوقيع بها, دار شرسة احداث من, قبل لم فكانت ابتدعها البشريةً. ببعض تنفّس لم عدم.",
                            },
                            {
                                title: "كان حامل كرة السلة سريريًا لاستثمار التغذية السريرية.",
                                content: "التي السبب اتفاقية أم وفي. كلا ثم دفّة مايو, لدحر ألمّ الثقيل ما يتم. الا لم أخرى أكثر تعداد. وفي مدينة الغالي بل, بين الأمور لإنعدام المتساقطة، أن. قبل حالية إستعمل مسؤولية ما.",
                            },
                            {
                                title: "لا يحتاج رات بما تتطلبه",
                                content:
                                    "مما تم الأجل لفرنسا الأوربيين. أوسع وزارة ثم بين, هو عرض قتيل، الستار ومحاولة, الى فكان كنقطة لم. هو والتي ويتّفق المؤلّفة وصل. عدد لغات بقسوة البولندي لم. هو بحق يذكر جسيمة وسمّيت, قد مدن هناك غريمه وبالرغم. دار لم ماشاء التقليدي, أسيا العظمى بالمحور تحت بـ. دول عل اللا أوزار الخطّة.",
                            },
                        ],
                    },
                    {
                        id: "fd9fce73-e286-450f-8fcf-7b988b968f3b",
                        class: "columns-3-balanced",
                        header: "ربعي",
                        type: "articles-list",
                        content: [
                            {
                                title: "لا الدردشة القوس الحامل وأصول درجة الحرارة.",
                                content:
                                    "عجّل أصقاع الربيع، حيث قد. الخاطفة الأبرياء انه عن, بعض ما لفشل الأحمر لإعلان. و أضف شعار قامت, أمدها أوزار الإكتفاء أما مع, قبل أي اللا المنتصر والنفيس. أن حتى مئات وإيطالي تشيكوسلوفاكيا, في سابق انذار الإتفاقية بحق. ان الدول لإعلان للسيطرة بحث, أي بعض الجو وايرلندا, أن بلا غينيا لليابان.",
                            },
                            {
                                title: "أتمنى لكم معرف فقر وثيقة الهوية الوحيدة لتزيين الكراهية القوس.",
                                content: "وبعض وإيطالي إذ به،. بل الا القادة اعتداء الهادي. ألمّ مساعدة عدد عل, عدد كل التي لإعلان. فعل ما دخول للسيطرة, بـ وإقامة للإتحاد بها. عرض عالمية للإتحاد لم.",
                            },
                            {
                                title: "الآن أو ابتسامة الراحة سحب طبقة لاكوس أو.",
                                content:
                                    "من الى الضغوط البرية الانجليزية, كل لهذه إبّان ضرب, هذا الوراء الإتحاد في. كل منتصف عسكرياً حول, إذ بعض أحكم مسؤولية بالسيطرة. هامش ليرتفع من يبق. كلا أن وعُرفت بمعارضة وحلفاؤها, أي بعد سكان وبعدما الانجليزية. يتم مع لغات سنغافورة.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-us-underscored",
                name: "يؤكد",
                articles: [
                    {
                        id: "f7640582-e9b6-4d47-b396-95515aa0a840",
                        class: "columns-2-balanced",
                        header: "هذا أولا",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "ساعة وتنامت وباستثناء حيث و, جُل عقبت بداية قتيل، عن. هو غير تحرير الخاسر. الدمج واقتصار والمانيا وفي ٣٠. انه في الموسوعة استطاعوا, أن جدول وحرمان تعد. كانتا السادس العالمي قام ما, أن حيث وبعض ليبين اليميني. والقرى الخاسرة بالولايات كما إذ.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "بل إيو وقبل مشروط الدولارات, عل أخرى لفرنسا نفس. أن وسوء الحكم الأمريكي لان, ساعة الخارجية شيء في. ٠٨٠٤ الأمم الولايات في ذات, عن عقبت إحكام ومحاولة يتم, شيء عل بتخصيص سنغافورة. كل شيء بقعة وبغطاء واقتصار, نقطة انتهت عدد تم, إذ الى تونس أحدث. أم وتم اتّجة ومطالبة, الى تُصب فمرّ العالم ما, هو جُل جنوب فهرست الوزراء.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "3f4c33ce-8628-46d1-b416-37b0fc218c74",
                        class: "columns-2-balanced",
                        header: "هذا الثاني",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "حيث لفرنسا المعاهدات الدولارات و, لها الدنمارك وبريطانيا عل. دون دارت مليون السيء تم, أم بهيئة الأسيوي الساحلية بعد. بـ غريمه انتباه تعد, إذ الحرة انتباه مسؤولية مدن. إجلاء الثالث وقوعها، عن ضرب. بين جمعت سكان والعتاد ما. مدن ثم الساحل العالمي استبدال, دول بل ونتج انتهت.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "قد ذات أدوات بالحرب ومحاولة, مع جمعت لفشل والروسية ذلك. فصل عل جنوب إعادة وكسبت, عرض عن زهاء المبرمة. و ومن خلاف وحرمان, أن يبق رئيس لتقليعة الأبرياء. كلا لم انتهت شواطيء, أم نفس هاربر الساحلية.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-us-state-by-state",
                name: "الدولة حسب الدولة",
                articles: [
                    {
                        id: "88c59d52-03e2-47cc-82a0-f0d9df4a88db",
                        class: "columns-wrap",
                        header: "كاليفورنيا",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "حقول هنا؟ الموسوعة كان كل, حاول جنوب عن وقد. لها إذ شمال الإنزال الثالث،. لها قد العدّ بمحاولة المتاخمة, سكان الأمور اليابان، أما من. ارتكبها الأولية تعد بـ, وقد مكثّفة وحلفاؤها باستخدام ان, حيث تم الجنود الإنزال.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ضمنها لإعادة الإتحاد إيو من, فقد ترتيب يتسنّى واقتصار في, إستعمل استمرار العالمية ٣٠ عدم. أي كما ليبين مهمّات الشرقية, إذ جورج للأراضي ضرب. جيوب تعديل بمباركة أسر عن, شعار سقطت إستعمل ذلك ان. بل العناد الإحتفاظ اليابان، دون. أن أما الشتاء ومحاولة, ٣٠ معقل الأسيوي ويكيبيديا، قام.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ببعض بمحاولة وتم و, تم عدد لإنعدام اقتصادية. لان في وبعض الشهيرة, قد الشمال ماليزيا، الدولارات إيو. يبق قائمة جزيرتي ما. يبق حصدت هامش الأمم ٣٠, و خطّة قادة السادس فقد. عل حيث وقبل ممثّلة الغالي.",
                            },
                        ],
                    },
                    {
                        id: "f28c0060-72db-4588-8b38-9f1b2a01a3ac",
                        class: "columns-wrap",
                        header: "نيويورك",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "بال ساعة بالفشل وسمّيت ما, تحت بل الله الجو. التي بمباركة ثم كما, بل كلّ دفّة عرفها. أي جُل نتيجة يتعلّق وقدّموا, بها لم أكثر وبلجيكا،. يطول السيطرة ٣٠ أضف, ٣٠ تُصب تحرير الأولى حتى. عدد إجلاء نتيجة الساحة ثم, الدول فقامت يكن ٣٠. من أراض تغييرات الولايات بها, بل القادة جديداً على.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "فصل جيما اتفاق الهادي أم, تعد عل قبضتهم وتتحمّل. تشكيل حاملات التنازلي حتى تم. حين بـ يتعلّق البرية الحيلولة, أي الأخذ العظمى حين. وعلى كرسي وقوعها، أي الى, الهادي المتّبعة ان هذه, فعل ٣٠ جنوب الشمال.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ليتسنّى وبالتحديد، دول ٣٠, بمباركة مليارات الشّعبين قام من. ان يعبأ بالحرب وباستثناء جعل, دون بـ ومضى وجهان فرنسية. مع بشكل إعمار حتى. وقبل لإعادة وقد ما, بهيئة تشكيل مما أي, الشرقية بمحاولة تعد ٣٠.",
                            },
                        ],
                    },
                    {
                        id: "bc567ef4-d017-4679-8d7b-c822dd49a3dc",
                        class: "columns-wrap",
                        header: "واشنطن",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "قام أم سقوط أواخر. مدن الثقيل الثقيلة الواقعة ٣٠, مع المحيط الصفحة الشتاء، دون, بحق كردة التحالف الإقتصادي مع. يتبقّ الفترة كلّ أم. أم مسرح شمال وسمّيت حيث, يتم في تسبب وحتّى. جدول النفط فقد ٣٠, الستار الباهضة بريطانيا لمّ في.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "فسقط الثالث عل على. ومن الأجل اليها بل, عرفها وباءت إتفاقية أضف بل. بحث بل إعلان الأبرياء الاندونيسية, بل إنطلاق العالم تزامناً يبق. والحزب بالمطالبة تم ضرب, قد وتم مهمّات بولندا،, جعل تُصب وعلى بالحرب ثم. الى أم وتتحمّل الوزراء, تعداد الانجليزية دنو ٣٠. غينيا وفنلندا فقد عل, كُلفة الحدود العالمي ثم جهة, الحكم بلديهما أي به،.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "يطول إجلاء تم كلّ, و فصل عالمية بقيادة بمعارضة. عدد تم قدما عالمية الأثنان, بفرض وسوء التّحول دول مع. ثم السيء إستعمل استمرار الا, اعلان كثيرة الثانية من قام. فهرست ويتّفق دنو من. ٣٠ فقد شرسة دأبوا تعديل, أن بتخصيص والإتحاد ولم, أخر بينما الشمل إذ.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-us-hot-topics",
                name: "مواضيع مثيرة",
                articles: [
                    {
                        id: "4a2d747f-a853-4452-82bf-504b5f79a7fe",
                        class: "columns-2-balanced",
                        header: "هذا أولا",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "بل أمدها العصبة الإيطالية فصل, قد والفرنسي سنغافورة الأمريكية بعد. ببعض أمّا قد مما, كانتا والكساد بـ حتى. عدد إذ معاملة وسمّيت. أخذ أم قُدُماً بالإنزال, تعد هامش نهاية عالمية بل, بقسوة العدّ بالحرب فصل أم. في الصفحة وقدّموا مدن. عن ضمنها بولندا، دنو, حين وقبل بداية إختار كل, ان بال الحكم اقتصادية. أن تعد مارد الشمال, حيث و أهّل العالمي اقتصادية, إختار التغييرات ولم ثم.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "Iليبين بتخصيص حين و. كانتا بولندا، واستمرت تعد مع, بل لها ثمّة بتخصيص الثالث،. القوى بريطانيا-فرنسا و كما, و تلك يتسنّى ا اليميني, تلك ثم بالرّد مهمّات الشتوية. ثمّة المشترك ومحاولة هو بها.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "c897ed90-26b7-4f9d-9c2c-7eb37270a317",
                        class: "columns-2-balanced",
                        header: "هذا الثاني",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "تم وقبل جسيمة وكسبت فقد, ما جهة الأسيوي والمعدات. عل كانت الهجوم يتم, مكن أن أمّا وبحلول المبرمة. عن غير وكسبت عسكرياً, بل شيء أثره، ا. أخذ تشكيل بقيادة المنتصر كل, ذلك أدنى أواخر اقتصادية مع. الطريق العالم، اليميني فقد ثم, لأداء وتتحمّل الأعمال قبل تم. والحزب وفرنسا عسكرياً جهة كل, كل تحت سياسة تحرّك.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "بقصف العصبة الوراء وصل و. لهذه المضي أم قبل, هو دول بقصف حادثة. دارت مسرح عقبت تلك عل. حلّت معاملة تحت ما. قد الضروري وصافرات تحت.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-us-paid-content",
                name: "المحتوى المدفوع",
                articles: [
                    {
                        id: "3acc4e4e-2720-4d9a-aa3e-ec820f6b4f00",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "وقتي تمويل مطور التغذية يحتاج إلى الحمل.كما أن المطورين لا يقدمون دائمًا ولكن السيرة الذاتية للكرة الطائرة.",
                            },
                        ],
                    },
                    {
                        id: "ca777be8-b675-4dc0-817f-972a72129394",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "ومع ذلك ، غد كرة القدم قوس الكحول.وكان أيضا الشوكولاته في الشوكولات لا رسم كاريكاتوري.",
                            },
                        ],
                    },
                    {
                        id: "cb0c2767-4955-4cc6-ae13-5c44a958b36f",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "الآن ، لكن هذا يبتسم دائمًا في المكياج الحامل للمكتب.وكرة القدم حتى أكره راحة قطر الأطفال في عطلة نهاية الأسبوع ولكن.",
                            },
                        ],
                    },
                    {
                        id: "efe39446-2154-4279-9d1d-66d27db034ac",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "دائما صفر الشخص المختار في قطر عطلة نهاية الأسبوع ليتم تعقيمه.فيليس بحاجة الآن إلى كرتون الكثير من تذوق الفلفل الحار في الكتلة. الجوع والقبيح.",
                            },
                        ],
                    },
                ],
            },
        ],
    },
    world: {
        name: "عالم",
        url: "/world",
        priority: 1,
        sections: [
            {
                id: "content-world-global-trends",
                name: "الاتجاهات العالمية",
                articles: [
                    {
                        id: "4da73fa5-c64a-43d8-873f-af7024fbae8c",
                        class: "columns-3-balanced",
                        header: "أفريقيا",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "لكنها دائما ابتسامة في مكتب حامل.الأسهم السريرية من الفلفل الحار تحتاج دائمًا إلى الواجب المنزلي في المنطقة.",
                        type: "text",
                        content:
                            "مدن و تحرير بمباركة الباهضة, الأول اعتداء أخر لم, تلك و الثقيل الحكومة استرجاع. هو العدّ اليابان لان, ٣٠ وقامت مكثّفة مكن, مدن بلاده الآخر الشرقية ٣٠. غير للمجهود المجتمع مع, وشعار ايطاليا، تم كلّ. قد الحيلولة العمليات وصل. سابق والحزب الدّفاع انه و. جهة بـ وترك والحزب تزامناً.\n\n أفريقيا, شاسعة إعمار به، ما. ولم كرسي وقوعها، من. فصل واستمر التنازلي لم, أم مكن تاريخ تطوير الساحل. أساسي بمحاولة دار هو, لها الأول لإعادة ما.\n\n٣٠ ومطالبة والفلبين جهة, أراض معارضة عرض ان. حكومة إحتار تم ضرب, عل جمعت وعلى أضف, حدى في نهاية الأرضية. الدّفاع العالمية الا أي, بـ طوكيو الساحة حدى. بحق ما اليابانية الإيطالية الأوروبية،, بـ فبعد ترتيب دول. بالحرب بالمطالبة ولم أن.",
                    },
                    {
                        id: "44d8807b-f06e-480f-8410-c5573127b527",
                        class: "columns-3-balanced",
                        header: "الصين",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "وادي ياسمين وميكروفون في الابتسامة.يحتاج مطور إلى الحمل مع رفاق أشعة السحب.",
                        type: "text",
                        content:
                            "تحت لفشل المتّبعة و, دول بأيدي بتخصيص مليارات عل. كل فمرّ شاسعة لعملة أخر, حول مع أوسع الشتاء،, حتى مشارف لمحاكم الشتوية إذ. كل الى جيما النزاع الكونجرس. ما اللا العالم فقد, يبق بـ سقطت أوزار بالولايات. وقوعها، التغييرات عن بحث. عن ميناء واشتدّت جهة, قبل يذكر التنازلي أي.\n\nجعل تم تونس ماذا مسؤولية, جُل ٣٠ بتخصيص وأكثرها والديون, ان بلاده وحلفاؤها وصل. أم بحث الواقعة باستخدام, كان ما فرنسا بالرّد لبلجيكا،, اتفاق وبولندا بالولايات أي حدى. دار القادة وتنامت عن. جُل طوكيو الثانية و, انه السفن العالم، عن. شمال مليون ثم كان, كل مما موالية ألمانيا الأهداف.",
                    },
                    {
                        id: "56478e74-f501-45a5-b9db-5a41b049f32b",
                        class: "columns-3-balanced",
                        header: "روسيا",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "ارتجاع كبير وتصنيع عقاري مختار كرة السلة موريس.",
                        type: "list",
                        content: [
                            {
                                content: "اليها الهادي المتساقطة، لم بال وبغطاء الشمال ايطاليا،, ثم المارق الأبرياء التقليدية حيث, مكن عل ويعزى لبلجيكا،. ترتيب لإعلان هذا قد, مدن عل تعديل الحدود اسبوعين.",
                            },
                            {
                                content: "وزارة أفريقيا الإقتصادي كما ٣٠, غينيا وبداية اليابان، عل هذه. لها تم بفرض أفاق الثالث،, بال مع مايو للمجهود, بقسوة فهرست الأولية هذا تم. حين في دأبوا",
                            },
                            {
                                content: "هذا بتخصيص بالرغم أن, الإقتصادية, لان غضون مقاومة تم. ولم إبّان أراضي إذ. مكن لم أفاق وأزيز وبلجيكا،, حقول المزيفة ٣٠ ضرب. وفرنسا المعاهدات عن بحق, فصل مسؤولية كل.",
                            },
                            {
                                content: "مرجع مليون الخطّة ومن ما, بقيادة وحرمان إيو كل. بتحدّي الأولية يكن لم. هو قام ليرتفع الخاطفة بالمحور, هو يذكر العدّ هذا. يتسنّى الفرنسي وتم هو, و بلا حادثة المواد. حول إذ يعادل",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-world-around-the-world",
                name: "حول العالم",
                articles: [
                    {
                        id: "22156cfb-5b44-4c70-adcc-8c560bb88bba",
                        class: "columns-3-balanced",
                        header: "أوروبا",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "محايدة محايدة. دائما المؤلف أو فترة الحياة.",
                        type: "text",
                        content:
                            "مع ولم بقسوة الخطّة. أم أمام الشرقية والنرويج نفس, بتطويق الأبرياء التغييرات في حدى, الطرفين بالمطالبة دار عل. بها ومضى وتنامت مليارات بل. إذ ولم الإطلاق مليارات وحلفاؤها, بخطوط بزمام لها ٣٠.\n\nأي لعملة إستعمل العالم، مما, وباءت الضغوط وبولندا ٣٠ تلك. حول هناك سياسة إذ, إيطاليا تزامناً الانجليزية ٣٠ ولم. قادة فاتّبع الثالث، ان هذه. إذ ووصف بزمام بين, ومن ثم ودول لهذه الموسوعة. الطريق للحكومة الأعمال يكن في, تحت قد الذود انتصارهم. لها واستمر الإطلاق استطاعوا ان. ووصف يتمكن الثالث، كل أسر.",
                    },
                    {
                        id: "0e6692ed-3268-4442-a52d-16c37c16c5e2",
                        class: "columns-3-balanced",
                        header: "الشرق الأوسط",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "الموظف والاتحاد الأوروبي ولكن الكثير من التصنيع المحدد.",
                        type: "text",
                        content:
                            "جعل إحتار الباهضة الواقعة ان, مدن في ودول الساحل الإثنان. بعض بينما مشروط الساحلية ان, عل اتفاقية التاريخ، هذا, قامت يتمكن بالتوقيع أي عرض. حكومة وعُرفت لم وصل. أسر بل نتيجة والحزب.\n\nخطّة وتنامت حين أم, تمهيد وايرلندا قد أخر. لفشل بداية بل بحق, أم وتم أكثر تشيكوسلوفاكيا. كان لم كانت المبرمة. قد أما نقطة مساعدة ابتدعها, تحت قد أخرى ارتكبها, انتباه والفلبين الاندونيسية لمّ عل. ان اللا وبالرغم الاندونيسية أخذ, بين عن لهذه بالفشل.",
                    },
                    {
                        id: "c9cd0674-b0de-4f53-9015-a97b57cf91d6",
                        class: "columns-3-balanced",
                        header: "آسيا",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "كان الخوف في وقت الراحة.",
                        type: "list",
                        content: [
                            {
                                content: "تم وقبل جسيمة وكسبت فقد, ما جهة الأسيوي والمعدات. عل كانت الهجو",
                            },
                            {
                                content: "تم اختياره كأسد في حياة القداس المدرسي.",
                            },
                            {
                                content: "والحزب وفرنسا عسكرياً جهة كل, كل تحت سياسة تحرّك.",
                            },
                            {
                                content: "الاتحاد الأوروبي لكرة السلة مؤلفة الدعاية لكرة القدم لتخرج.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-world-latest-media",
                name: "أحدث الوسائط",
                articles: [
                    {
                        id: "2c78e953-89f7-4a41-a852-6937b647674a",
                        class: "columns-1",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-world-today",
                name: "اليوم",
                articles: [
                    {
                        id: "b4f53c23-c475-4359-9b73-84b5f193695e",
                        class: "columns-3-wide",
                        header: "الاضطرابات",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        title: "موز الكرتون يتطلب الكثير.في الاحماء أو وضع على الوعاء أم لا.",
                        type: "list",
                        content: [
                            {
                                content: "القداس ليست لا قيمة لها الآن العقارات.الجزر المتخرج لكرة القدم هو عقار في.",
                            },
                            {
                                content: "إذ. كل الى جيما النزاع الكونجرس. ما اللا العالم فقد, يبق بـ سقطت أوزار بالولايات",
                            },
                            {
                                content: "مدن و تحرير بمباركة الباهضة, الأول اعتداء أخر لم, تلك و الثقيل الحكومة استرجاع. ه",
                            },
                            {
                                content:
                                    "اليها الهادي المتساقطة، عن لمّ. وفي هو قبضتهم وتنصيب. لم بال وبغطاء الشمال ايطاليا،, ثم المارق الأبرياء التقليدية حيث, مكن عل ويعزى لبلجيكا،. ترتيب لإعلان هذا قد, مدن عل تعديل الحدود اسبوعين. تحت لفشل المتّبعة و, دول بأيدي بتخصيص مليارات عل. كل فمرّ شاسعة لعملة أخر, حول مع",
                            },
                        ],
                    },
                    {
                        id: "8e24c654-824d-4b80-add0-e6a69926e2e1",
                        class: "columns-3-narrow",
                        header: "يحدث الآن",
                        url: "#",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "دائما أو وقت الحياة كأطفال أو للبعض.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "طب الكرتونية من البلياردو أو مضادات الأكسدة في عطلة نهاية الأسبوع.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "السهام السريرية كرة القدم عطلة نهاية الأسبوع الكراهية مضادات الأكسدة موريس الجلوس.",
                            },
                        ],
                    },
                    {
                        id: "b838d62e-fc9b-4c7f-808b-dfe42ba8207b",
                        class: "columns-3-narrow",
                        header: "جدير بالملاحظة",
                        url: "#",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "الآن مشروب الموز هو مضادات الأكسدة حامل أو وادي.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "إلى القطر من عدم وجود كتلة طيران ليست تصنيع معين.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "كرة القدم الإحماء العظيمة ليست قطر.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-world-featured",
                name: "متميز",
                articles: [
                    {
                        id: "333174c6-e4f4-4376-b0ff-38d31161b9db",
                        class: "columns-3-balanced",
                        header: "الاتحاد الأوروبي",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "الحداد تعقيم وعاء بيئي كبير.",
                        type: "list",
                        content: [
                            {
                                content: "كان ان وبدون حادثة النزاع, إذ العصبة واقتصار كما. ثم فعل هاربر أفريقيا.",
                            },
                            {
                                content: "سنغافورة لم. ولم عل لفشل تحرّكت محاولات, أم كما الساحة الجديدة، الفرنسية, أن دون مرمى أمام مساعدة. ٣٠ جُل حالي",
                            },
                            {
                                content: "الشرق، الهادي ٣٠ أما, ثم سقوط أمّا ومن. لمّ بل لعدم الأول. إذ أطراف اكتوبر دنو, قِبل الثقيلة الجديدة، حول كل",
                            },
                        ],
                    },
                    {
                        id: "28fd8202-0588-42a2-bb92-54c534521b23",
                        class: "columns-3-balanced",
                        header: "بريطانيا",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "الشوكولاتة السريرية الفلفل الحار تحتاج دائما الواجب المنزلي.",
                        type: "text",
                        content: "في قتيل، ابتدعها دنو. ضرب شمال للسيطرة استراليا، أم. قادة بقسوة الهادي مع عدم. إذ تطوير علاقة أساسي هذه. عليها الأوروبية الإقتصادية تم انه, بحق أم وسوء أمدها بريطانيا،.",
                    },
                    {
                        id: "bcb67523-c31c-44ae-b9a1-a2b3b0cc5793",
                        class: "columns-3-balanced",
                        header: "أمريكا اللاتينية",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "التخطيط ما لم تأخذ الحياة الحزمة.",
                        type: "list",
                        display: "bullets",
                        content: [
                            {
                                content: "ليتم تعقيمها في المنطقة في الخوف من الضعف.",
                                url: "#",
                            },
                            {
                                content: "خيار اليابان، الأوروبية، أم عدد. بـ لفرنسا واُسدل الى. التي اليميني",
                                url: "#",
                            },
                            {
                                content: "عرض يقوم أسابيع ديسمبر. سكان وزارة مسؤولية ذلك تم,",
                                url: "#",
                            },
                            {
                                content: "في اللاعبين باستثناء حياة كرة السلة للشوكولاتة.",
                                url: "#",
                            },
                            {
                                content: "هذا لعدم القادة الأمريكي أم. حالية السبب قد أسر. عن أخر",
                                url: "#",
                            },
                            {
                                content: "قطر عطلة نهاية الأسبوع كمنطقة معقمة.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-world-international",
                name: "دولي",
                articles: [
                    {
                        id: "bcdb2555-6ea9-48cc-b99e-7c496e95b54a",
                        class: "columns-wrap",
                        header: "الأمم المتحدة",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "و بينما مكثّفة الأمريكية يبق, إذ لفشل أفاق استرجاع بعد, جُل أصقاع معزّزة اليابانية ان. وصغار وحلفاؤها هو جعل, كانت تحرّكت التقليدي بلا كل. مكثّفة وهولندا، يكن هو, خطّة وجزر مع بين. هذه ان جيما ليرتفع, دون مع فسقط اتفاق بأيدي. مع يتم اعتداء الأمور وهولندا،, الخاسر المتحدة كل عدد. الخارجية استطاعوا بـ بحق.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "شواطيء ومطالبة إيو ان. أسيا والمانيا عل تحت, فكانت العالم، الربيع، أخذ أي. كلا و جديدة القوى. غضون أوسع اللازمة حول هو, يتم ما الآخر وبداية السادس, والقرى بريطانيا-فرنسا هذه ٣٠. وفي الحرة الأمور المواد إذ, جهة لم رئيس ميناء. بين أن أدوات التّحول.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "بـ أضف أوزار البولندي الإكتفاء. دارت الهادي يبق قد, أي ويعزى الساحل لمّ. وتم في أكثر اتفاقية الواقعة, وقبل مسؤولية قد شيء. يتم فمرّ مشارف ان, تلك ان وإقامة الخطّة. كانت الساحلية مدن كل, بل هذه اعتداء الثانية.",
                            },
                        ],
                    },
                    {
                        id: "db9bc4e6-b7d8-4cbd-b9a6-17bc5c50b8b1",
                        class: "columns-wrap",
                        header: "الاتحاد الأوروبي",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "خيار اليابان، الأوروبية، أم عدد. بـ لفرنسا واُسدل الى. التي اليميني بـ بحق, هذه الأوضاع المتّبعة و, وعلى محاولات سليمان، الى ان. هو الخطّة ديسمبر الأثنان يتم, لمّ ثم قبضتهم الثالث، وبلجيكا،.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "هذا لعدم القادة الأمريكي أم. حالية السبب قد أسر. عن أخر حصدت الفرنسية, الصفحات للإتحاد قبل ثم. ضرب عُقر أحكم لإعادة عل, من عرض يقوم أسابيع ديسمبر. سكان وزارة مسؤولية ذلك تم, غضون إجلاء العالم، ٣٠ تلك, دول كُلفة الخاسرة بل.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ومن عن الشتاء الشرقي, إذ أسر تطوير والإتحاد. ٣٠ الى لفشل بالحرب الإمتعاض. شاسعة تعديل ولم عن, يقوم لبلجيكا، قام و, فصل هو أوروبا الخاصّة. فعل الإثنان اليابانية من.",
                            },
                        ],
                    },
                    {
                        id: "a4208fe3-e9b4-46f6-af7e-ff04522ccc9c",
                        class: "columns-wrap",
                        header: "أزمة عالمية",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "مرجع الثانية الانجليزية لم مكن. فكان وبداية استمرار دار عل. الشتاء، الثانية حين مع. وصل أن لمحاكم للحكومة اليابان, تم عُقر وبغطاء شموليةً بها. أواخر الصينية فصل و, ومن أي ليتسنّى بولندا، اليابانية. بحشد عملية أما لم, هو العناد معزّزة بحق.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "أخر في مشروط الهادي, عدم تم ترتيب الشّعبين, من الإنزال البشريةً بعض. عل عدد الصفحات للأراضي, إعلان للجزر الشتاء، جهة من. عن العالمي المبرمة الأبرياء دون. هو الشهير بالتوقيع أخر, تعد عن مايو واستمرت, عرض من جمعت ماشاء المارق.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "حيث فقامت السفن وبلجيكا، في, حين أم وحتّى لليابان, أي أخر هاربر الدنمارك. تلك في سكان التخطيط, غير أراضي إتفاقية وهولندا، ٣٠. ما لها سقوط المضي وقدّموا, أخذ حكومة بقيادة تكاليف قد, ذلك أراض الحكم أي. ومن أم بقصف منتصف الاندونيسية, أن كُلفة ويعزى الواقعة عدم.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-world-global-impact",
                name: "التأثير العالمي",
                articles: [
                    {
                        id: "48ae1b0c-4f0c-47f8-ab31-4ec18aaaf24c",
                        class: "columns-3-balanced",
                        header: "طقس",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "عنصر الأداء ما لم يكن أي خصم.",
                        type: "list",
                        content: [
                            {
                                content: "الميكروفون في مؤلف كتاب الوعاء الآن معرف يدير المخاوف.إذا كان هناك الكثير من المرح أيضا.",
                            },
                            {
                                content: "أو عطلة نهاية الأسبوع ومطوري الحياة.مخاطر حركة المرور في.",
                            },
                            {
                                content: "مرجع الثانية الانجليزية لم مكن. فكان وبداية استمرار دار عل.",
                            },
                            {
                                content: "التذاكر في هذا الوقت من الوقت.",
                            },
                        ],
                    },
                    {
                        id: "71a55a05-6c7a-432e-8d8f-dc55746911e6",
                        class: "columns-3-balanced",
                        header: "عمل",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "الآن ، موز حياتي الحلق أو.",
                        type: "list",
                        content: [
                            {
                                content: "حيث فقامت السفن وبلجيكا، في, حين أم وحتّى لليابان,",
                            },
                            {
                                content: "الضحك سحب المرحلة الجامعية الأولى في المنطقة عدد صحيح الشوكولاتة.",
                            },
                            {
                                content: "الدورة التدريبية المطورين كتلة القبيحة وثيقة الهوية الوحيدة.",
                            },
                            {
                                content: ". ما لها سقوط المضي وقدّموا, أخذ حكومة بقيادة تكاليف",
                            },
                        ],
                    },
                    {
                        id: "f44f022b-f57e-4d6d-84bc-904dfad9686a",
                        class: "columns-3-balanced",
                        header: "سياسة",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "ن حتى جورج الحرة, ثم جيوب أواخر ولم, ثم جنوب الخاطفة البشريةً حول.",
                        type: "list",
                        content: [
                            {
                                content: "اربر الدنمارك. تلك في سكان التخطيط, غير أراضي إتفاقية وهولندا،",
                            },
                            {
                                content: "ذلك أراض الحكم أي. ومن أم بقصف منتصف الاندونيسية, أن كُلفة ",
                            },
                            {
                                content: "بحث ثم, ضرب لكون أملاً وفرنسا في. ثم فقد وصغار إعادة بولندا،.",
                            },
                            {
                                content: "تحرّكت انتباه مع. أن وبدأت يتمكن حدى. دون ٣٠ يتسنّى ",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-world-underscored",
                name: "يؤكد",
                articles: [
                    {
                        id: "060bbae5-655f-4ed6-ae0f-8afdb2056ecf",
                        class: "columns-2-balanced",
                        header: "هذا أولا",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "حول بينما الستار عل, لمّ كل الشتاء، التغييرات. ممثّلة الضروري بحث ثم, ضرب لكون أملاً وفرنسا في. ثم فقد وصغار إعادة بولندا،. الثقيل اليابانية بريطانيا، ثم بلا. عرض الأجل وتنصيب الإنزال و, بل ٢٠٠٤ إحتار لها.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "مسرح مواقعها الانجليزية و بلا, ضرب ودول إختار التّحول ما. إيو أحكم تحرّكت انتباه مع. أن وبدأت يتمكن حدى. دون ٣٠ يتسنّى التكاليف, عل وقد تسبب عرفها الثقيل.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "b4ef9c47-027a-4870-8413-b83366e1ce21",
                        class: "columns-2-balanced",
                        header: "هذا الثاني",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "ثم عدم ثمّة بمعارضة الدنمارك, ضرب ما كردة أكثر الأبرياء, ذلك عملية اتفاقية الشهيرة إذ. عن نفس العالمي الأسيوي وهولندا،, ما وبعض تمهيد رجوعهم يبق, على ثم ويعزى واستمر. به، عل إحتار السيطرة والكساد, ذات مليون مشاركة ا أن. أخرى جسيمة البشريةً تم يتم, قبل أي وجهان وزارة فرنسا, يكن انذار وإيطالي الأهداف بـ. أن خطّة المتساقطة، الى, تكبّد طوكيو ابتدعها أن ذلك, جورج واحدة الوزراء أم فصل.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "التخطيط الإثنان بالمحور لان قد. بحق وبدون ويعزى ان, بل تعد الأولى الأوروبية. أن جهة شاسعة بريطانيا الأوربيين, العدّ واستمر الأهداف قام هو. أن حالية إستعمل أسر, أجزاء للسيطرة وبالتحديد، به، مع, بقسوة حاملات الإقتصادية بل كان. كل ذلك الدمج المجتمع والكساد, هو شيء فكان بالجانب البولندي, ذات إعلان الثقيل في. مع يعبأ أجزاء ومن, حاول هامش تم لكل.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-world-global-issues",
                name: "قضايا عالمية",
                articles: [
                    {
                        id: "f189aeb3-f002-4cf4-929e-1957c1e049a9",
                        class: "columns-wrap",
                        header: "ارتفاع الجريمة",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "الشوكولاتة المراهقين حتى السعر.التلفزيون المضحك الآن ليس بعد الظهر.ومع ذلك ، ولكن سعر الابتسامة من تدليك كرة القدم الجذاب.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "في حياة الكتلة القبيحة ولكن.في هذه الدورة التدريبية ، فإن مجموعة التغذية هي مطور التغذية.أرنب برايس آينيان جويفر كبيرة والاستثمار في عطلة نهاية الأسبوع.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "تعد شاسعة أطراف عن, مرمى استعملت يبق عل. ان العسكري الإحتفاظ نفس, و فرنسية الموسوعة الإتفاقية كلّ. ذات بـ أهّل وزارة الإطلاق, الثقيلة والروسية ومن في, ان انه ٠٨٠٤ وقرى احداث. غير وتزويده التخطيط عن.",
                            },
                        ],
                    },
                    {
                        id: "ddf4293b-3356-4ec4-b349-75d29690623e",
                        class: "columns-wrap",
                        header: "المخاوف الصحية",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "عن وبعد تعداد وأزيز بحث, إذ أخذ مايو جديدة. هو وصل الساحل الخاصّة الأثنان. وبداية جديداً العاصمة شيء قد, أسابيع بتطويق الساحة غير عل, بفرض التنازلي نفس ثم. أن قبل وسفن اتّجة الخاسرة, قبل ليبين الجديدة، لم, بـ هذه أهّل لإعلان الخاسر.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "هو بقعة العالمي ضرب. هذه أم لغات المضي مشاركة, أطراف اعتداء عن قبل. ان غير مرجع فكانت أساسي. أضف وبدون الطريق بالرغم ثم. به، جورج معقل من.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ز والمعدات أي جهة. الى إذ بالرغم العاصمة التقليدية, ما بين التي الأوروبية, جمعت وإيطالي و حدى. تحت يذكر اتّجة كل. أي انه تُصب عالمية اليابانية, بحق جيما أراض أوراقهم إذ. جورج عملية والفلبين بحق أم, أم وسوء يونيو حول",
                            },
                        ],
                    },
                    {
                        id: "9b501227-b127-49b2-80d6-33945e5ea16c",
                        class: "columns-wrap",
                        header: "اقتصاد",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "كرسي لغزو استدعى هذه أم. في للصين الأمم حيث, وصل عل تصفح وباستثناء, ولم تسبب أوسع استدعى لم. عرض و التي الآخر بقيادة. تسبب واتّجه تحرّكت انه عن, لم وزارة الأحمر حيث, ومن معقل الطرفين ان. أمدها أساسي الأحمر من جُل.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "السبب العاصمة دول ما, علاقة التاريخ، الفرنسية هذا تم. وصل ان أوسع أواخر للسيطرة, أمدها إبّان لليابان إذ بلا. وفي كل ثمّة بالرّد, تم للجزر اليابان ذات. لم تعد الدّفاع بريطانيا. بها بل يعبأ وزارة وهولندا،, لغزو وفرنسا الصعداء أما بل. ان خلاف أساسي الأمريكي أخذ, في كلّ صفحة البولندي.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "و تحرّك الأهداف ايطاليا، ذات. لم الدول إحكام لها, وبعض أواخر وايرلندا هو فعل. و شيء هناك مسرح, لم أسر واحدة علاقة الطرفين, الى كل الإطلاق استرجاع. ان وجهان فرنسية وبالرغم قام, عجّل وفرنسا الانجليزية تم جهة.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-world-hot-topics",
                name: "مواضيع مثيرة",
                articles: [
                    {
                        id: "2ecc66a8-422a-4ec1-8523-b2b3b6bd95d1",
                        class: "columns-2-balanced",
                        header: "هذا أولا",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "لإعلان العالمي الدنمارك لمّ قد, كلّ وزارة الشهيرة التغييرات قد, عدم اتفاق مسؤولية واستمرت ثم. ان تلك وسفن أجزاء اعتداء, ما لها كُلفة ليرتفع. الجو وعُرفت مهمّات ومن ما. كلّ ووصف قائمة أسابيع ما, وهولندا، ايطاليا، لبولندا، ٣٠ لها.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "أسر عن بشكل وسفن تزامناً, أم وايرلندا الأوروبي انه. وبعض فرنسية التّحول تم أضف, كان اكتوبر بالجانب ان, ودول لهذه للصين عل بلا. الى ليتسنّى الأرواح ويكيبيديا، بل. كما و ودول وبدأت الثقيل, لمّ وعُرفت تكاليف عن. عدد ما أحدث وحتّى ألمانيا, أخر ثم نقطة كردة بتطويق, جعل أن بفرض والروسية.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "e97c9e59-bce0-408e-8151-644b4c51fa24",
                        class: "columns-2-balanced",
                        header: "هذا الثاني",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "شيء حاول مدينة ٣٠. إذ لكل ديسمبر ولكسمبورغ, حيث بحشد الحكم وقوعها، تم. حقول موالية لإنعدام عل حتى. بها العدّ وأكثرها ثم, بال لم عجّل لدحر لفرنسا.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "في حول وحرمان عسكرياً, حتى السفن بتطويق الطرفين بل, عن الى ماذا وقام ابتدعها. لهيمنة العالمي ان جُل, بالفشل التكاليف عل قبل. ضمنها أطراف وبلجيكا، فصل و, لان في بقصف ودول الدول. بل حدى اعلان معزّزة, بحق ثم استبدال التخطيط سنغافورة, وفي كل أثره، استطاعوا بريطانيا-فرنسا.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-world-paid-content",
                name: "المحتوى المدفوع",
                articles: [
                    {
                        id: "6f02bb8e-b794-403e-8417-6efaf23f7d4f",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "والرعاية والمهنيين السريريين.جماعي العقارات الواجبات الصوتية التجمع ولكن معرف المطورين القبيح.",
                            },
                        ],
                    },
                    {
                        id: "c1ab91c2-8a27-4b86-b862-f2cb98d99636",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "أو عطلة نهاية الأسبوع ومطوري الحياة على الإطلاق.الآن الكرة الطائر و.من التغذية أو لبعض السلطة ودرجة حرارة الوصفة.",
                            },
                        ],
                    },
                    {
                        id: "ea11fca8-afd0-4aab-b106-047aab8ca678",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "الأداء في الهواء الطلق على تعويضات الواجب العقاري الجماعي التغذية.لا يوجد موز للميكروفون في المؤلف.الحياة والأسد الواجب المنزلي كقطر من عدم وجود كتلة طيران.",
                            },
                        ],
                    },
                    {
                        id: "44a282f4-379a-41bd-bccb-5d7a16aa8d98",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "الفول السوداني في تشغيل المطورين الجماعي القبيح ل لتزيين التخرج.يسحب أو تدليك في بعض الأحيان يعزز لاعبين الحلق المجاني.",
                            },
                        ],
                    },
                ],
            },
        ],
    },
    politics: {
        name: "سياسة",
        url: "/politics",
        priority: 1,
        sections: [
            {
                id: "content-politics-what-really-matters",
                name: "ماهي المشكلة الحقيقية",
                articles: [
                    {
                        id: "5fed924d-8356-4d2e-bf06-ba58866f4cd0",
                        class: "columns-1",
                        type: "grid",
                        display: "grid-wrap",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "فاتّبع الفترة دول تم, أم قام بزمام الشهير, كل تصفح الإقتصادية انه. قد بلا ودول الأرض, تم جنوب السبب الشمال بلا. هذا مسرح شموليةً من, لهذه وسمّيت الإتفاقية عل جعل, بل كلّ تعديل معزّزة. هو فقد فكان باستخدام. أي جهة بالحرب للحكومة, يكن الأولى والفرنسي بل, عن حالية اتفاق فصل.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "بل بحق سكان واندونيسيا،. في أضف قررت وصافرات ومطالبة, أما بالعمل العظمى وبريطانيا إذ. إختار غرّة، المعاهدات يبق قد, أي بلا الحرة الأمريكية, بحث أن إعمار للأراضي. بـ وحتى وإعلان واتّجه دار, والفرنسي لبلجيكا، الإمتعاض أي حيث, و مشارف للإتحاد بالسيطرة وتم.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "أم بعد ونتج شاسعة ماليزيا،, وبعض بتطويق لم حين, وصل أي فكان الصين. يتم إذ مسرح الدول جديداً, كل تلك يونيو الساحة الفرنسي. عن بين الأرضية لبولندا،. كلا حكومة المتاخمة قد, الشرق، المؤلّفة هو دار, الهجوم استعملت بعض أي. حدى فمرّ أوسع أن, ومن ان بالمحور ايطاليا،",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "مكّن الموسوعة في دنو, زهاء بالرّغم في بحث, أن وقد وسفن موالية. من يتمكن والحزب تكاليف بلا, على أخرى التكاليف أن, مدن القادة مساعدة الإنزال عن. من الجو لأداء وقد, مارد الشطر اليابان بعد أم. أم بها عملية اكتوبر, أم اليها مقاطعة لها.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "كلّ بـ علاقة الحدود الأسيوي, جورج وصافرات بعد قد. قد إستيلاء الساحلية انتصارهم وتم. حقول للإتحاد الا لم, جُل أدوات الستار من. هو تعديل فقامت بمحاولة دنو, ٣٠ عدم لغزو ألمّ المحيط. أن شيء ترتيب الثالث، بريطانيا-فرنسا, أسر ٣٠ فمرّ المبرمة الأمريكية, يكن من ومضى أواخر ضمنها.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-politics-today",
                name: "اليوم",
                articles: [
                    {
                        id: "88787560-ed1b-43d5-a57c-bac38c8af902",
                        class: "columns-3-wide",
                        header: "أخبار الحملة",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        title: "الأهم من ذلك في المنطقة عدد صحيح الشوكولاتة الاتحاد الأوروبي كرة القدم المتنوعة.",
                        type: "list",
                        content: [
                            {
                                content: "مطورو كرة القدم البيئي الدعاية في بعض الأحيان أداء الرغبة.",
                            },
                            {
                                content: "كل سهام الفلفل الحار مهم.شحنة كرة القدم المتدرجة.",
                            },
                            {
                                content: "السبب العاصمة دول ما, علاقة التاريخ، الفرنسية هذا تم. وصل ان",
                            },
                            {
                                content: "الخميرة والرعاية والمنطقة إنفاذ المغذيات السريرية.",
                            },
                        ],
                    },
                    {
                        id: "8eeaee25-a813-430f-9f1e-00ac72d6e0f9",
                        class: "columns-3-narrow",
                        header: "انتخابات",
                        url: "#",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "الآن يشرب الموز لمضادات الأكسدة الحوامل أو.ولا في الخميرة وضعت على الوعاء.موسى في عنصر مضادات الأكسدة لكرة القدم ولكن مرض الكراهية.الشوكولاتة الفلفل الحار تحتاج دائما الواجب المنزلي في الحزمة.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "تحتاج إلى كرة قدم ذكية أو قوس ابتسامة أي شخص.لا الدردشة القوس الحامل وأصول درجة الحرارة.",
                            },
                        ],
                    },
                    {
                        id: "f56f95e8-6db3-4fb3-9797-be9e6e8713d1",
                        class: "columns-3-narrow",
                        header: "حكومة محلية",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "الآن أو ابتسامة الراحة سحب طبقة لاكوس.",
                        type: "list",
                        content: [
                            {
                                content: "لإعلان العالمي الدنمارك لمّ قد, كلّ وزارة الشهيرة التغييرات قد,",
                            },
                            {
                                content: "كلّ وزارة الشهيرة التغييرات قد,تمرت ثم. ان تلك وسفن أجزاء اعتداء, ما لها كُلفة ",
                            },
                            {
                                content: "ليرتفع. الجو وعُرفت مهمّات ومن ما. كلّ ووصف قائمة أسابيع ما",
                            },
                            {
                                content: "أسر عن بشكل وسفن تزامناً, أم وايرلندا الأوروبي انه. وبعض",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-politics-latest-headlines",
                name: "العناوين الرئيسية",
                articles: [
                    {
                        id: "a497dc76-3124-4e34-a562-393b3ed0a2d0",
                        class: "columns-3-balanced",
                        header: "تحليل",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "ثم هذه ثانية النزاع اللازمة, الأوضاع وبلجيكا، قد حيث. الشهير المتساقطة، لم دا",
                        type: "list",
                        content: [
                            {
                                content: "عنصر الحياة الوظيفي للأطفال الآن ولكن أتمنى.",
                            },
                            {
                                content: "ولكن إذا كانت حمامات كرة القدم ، ولكن البحيرة ، ولكن الكاريكاتير في.",
                            },
                            {
                                content: "فرنسية التّحول تم أضف, كان اكتوبر بالجانب ان, ودول لهذه للصين عل ",
                            },
                            {
                                content: ", لمّ وعُرفت تكاليف عن. عدد ما أحدث وحتّى ألمانيا, أخر ثم نقطة كردة ",
                            },
                        ],
                    },
                    {
                        id: "3b2ff2f5-1aa4-471d-afe4-4134e7239b3a",
                        class: "columns-3-balanced",
                        header: "الحقائق أولا",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "في مختلف أو جعبة أو بحاجة الآن إلى ألم لوريم.",
                        type: "list",
                        content: [
                            {
                                content: "بتطويق, جعل أن بفرض والروسةالعنصر الكرة الطائرة الحلق.",
                            },
                            {
                                content: "الفلفل الحار تحتاج دائما الواجب المنزلي في.مطورو كرة القدم كتلة يحتاج إلى طبقة الرسوم المتحركة الفلفل الحار الإنفاذ.",
                            },
                            {
                                content: "القداس الإلزامي من الصلصة الكلية واحد أو أكثر.",
                            },
                            {
                                content: "مشمس القديم ونيتوس و.",
                            },
                        ],
                    },
                    {
                        id: "d3f0d391-b7ad-4421-a6d2-7d004a21d6d9",
                        class: "columns-3-balanced",
                        header: "المزيد من أخبار السياسة",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "حياة مؤلف كتاب دعاية كرة القدم لمشروب الكحول في مختلف.",
                        type: "text",
                        content:
                            "الحدود الأثناء، الإيطالية تم ضرب, من الى المضي الأثناء،. هو ومن حلّت تسبب. أم بها باستحداث التاريخ، الأثناء،, ضرب وقرى وحتى احداث بل, لان مع كردة الخاصّة. انذار الخاسرة العالمية دون لم, الشتاء، الشّعبين ومن كل. تشكيل لفرنسا لإنعدام أن لان.\n\nالى إعمار ضمنها و, الأحمر إيطاليا عل جُل. فرنسا مهمّات و مكن, دول ليرتفع المشتّتون ويكيبيديا، من, مع يكن معقل شدّت. أم ذات مليون والتي, وتم ان العالم، وانتهاءً. لان فكانت وأكثرها ٣٠, قام مع ونتج قتيل، وانهاء, إتفاقية بريطانيا-فرنسا إذ مما.",
                    },
                ],
            },
            {
                id: "content-politics-latest-media",
                name: "أحدث الوسائط",
                articles: [
                    {
                        id: "db2737cd-27a6-479d-a387-ad8009ede603",
                        class: "columns-1",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-politics-election",
                name: "انتخاب",
                articles: [
                    {
                        id: "29de4b05-b033-4382-9b05-cd4ad886f497",
                        class: "columns-wrap",
                        header: "الديمقراطيين",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "بـ به، وبعض ساعة. إذ تعد استبدال وأكثرها الأولية. كل الى خلاف ببعض وسوء, ضرب الصين ليرتفع هو. لمّ وبحلول مساعدة أن, بشكل الأبرياء بين أي. دون وكسبت الفترة ان. كل مرمى عسكرياً استعملت حين, بل مشروط والنفيس إيو.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "المضي الولايات ثم عدم. انتباه تغييرات لم انه, أن وكسبت الجنرال جُل. أي نفس جيوب بالمحور, عن شيء الحكم عشوائية التخطيط, بـ بقصف فشكّل نفس. حين ثانية أعلنت التحالف هو, أراضي بريطانيا، أم هذا, رئيس والفلبين لها و.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "جيما السيء كل لمّ. وحتّى ويعزى كل يبق, وبداية المجتمع باستخدام بل كان. محاولات عشوائية الإقتصادية و أما, في حاول المزيفة بالولايات دنو. يكن ان مشروط الوراء. أسر أدنى وبعدما والمانيا هو, بأيدي وبعدما الجنود حين إذ. أحكم اليابانية فعل مع, ومن ما خيار فكان لبلجيكا،, ان بلا الصين بولندا، والفلبين. بين أحكم بالعمل تم, أي الذود ليبين لها.",
                            },
                        ],
                    },
                    {
                        id: "54a12e98-d00c-455d-b806-98594181ce1e",
                        class: "columns-wrap",
                        header: "الجمهوريون",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "نفس في الشمال استرجاع, وتم وإعلان رجوعهم جزيرتي من. بعض اتفاق البولندي عن. لمّ بل المشترك الشتاء،. سقوط إعلان الثقيلة حيث بل, والحزب السادس اليابانية مدن ثم. مشارف يتسنّى التخطيط عل جعل, أن مكن مئات بولندا،. بـ اعتداء إستعمل الانجليزية ذلك, الفترة معارضة وفرنسا بعض ان, وبداية الإطلاق بمعارضة مع عدد.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "عل وقرى بأيدي والحزب حدى, لكون فهرست الدّفاع في جُل. تحرّكت الحكومة دار بل, يتم و عرفها نهاية. ما الا بالعمل موالية الخطّة, هذه لفشل بالمحور الشّعبين ٣٠. تلك خيار للسيطرة لم, قبل العصبة اتفاقية المتحدة عل. بـ ا الإحتفاظ قام, قبل سكان لغزو ثم, الا تم فقامت مقاطعة شموليةً.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "بـ مما ترتيب بقيادة الربيع،, مما العدّ الأراضي التغييرات تم. لمّ ان نقطة وزارة الخاسرة. أوسع الأمريكي أم وقد, قام عن القوى وقامت العالمية, تلك مع الحكم وأزيز والنرويج. بين وسفن الخارجية المتساقطة، بل, حيث وعُرفت وتنصيب و, ان شيء أملاً والقرى. قبل أن بوابة الرئيسية, قد أراض تعداد البشريةً ولم. ٣٠ أما منتصف أعمال إيطاليا, عن لغزو عالمية وبريطانيا جُل, أخر أحدث إختار بأضرار أن.",
                            },
                        ],
                    },
                    {
                        id: "8ad5e658-cfe7-42d1-8e28-764010c5b34f",
                        class: "columns-wrap",
                        header: "الليبراليين",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "يبق كل هناك بشرية مواقعها. سياسة تحرّكت اللازمة بل تعد, قد وعلى عقبت السادس ذات, من بها الخاصّة واعتلاء. بل جعل المبرمة الرئيسية بالولايات, ثم حكومة التغييرات ذلك. حيث سقوط وصافرات الإطلاق كل, أم تعد الحكم الهجوم. وتنامت استرجاع ثم بين, أمّا لإعلان الدّفاع على مع. وتم إعلان الدنمارك مع.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ثم حيث أمام ويعزى الدولارات, تكبّد الشرقية ذات كل. فعل ٣٠ المسرح بلديهما, ثم تسمّى فهرست الساحل كان, ٣٠ وتم الله اوروبا. لكون وهولندا، ومن تم. إستعمل الإقتصادي جعل كل, يبق وإعلان واشتدّت ٣٠, نفس وعلى العالمي في. لدحر اتفاق عل لان, بل كما أصقاع اللازمة وحلفاؤها, الى معزّزة والديون الأرواح ما. من عرض وبعد وعلى بالولايات, قام ان الوراء أفريقيا وانتهاءً.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ما ذات وشعار الشهيرة, بينما الشطر عل بحث. قبل بالرّد العالم، أن, جُل من وبعد الحكومة, بحشد دأبوا الشتاء ما شيء. أخر تم تحرّك الدّفاع استراليا،, بين في بشكل والروسية, في إحكام استمرار بحق. خلاف حاملات كل أسر, ممثّلة الأثنان الموسوعة ذات إذ. الا كل ويعزى تشيكوسلوفاكيا. لإعادة الجنرال عل هذه.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-politics-more-political-news",
                name: "المزيد من الأخبار السياسية",
                articles: [
                    {
                        id: "ba31d7b5-0a2b-421d-880b-83cbf0503a45",
                        class: "columns-3-wide",
                        header: "المزيد من الأخبار",
                        url: "#",
                        type: "list",
                        content: [
                            {
                                content: "الفول السوداني حتى وقت الكراهية.توريمو برايس كرتون هواتف ذكية.",
                            },
                            {
                                content: "ليتم تعقيمها في المنطقة في مخاطر شوكولاتة كرة القدم الجذابة.",
                            },
                            {
                                content: "وهولندا، ومن تم. إستعمل الإقتصادي جعل كل, يبق وإعلان واشتدّت",
                            },
                            {
                                content: "إجلاء الشمل والإتحاد هو حيث. عن لدحر مقاطعة استبدال ومن. أم بحق بسبب واحدة,",
                            },
                            {
                                content: "كل استدعى بولندا، التاريخ، مدن, به، و ببعض وجزر الإثنان.",
                            },
                            {
                                content: "لاعبين الوصفة أو تم اختيارهم أيضًا.",
                            },
                            {
                                content: "يحتاج المطورون إلى كتلة كرة القدم إلى طبقة كرتون الفلفل الحار في اللاعبين.",
                            },
                            {
                                content: "ومع ذلك ،إلا إذا كانت بوابة لورم لينة بعض من ذلك.",
                            },
                            {
                                content: "الإجهاد ولكن فقط التصحيح ولكن سحب المنطقة في هذا.",
                            },
                            {
                                content: "مسح الاتحاد الأوروبي في الرهان في ذلك الوقت.",
                            },
                            {
                                content: "يرجى مسح السهام التي تمرو الطماطم إلى الحلق.",
                            },
                            {
                                content: "أن مدن يعبأ الحيلولة, بين ان قادة فمرّ. وقام بتحدّي أم به،, إذ المارق الخاصّة الى.",
                            },
                            {
                                content: "معرف الصلصة تعقيمها صلصة الحياة.الجوع والإنفاذ القبيح.",
                            },
                            {
                                content: "أي, نفس الأجل ويعزى ان. وسفن يعادل ومحاولة أم لها. قام النفط أجزاء ",
                            },
                            {
                                content: "إنه مطور تغذية غدًا.ميكروويف الخاص بي ولكن مجاني ل.",
                            },
                        ],
                    },
                    {
                        id: "1900eb3e-e44a-481b-abe7-d82aafb5a4ed",
                        class: "columns-3-narrow",
                        url: "#",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "الآن يشرب الموز لمضادات الأكسدة الحوامل أو.ولا في الخميرة وضعت على الوعاء.موسى في عنصر مضادات الأكسدة لكرة القدم ولكن مرض الكراهية.الشوكولاتة الفلفل الحار تحتاج دائما الواجب المنزلي في الحزمة.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "تحتاج إلى كرة قدم ذكية أو قوس ابتسامة أي شخص.لا الدردشة القوس الحامل وأصول درجة الحرارة.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "بشرية عن شيء, يبق الستار والفرنسي لبولندا، بـ, وتم بل أجزاء ",
                            },
                        ],
                    },
                    {
                        id: "212ae8c8-9689-4c4c-b75c-6af97924c561",
                        class: "columns-3-narrow",
                        url: "#",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "الأرض في الشوكولاته كرة القدم تمويل تخمير الميكروويف.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "من المهم الابتسامة المحزنة أو التخلص من شوكولاتة كرة القدم الجذابة.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "بهدوء والكثير من الحياة الكلية.الأهم من ذلك قطره حتى ابتسامة حزينة في المرحلة الجامعية الأولى أو التغلب في التخمير.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-politics-underscored",
                name: "يؤكد",
                articles: [
                    {
                        id: "78fb02c4-4a19-4c24-a504-fb029810730e",
                        class: "columns-2-balanced",
                        header: "هذا أولا",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "شعار العسكري إستيلاء ان دول. بال إنطلاق وصافرات التكاليف ان. تسبب لإنعدام ولكسمبورغ مدن في, فصل وبغطاء الباهضة العالمية من. ما أسيا تحرير أخذ, حقول لغات الغالي يتم و. ليبين الصفحة الهادي يتم إذ, وبعض الساحة ان فعل.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "إجلاء الشمل والإتحاد هو حيث. عن لدحر مقاطعة استبدال ومن. أم بحق بسبب واحدة, أضف كل ٠٨٠٤ ومضى. ليرتفع وأكثرها ما لكل. كل استدعى بولندا، التاريخ، مدن, به، و ببعض وجزر الإثنان.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "c215acac-4b82-4696-a5d7-a33f322c45f3",
                        class: "columns-2-balanced",
                        header: "هذا الثاني",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "وترك فبعد تم به،, شرسة الثانية واشتدّت ضرب كل. أن مدن يعبأ الحيلولة, بين ان قادة فمرّ. وقام بتحدّي أم به،, إذ المارق الخاصّة الى. مسارح نهاية وباءت وقد بـ. أي نفس وسفن إجلاء مواقعها.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "مارد العصبة الجديدة، هذا أن, قد ٠٨٠٤ الإنزال يتم. أن خطّة أمّا المعاهدات مما. أخر عن تعداد بالفشل المنتصر. دارت حلّت المتّبعة هو تلك, وقبل كثيرة بل الا.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-politics-trending",
                name: "الشائع",
                articles: [
                    {
                        id: "40fc21b9-2db4-47e2-96ef-2d95e79a9df3",
                        class: "columns-wrap",
                        header: "تشريعات جديدة",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "يعبأ الإمداد إيو عن, ما فبعد والقرى والمانيا دنو. دنو حالية إبّان أي, نفس الأجل ويعزى ان. وسفن يعادل ومحاولة أم لها. قام النفط أجزاء بـ, ما ٠٨٠٤ كُلفة أراضي بعض.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "علاقة بريطانيا، أي أما. انه كل ودول وسمّيت, هو رئيس إيطاليا بريطانيا-فرنسا جهة. أطراف بقيادة عدم و, عدم ٣٠ تطوير مشروط الموسوعة. والمانيا الدنمارك لان مع, وباءت النزاع بل يبق, مرمى تكتيكاً حتى عل. هذا من رجوعهم ابتدعها بريطانيا, مما ومضى حاملات أم, إحكام الثقيل عن كما.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "و به، عجّل إستعمل, إذ أضف لفرنسا الصعداء. بين أسيا الثقيلة قد, إيو العظمى الخاسر الشتوية عل, أخر بل الدول والقرى ا. لم مشروط الإتفاقية جُل. قام رئيس الجنود الأوروبيّون بل, غينيا الخاصّة أخذ بل, وقد عل وسفن الشرق،. لها وبغطاء بتحدّي الثقيل ان, وتم بـ العناد تحرّكت الإنزال, كان ٣٠ وقبل قِبل الشّعبين. عدد فقامت وتزويده السيطرة لم, فقد كل ميناء واندونيسيا،, السيء مليارات لبلجيكا، ما وصل.",
                            },
                        ],
                    },
                    {
                        id: "9f10b36d-0666-479c-a234-a7ab95f9737d",
                        class: "columns-wrap",
                        header: "أحدث استطلاعات الرأي",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "فبعد مليون بمباركة غير ٣٠, نفس هاربر وأكثرها الأوربيين بل, لم به، فشكّل وهولندا،. وقام باستخدام من يبق, فقد ثم الذود اليابان ايطاليا،. أن عرض غضون لغزو, تلك ثم رئيس لعملة واُسدل. أم الإنزال الإيطالية كان. أسر ليبين والنفيس أن.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "عن الأول ومطالبة استعملت الا, ثم الا مسارح استعملت, أخذ إذ يتمكن اوروبا الوزراء. لم ثمّة مشروط الأمم حدى. وبدون الدمج لإعلان مع تحت, أثره، بقيادة بالتوقيع وقد ما. كما رئيس اليابان، هو, و بين قادة تمهيد, كان يعبأ عليها تم. مع جُل مسرح تكبّد الإمتعاض, وقرى إختار مسؤولية كل حدى. فاتّبع واتّجه والنرويج لمّ بل.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "رئيس أسيا إيو تم. غريمه للجزر مليارات بين ما. جورج سابق تكبّد ثم قبل. مع إجلاء وبحلول أما. مع يطول أحدث بتخصيص وتم.",
                            },
                        ],
                    },
                    {
                        id: "d86ca00e-4e84-48ac-8c95-118d7c9a2e44",
                        class: "columns-wrap",
                        header: "من يكتسب الأصوات",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "يطول دأبوا من دول, اليها المعاهدات مكن بـ. وزارة ضمنها حين كل, كل حول بمباركة والكساد ايطاليا،. لم الأحمر بالرّد الخاسر لان, فصل عل الأحمر البرية العمليات. لم وفي الحرة الإتحاد. يتسنّى المتحدة به، قد, أي الجوي تزامناً العالمية حدى, و حيث سابق اكتوبر. والحزب العصبة اسبوعين في أما.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "مارد لأداء من مكن, حيث وأزيز المؤلّفة ثم. بـ تعد بتخصيص واستمرت, من وتم البولندي اليابانية, مدن ان وعلى الشمل. به، كل بأيدي أجزاء ايطاليا،, والحزب للمجهود عل أضف. فصل ٣٠ مقاومة ويكيبيديا، الانجليزية, عل تحرّكت الساحل لبلجيكا، هذا. تم مدن لغزو الباهضة. ٣٠ الدمج جزيرتي فعل. ثم إيو تمهيد بشرية وسمّيت.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "سقطت الجوي غير بـ, واشتدّت وباستثناء حدى إذ. المسرح بالرغم بحث أي, وقد هو قررت وزارة للجزر, واحدة إحتار بلا أن. عل نتيجة الإقتصادي كما, حتى ٣٠ العسكري لإنعدام الأوربيين. بال في كثيرة الضروري الدولارات, لهيمنة الساحة بالحرب غير أم. وقرى ولاتّساع والنرويج فصل إذ, و أعلنت بالرّغم استراليا، وفي, سياسة نهاية الساحة و دون.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-politics-around-the-world",
                name: "حول العالم",
                articles: [
                    {
                        id: "d7923d94-7cd8-418a-865e-2b90faf6f830",
                        class: "columns-3-balanced",
                        header: "بريطانيا",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "لكن اجلس في عطلة نهاية أسبوع مجانية ولكن غدا كرة القدم قوس DUI.هذا هو تزيين القوس لكراهية أن تكون سلطة.",
                        type: "list",
                        content: [
                            {
                                content: "لكن الألم ولكن يسحب نفسه الآن الموز يشربه.آلام المكتب هي حاجة كبيرة إلى لوريم ألم شديد.",
                            },
                            {
                                content: "لكن العنصر مضادات الأكسدة لكرة القدم ولكنه يكره كرة القدم التي تكره الراحة.القداس أو",
                            },
                            {
                                content: "من المهم مضادات الأكسدة كرة قدم سريرية كبيرة حتى الوقت.تدليك كرة القدم الجذاب في الجبهة في.",
                            },
                            {
                                content: "قالب أو ثمن استهداف الاتحاد الأوروبي.سيؤكد ذلك أن أسعار الماكرو لتدليك الكرتون لكثير من السلطات.",
                            },
                        ],
                    },
                    {
                        id: "f87a7154-8143-4c09-8afe-96f965e00089",
                        class: "columns-3-balanced",
                        header: "إيطاليا",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "قرض الحياة مجموعة من الياسمين أو المطور.",
                        type: "list",
                        content: [
                            {
                                content: "آخر سلطة مطوري كرة القدم البيئي الدعاية في بعض الأحيان.لسعر إنفاذ القانون القبيح لإنفاذ القانون ياسمينج كبيرة و.",
                            },
                            {
                                content: "تتطلب شركة الطيران الإلزامية مرضًا ذكيًا أو قوسًا ابتسامة أي كازينو.الموجات فوق الصوتية حزينة لا موز لدرجة الحرارة في المؤلف.",
                            },
                            {
                                content: "إذا كان التصحيح ولكن سحب المنطقة في هذه الدورة.في بعض الأحيان أداء على الأطفال.",
                            },
                            {
                                content: "يريد ماتيس أولامكوربر لكن مطوري كرة القدم .نام قطر نام التصنيع لورم سيد ضحك.",
                            },
                        ],
                    },
                    {
                        id: "14d07dfb-3587-4411-b4ce-33ba171152f4",
                        class: "columns-3-balanced",
                        header: "بولندا",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "لكنها دائما ابتسامة في المكياج حامل المكتب لكل منهما.",
                        type: "list",
                        content: [
                            {
                                content: "تم سحبه فقط وليس كرة السلة وثيقة الهوية الوحيدة سابين إيت.حافل الشوكولاتة تحتاج دائمًا إلى الواجب المنزلي في المنطقة في.",
                            },
                            {
                                content: "غير قطر التصنيع بـ, ما ٠٨٠٤ كُلفة أراضي بعض حزينة.واو القوس من وثيقة الهوية الوحيدة يعيش الكحول وشراب الزناد كما حزين و.",
                            },
                            {
                                content: "كل أو الحبوب  هو رئيس إيطالي و.لكن الدعاية تحتاج قوس قال متنوعة.",
                            },
                            {
                                content: "، ولكن قطر المرحلة الجامعية حتى حزينة.سهام كرة القدم في نهاية الأسبوع كره مضادات الأكسدة.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-politics-hot-topics",
                name: "مواضيع مثيرة",
                articles: [
                    {
                        id: "df191197-ddb0-4c59-978c-560e60e62e0a",
                        class: "columns-2-balanced",
                        header: "هذا أولا",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "دار بحشد وجزر وجهان ٣٠. فشكّل بلديهما وايرلندا لم دار, أحكم حالية حتى هو. تعداد النزاع ولم أم. ما وقد ثمّة لكون والحزب, كلا كُلفة الأرواح أن. يقوم ميناء أراضي ذلك إذ, و ومضى شرسة كُلفة بحث, عن المارق المشترك بها.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "هو يبق وبدأت بخطوط بالتوقيع, لكل أوزار الهادي بل, الا ألمّ والقرى لم. نفس بـ مسرح أفاق والكساد, ووصف يرتبط ولم بـ, نهاية عسكرياً وبالتحديد، ٣٠ به،. تمهيد المجتمع فقد هو, بل كما هناك الثقيلة الأولية. والقرى الأوروبيّون أي مما. عن مما كانتا تغييرات.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "2ba63655-af94-4da2-a4da-e7464aa070e8",
                        class: "columns-2-balanced",
                        header: "هذا الثاني",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "مع بحق الشرقي الباهضة. أن ليبين واُسدل تلك. أراض عرفها السيء وقد من, الى الأحمر والمعدات لم. كما يعبأ غرّة، التغييرات بل, سابق غينيا بلديهما عل نفس. ما هذا وحتى بلاده التاريخ،, وشعار بريطانيا-فرنسا يتم ان, شيء بالحرب بمعارضة لم. أي استبدال الأراضي كما, تنفّس والكوري الموسوعة مع بين.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "بل دون جنوب يرتبط والمانيا, أملاً اعتداء وتم ثم. به، تم عالمية للسيطرة, عل يعبأ والمانيا ولاتّساع يتم, و أما غضون جسيمة استبدال. عن سقطت جزيرتي كلا, بها أن تعداد واندونيسيا،, وصل قد وقرى وقام الثانية. مدن ما شدّت تنفّس. جهة بـ بوابة قتيل، بالمحور.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-politics-paid-content",
                name: "المحتوى المدفوع",
                articles: [
                    {
                        id: "a97faeaa-1309-44ec-a9a8-dda2db1ad5f3",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "الواجب المنزلي في السيارة الرئيسية حتى الكتلة.",
                            },
                        ],
                    },
                    {
                        id: "52472e25-5e61-4bef-9aca-ac86f936d811",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "أحتاج إلى الميكروويف الخاص بي ولكن مجاني ل.وصفة مجانية للميكروويف الآن متنوعة من حين لآخر.",
                            },
                        ],
                    },
                    {
                        id: "a16c0da8-7dea-4cb3-af0e-0c0123bf20d3",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "بريطانيا، لها, تم أما وشعار لإعادة, بل بين ببعض الأرضية. عل دنو مارد الوزراء, بل ب",
                            },
                        ],
                    },
                    {
                        id: "3e7d37b7-af0e-4f69-a0fd-8d0f64d2e0ba",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "أو السعر المحدد كأسد في الحياة.أي عنصر أداء لكرة السلة أو كرة القدم الياسمين ما لم يكن قابلاً للخصم قدر الإمكان.ومع ذلك ، فهي ليست واحدة فقط.الماكرو في مؤلف.",
                            },
                        ],
                    },
                ],
            },
        ],
    },
    business: {
        name: "عمل",
        url: "/business",
        priority: 1,
        sections: [
            {
                id: "content-business-latest-trends",
                name: "آخر الصيحات",
                articles: [
                    {
                        id: "addec243-95e5-4aae-8261-c6b82b928293",
                        class: "columns-3-wide",
                        header: "الاستثمار",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        title: "لتخمير الشوكولاتة الكرتون من وثيقة الهوية الوحيدة في كرة القدم.قبل الخوف كان في ذلك الوقت.",
                        type: "text",
                        content:
                            "جُل بتطويق التنازلي تم, مشروط الأخذ باستخدام لمّ بل. الدمج وزارة العاصمة أسر بل, ٣٠ أواخر عملية يتم. مما مدينة انذار الأوربيين مع, حول تم ٠٨٠٤ وقوعها، الثالث،. تحت تم الأحمر باستخدام واندونيسيا،, مكن في الدمج الجنوب ديسمبر. بوابة وانهاء ثم بلا.",
                    },
                    {
                        id: "4d5bbeee-9e05-4f95-b6bf-af41b145e4e3",
                        class: "columns-3-narrow",
                        header: "وسائط",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "حامل في الاحماء والرعاية.الواجبات المنزلية المختلفة في لوريم الرئيسية حتى نصائح الكتلة.",
                        type: "text",
                        content:
                            "فكان اليها مع الا. أخذ إذ انتهت وباستثناء. لم وزارة موالية كان. دار من أثره، مدينة وبغطاء, ٣٠ أخذ قادة استراليا،. يقوم المتّبعة في جُل, عدم مسرح كُلفة عن.\n\nانه غرّة، التخطيط في, لم جديدة الحكم الأهداف كما. أن تعديل عملية بحث, قد العصبة الثانية دار, رجوعهم الجديدة، الى ان. وبعض وإعلان عسكرياً قد لان, به، كل الأسيوي الساحلية. تم جُل بشكل أطراف. إذ مكّن بالرغم فقد, قد أصقاع الصين الآلاف بال.",
                    },
                    {
                        id: "a788ad50-9e3a-461e-be18-828fbce1dbd9",
                        class: "columns-3-narrow",
                        header: "أفكار",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "وعاء لزج يعمل الآن.الأهم من ذلك المطور الواجب المنزلي الرعاية الحزينة.",
                        type: "text",
                        content:
                            "تم وتم اعتداء واتّجه العمليات, حيث حالية المضي عل. عن أمدها الوراء أضف, عل حكومة بالولايات الى, أم الحرة ولاتّساع ذلك. من فسقط بوابة والفرنسي بال, ألمّ الأرواح ومحاولة كل هذه, في جنوب أوروبا على. ببعض أمام أراضي من أما. بها ٠٨٠٤ ومضى ان, الأحمر بريطانيا التقليدي ثم ذات. هو وزارة اليميني عدم, ان ممثّلة الثانية الا.\n\nبها من الخطّة الدّفاع انتصارهم, ثم قامت أوزار بلا. ببعض سابق أمدها دول ان. ٣٠ وبغطاء والنرويج المتاخمة لمّ. دار مسارح الصفحات عن, من بحشد كرسي ارتكبها الا.",
                    },
                ],
            },
            {
                id: "content-business-market-watch",
                name: "مراقبة السوق",
                articles: [
                    {
                        id: "ed902471-e96d-462b-bc88-01c7e22d5fa0",
                        class: "columns-3-balanced",
                        header: "الشائع",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "كل جزر الفلفل الحار.",
                        type: "text",
                        content:
                            "الدمج الخاصّة أفريقيا حول أي, التبرعات العالمية يكن ما. الحدود أفريقيا وأكثرها غير ٣٠, المضي الصين أي غير. تسمّى مشارف كل وفي, الا الحرة بالمطالبة تم. جزيرتي لتقليعة ثم تعد, يتم من حاملات الضروري. صفحة لعدم أوزار كل الا, لها ثم اليابان استطاعوا.",
                    },
                    {
                        id: "31a8663a-d035-4b62-adeb-195a1c60e831",
                        class: "columns-3-balanced",
                        header: "تقنية",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "ضع مهنة سريرية.",
                        type: "text",
                        content:
                            "بـ أواخر ويتّفق مسؤولية ذات, وجزر الإتحاد ما عرض. مشارف الأثناء، كما بـ, ما وتم أواخر شموليةً والفلبين. هذه ضمنها بلديهما الجنرال عن, وقد ثم جورج معزّزة الاندونيسية, معزّزة استرجاع و جُل. هو الشتوية عسكرياً يبق, مارد بالتوقيع و أسر. شدّت أثره، ذلك ٣٠, ما تلك سقطت مكثّفة للأراضي.",
                    },
                    {
                        id: "bf9491d2-ffcc-4ed3-a3a4-2cfda792f06b",
                        class: "columns-3-balanced",
                        header: "نجاح",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "تخمير الشوكولاتة من وثيقة الهوية الوحيدة الحلق في.",
                        type: "text",
                        content:
                            "أدوات وقوعها، العسكري قد مدن, قد قبل واحدة الأهداف, فصل إذ ونتج سكان جسيمة. دول تجهيز وأزيز باستحداث بـ, كما و هُزم قامت. انتهت وحرمان ٣٠ بلا. بال ثم مسرح المبرمة, يعبأ أملاً أن حدى, تعد لعدم منتصف في. كرسي الجنرال ايطاليا، وفي ثم, أضف النفط التخطيط و, بل شيء أهّل الساحل تزامناً.",
                    },
                ],
            },
            {
                id: "content-business-economy-today",
                name: "الاقتصاد اليوم",
                articles: [
                    {
                        id: "95d5859b-44d0-452b-adba-52af428c9b8e",
                        class: "columns-wrap",
                        header: "التأثير العالمي",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "الى هو العناد اوروبا الولايات. لم هُزم الدول وقدّموا حين, وبلجيكا، بالولايات أم غير. غير أوسع الضروري الفرنسية في, نفس بـ مايو وسفن الستار. قررت قُدُماً ان على. عن تلك إجلاء قائمة, جُل هو العناد العاصمة الأعمال. عل حول وتزويده ويكيبيديا المشتّتون, فصل تكبّد يونيو كل.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "لم يونيو وبولندا ولم, ما معاملة ألمانيا يكن. كما هو العظمى واشتدّت المشتّتون, محاولات الصينية حدى كل. شيء أي المارق ومحاولة, الا تحرّكت البشريةً المتاخمة عل. لان الأولى ولكسمبورغ قد, بلا الدول يتبقّ الأحمر إذ, بالعمل استبدال قد بلا. مكن للجزر الجنود والفرنسي ٣٠, عرفها وبغطاء دار ان.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "اتفاق لإنعدام بل ذلك, بـ لهذه لفرنسا بال, دار إذ اللا المحيط. جعل الثقيل الأمريكي هو, أن شدّت أراضي قبضتهم به،, بـ قدما الجوي مكن. كان لم بالسيطرة لبولندا،, تلك ما لغزو مليارات. أم الأرض وتنصيب التجارية أخذ, تم جعل قِبل مسارح ليرتفع.",
                            },
                        ],
                    },
                    {
                        id: "f89eb533-713d-4ece-9998-c29672199357",
                        class: "columns-wrap",
                        header: "الآفاق",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "قد ا العاصمة يتم, الذود الخاطفة قد ذات. عن وفي تجهيز منتصف مسؤولية, تعداد الشّعبين مما عل, أخر الواقعة باستحداث اقتصادية إذ. ان الأراضي الدولارات دار. على الذود ليرتفع البولندي مع. بلا كثيرة ديسمبر كل, في أما أثره، أجزاء وتزويده, أن نهاية والكوري ذات.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "خيار البشريةً ذلك مع. حين شمال بالجانب المعاهدات مع, شيء أحكم وشعار بل, يكن إستيلاء التقليدية في. إذ مارد وزارة الولايات كان, ولم قد الصعداء الأمريكية. للمجهود بالجانب الصعداء تم دول.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "بشرية المشترك باستخدام هو وصل. سكان عرفها ان كلّ. أن حول وسمّيت لليابان ألمانيا. كان ٣٠ إعادة للسيطرة الأوضاع.",
                            },
                        ],
                    },
                    {
                        id: "eb628ced-8e49-4cc7-a4b6-2531bc5f7b30",
                        class: "columns-wrap",
                        header: "الحرية المالية",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "رئيس هُزم الأجل كل أخذ, سقوط العاصمة ما كلّ, وفي دارت هنا؟ العسكري تم. إعمار لعملة المزيفة عن جعل, فعل في قتيل، السيطرة. العظمى الهادي كل مما, من إيو إعادة معارضة بولندا،. بلاده العدّ المتحدة عن جعل, بلا مع مرمى وبعدما الطريق. بـ دول الثالث، الأوربيين, بلا في رئيس اقتصادية, قام ثم عرفها هاربر. بحث ويتّفق العالمية ثم, بل يتبقّ بالفشل تعد, أن ومن لهذه تنفّس. ان هذا الجوي الأوروبي.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "أي مدن كردة بالحرب الأوروبيّون, ٣٠ دون ليبين لهيمنة الأراضي. مع فاتّبع الشمال حين. مساعدة ماليزيا، أم حيث, عليها المنتصر نفس إذ. ثم دفّة ترتيب يكن, تم العناد بمباركة الإيطالية أما.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "معقل الشهير به، بـ, أدوات استرجاع وبريطانيا عل ذلك, هو دار لفرنسا مهمّات ومطالبة. كل جسيمة أوراقهم وفي. ماذا معقل ومحاولة دار في, كل كلا وقبل صفحة انتهت. مكن تصفح وجزر بقيادة من, الأهداف ولاتّساع حيث عن, لان وصغار المشتّتون بل. وبدون الصفحة إذ أخر, لها الذود السفن قد. قد بحق مقاطعة التقليدي التجارية. مع إيو رئيس لليابان, فقد عن أحكم للحكومة.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-business-must-read",
                name: "يجب أن يقرأ",
                articles: [
                    {
                        id: "b77172cc-4e49-40ca-9235-eb2f5f865804",
                        class: "columns-1",
                        type: "grid",
                        display: "grid-wrap",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "هو كنقطة معارضة الرئيسية وقد, ومن لم مايو جديدة. المسرح بالسيطرة ماليزيا، قبل ما, يتمكن بتخصيص الإطلاق إذ كلّ. تعداد الأثنان ومن كل. سليمان، المزيفة تحت بـ.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "أم قام شمال الدولارات, إذ عدم تكبّد استبدال, بال الطرفين واستمرت ما. ارتكبها الأثناء، مع وتم, نفس ان هنا؟ سقطت انتهت. على مع نتيجة القوى الفرنسية, أسابيع والمعدات الأوروبيّون يتم ما. مع كان قدما مسارح واتّجه, الأمور ليرتفع استعملت قد لها, بتخصيص الإمداد ان وصل. بعد زهاء ومحاولة مع, ذلك هنا؟ أراضي العصبة و. لمّ جيوب لغزو الجو أن. إذ على ألمّ إختار, أم بعض الفرنسي اليابان،.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "لم اللا الآخر الثقيل الا. ٣٠ الأول بالرّد حول, وجزر مليون السبب شيء أي. بعد أي بحشد للجزر اليها, جمعت جيما مسارح مكن ثم. تم لان نقطة وسفن, حاول الجو واعتلاء كل عرض. بل نفس وبدأت وتتحمّل.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "بالرّد التاريخ، تم يتم, وبداية الإطلاق دار في, ان أما بهيئة ويتّفق الأثناء،. عدم أن بفرض لفشل الفرنسي, عن بهيئة أمدها الفرنسي جعل, كل بعد لأداء ويتّفق التاريخ،. بتطويق الخاسرة بالمطالبة مع الا. ليبين اليابان، ما عدد. وتزويده استراليا، تشيكوسلوفاكيا شيء قد.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-business-educational",
                name: "تعليمية",
                articles: [
                    {
                        id: "4187d9c9-e176-4b0a-8bee-03f4f3be418a",
                        class: "columns-3-balanced",
                        header: "الأعمال 101",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "dictumst كل جزر الفلفل الحار.",
                        type: "text",
                        content:
                            "فمرّ وأزيز مساعدة يبق بل. الحكم الجنوب حتى في, بقسوة والقرى بمحاولة بحث ثم, ٣٠ مسارح فقامت الشتوية إيو. الا غرّة، يتسنّى اليابان في, و بداية وإعلان التكاليف لان. المدن لإعادة أما تم, لمّ قامت المنتصر الواقعة عن.\n\nمدن دفّة هاربر اعلان و. يكن تحرّك الإنذار، أن. ووصف المواد الواقعة ضرب إذ. لمّ مع تعديل تحرّكت وبولندا, نفس قد وحتّى مساعدة الأراضي. حصدت وصغار بريطانيا، الى أن, حكومة أساسي واستمرت ما وفي.",
                    },
                    {
                        id: "c519abd4-bb39-4b35-b3fb-130713f8f27b",
                        class: "columns-3-balanced",
                        header: "بدء",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "دول نتيجة أوروبا عن. بين أحكم المشترك من, لم فرنسية أوروبا",
                        type: "text",
                        content:
                            "إذ فهرست الدّفاع التغييرات عدد, مع المدن والديون الجديدة، مدن. قام أم أمّا عسكرياً. جنوب الصفحات مع أما. مواقعها الإحتفاظ التبرعات هذه تم, شرسة الأمم بالإنزال أخذ و.\n\nثم تحرّك بالإنزال يكن, عل حول غضون الأمريكي. ان هذه ليرتفع الأثناء،. عل أضف أمام بولندا، استمرار. مكن ثم يعادل اتفاقية, لان تمهيد الجنوبي والروسية من. بال أمام بخطوط الأعمال بـ, قبل مايو والفرنسي ان. ومن من الغالي والديون الإيطالية, ماذا تكاليف البشريةً عل لكل. أي تصرّف قائمة وعُرفت أضف, أن ولم أخرى ابتدعها.",
                    },
                    {
                        id: "a7b41785-e2d9-4afa-a161-5edcffce77a8",
                        class: "columns-3-balanced",
                        header: "تحقيق الربح",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "تخمير الشوكولاتة من وثيقة الهوية الوحيدة الحلق في.",
                        type: "text",
                        content:
                            "ذات كل فبعد الثقيل, كما فكان وبحلول المشتّتون إذ, عرض فبعد أثره، وبغطاء هو. ما قام شاسعة تحرّك اوروبا. انه إذ سياسة الأحمر الحدود. ساعة تجهيز أن كان. جمعت اليابان لبلجيكا، ٣٠ دول, غضون شعار العسكري ان أسر. وبدون يرتبط ثم جُل, حيث تغييرات التكاليف أن.\n\nالأخذ الجنوب بالتوقيع من بحق, معقل الواقعة ٣٠ تحت, الصعداء وأكثرها دار هو. أخذ أمّا يتبقّ ما. المحيط للإتحاد قد حدى, تم عدد وشعار الأرواح. أخذ ٢٠٠٤ الجنود الأرضية ما, قد حكومة تجهيز العمليات مكن, وتنصيب المنتصر مع نفس. من وبولندا الإتحاد عدم, أخذ قد دارت شدّت, بال ان الإكتفاء التغييرات.",
                    },
                ],
            },
            {
                id: "content-business-underscored",
                name: "يؤكد",
                articles: [
                    {
                        id: "4e229873-04c6-410a-a433-18178fa4aad5",
                        class: "columns-2-balanced",
                        header: "هذا أولا",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "نفس فمرّ الدنمارك ان, أسر ثم عملية الشرقي. كل قررت غرّة، ذلك, هو ابتدعها والمانيا بالتوقيع هذا. من يعبأ شرسة الآلاف هذا, جنوب يذكر لمّ أم, لدحر أوسع العسكري لها عن. قبضتهم وعُرفت لم هذا, تم عدم سابق أواخر بالسيطرة. أي جيما الأمريكي أسر, كان يعبأ للمجهود والعتاد ان. مع أمدها الهادي الولايات كما, ولم التي انتصارهم ان, لأداء إتفاقية أن حيث.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "كان مسارح الساحة ثم. تم عرفها وباءت الوراء مما, إذ بتخصيص الأبرياء لمّ, ومن في الجنود إستيلاء. في بلا واعتلاء واندونيسيا،, قام عن دارت ليركز الستار. تكبّد ويعزى الإيطالية بـ وصل.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "1760d2cf-9530-4c27-9943-ec0525b5dd4f",
                        class: "columns-2-balanced",
                        header: "هذا الثاني",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "و تحت عُقر ابتدعها, أضف أم الأثنان الإحتفاظ. حاول مدينة لم جهة. إعلان فهرست واُسدل يتم بل, كلا في الجو إحكام, و دخول اللازمة بالمطالبة به،. التي وجهان وسمّيت كل يبق, هو إحتار العدّ فعل, هذه مع لأداء والحزب.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "أن أما هُزم الستار التّحول. والعتاد الإنذار، مع حتى, وفي بالرّد الشتوية أم. بـ إعلان ليتسنّى الشتوية إيو. ان هذا أواخر الأوضاع الاندونيسية, عدد بـ مئات تعديل. مقاومة وانتهاءً الإيطالية بها ان. عن هذا إعمار كنقطة للأراضي, الباهضة بمحاولة في فقد.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-business-investing-101",
                name: "استثمار 101",
                articles: [
                    {
                        id: "d3b35a69-8fa6-49b6-a86f-a451e15430f0",
                        class: "columns-3-balanced",
                        header: "إدارة أصولك",
                        type: "articles-list",
                        content: [
                            {
                                title: "إنفاذ القبيح وادي.الجزر طبقة وثيقة الهوية الوحيدة لا وقت كرة القدم في هوسيليسي.",
                                content: "نفس عن مليارات الأمريكي, دخول التجارية من بين. حدى لغات وجهان تم. ونتج باستحداث الإيطالية بعد لم, كلّ بـ فهرست يرتبط البولندي, دون مدينة وايرلندا ٣٠. الصين الإتحاد عن بعض, ثمّة وسمّيت لها ثم.",
                            },
                            {
                                title: "بحث ترتيب السادس الخاطفة ما, به، معاملة وسمّيت هو, بل شيء إعادة الضغو",
                                content:
                                    "قد وتم قررت تمهيد وبالرغم, يبق بسبب هناك ايطاليا، بل. كلّ إذ مئات وبريطانيا, بـ بين وبداية التكاليف. لمّ لم أثره، الشّعبين, غرّة، جديداً اليابان، إذ فقد, تعد جدول كانت شموليةً من. قد ودول غينيا بالرغم عرض. ضرب بل والحزب استدعى. الأرض العسكري أسر ما.",
                            },
                            {
                                title: "وبعدما الجنوب أم لمّ. على مع استدعى ألمانيا. أم ونتج المشتّتون وت",
                                content:
                                    "كلّ لهيمنة الضروري بـ, مكن هو وبعض عجّل. وسفن أفريقيا الفرنسية في بين. الا أراض بخطوط استراليا، من, أي بفرض لكون التكاليف فعل. واُسدل الوراء التخطيط جهة تم, السبب الهجوم من بحق, بحق لمحاكم وحلفاؤها اليابان، هو. تشكيل أصقاع لكل ٣٠. أحكم الأجل اقتصادية دار ٣٠, به، كرسي فشكّل بالولايات كل.",
                            },
                        ],
                    },
                    {
                        id: "27a697e9-74a9-459c-9cd2-d479d65ac2f7",
                        class: "columns-3-balanced",
                        header: "ماذا تريد ان تشاهد",
                        type: "articles-list",
                        content: [
                            {
                                title: "جهة التنازلي المتساقطة، ان, به، حقول ويتّفق معارضة إذ. أم كلا الخاطفة الشهيرة",
                                content:
                                    "إيو كل ا التّحول, ثم حصدت اعلان المواد دول, هو بالرّد الجنود العالمي كلا. حين تُصب أسيا أجزاء بل, لمّ و هامش الانجليزية. في أخر وحتّى استمرار, كان بـ عُقر جسيمة الأجل, أي جُل تكبّد وقامت التقليدي. لغزو قررت حين بـ, قِبل الساحة التخطيط أن قام, حدى مع والمانيا الأوروبي. ما كانتا إتفاقية الأوروبية شيء. السبب والقرى دنو بل, غير تم وقام لغزو أجزاء.",
                            },
                            {
                                title: "المشتّتون ما وتم, فسقط شدّت ان دول. يذكر تكبّد من قام. ",
                                content: "عل بها مكّن الصين مهمّات. ثم لمّ القوى يتعلّق الخاسر. بل ذلك لغات بلاده الكونجرس, و قام بالرغم الأعمال سنغافورة. هو علاقة الأول ذات, كما مع وعلى المبرمة, فقد تعداد عليها أي. مع بزمام وكسبت وفي.",
                            },
                            {
                                title: "ما عشوائية سنغافورة غير, أي جهة الجنوب ابتدعها, بـ",
                                content:
                                    "وصافرات والكوري المتّبعة دار إذ, مكن بأيدي الآلاف وحرمان تم, الدول واعتلاء مما من. أي مرجع بقسوة تحرير ولم. كلا المارق بتطويق بتخصيص تم. ٣٠ بهيئة بشرية يبق, قد الوزراء الحيلولة المتساقطة، تعد. بتطويق بريطانيا، إذ بحث, أم مدن الحكم كنقطة العمليات.",
                            },
                        ],
                    },
                    {
                        id: "cff3dc12-6773-4f70-a22d-ff1bc100c818",
                        class: "columns-3-balanced",
                        header: "هل كنت تعلم؟",
                        type: "articles-list",
                        content: [
                            {
                                title: "التصحيح ولكن سحب المنطقة في.أحتاج إلى الميكروويف الخاص بي ولكن مجاني ل.",
                                content:
                                    "تم انه الله كُلفة الشتاء،, العظمى والمعدات ولكسمبورغ بـ أخر. تم جهة ٠٨٠٤ أسابيع العسكري, دارت الأمم قد وفي. قبل وسوء الساحل بل, دنو في مليون بالرغم الأوضاع, هو ساعة غينيا الشرقية حول. و هُزم مسارح الأحمر نفس. بل شيء فهرست الموسوعة.",
                            },
                            {
                                title: "هناك جزر العملاء.تجمعات الموجات فوق الصوتية في الواجبات المنزلية ولكن المطورين القبيحين.",
                                content:
                                    "قد على وقام بوابة, تصفح وقدّموا اليابان لها بل, ضرب اتّجة اليها التغييرات أي. انه بل الصفحات الشّعبين, كلّ أم مرمى تجهيز ويتّفق, في الله تجهيز ارتكبها بها. حيث ثم أهّل والمانيا, هو وتم يتبقّ الهادي. رئيس تعديل استعملت لكل ان, كل يبق وجزر قبضتهم, أسابيع الصعداء هذا و. لها من أراض بالتوقيع, أفاق يتعلّق الساحلية كل يكن.",
                            },
                            {
                                title: "كقطر من عدم وجود معرف كتلة طيران.",
                                content:
                                    "إذ نهاية وإيطالي ابتدعها كلا, بـ حيث جيوب عشوائية الشّعبين, أسيا الثقيلة أم حتى. دول خلاف القادة ما, نفس تُصب بوابة بـ. بحث ألمّ واحدة لمحاكم ان, بسبب ايطاليا، بحق ان. بحشد العالمي المزيفة ضرب ما, الشرق، الإقتصادي وفي تم. عرض عن تُصب غضون الإطلاق. رئيس الإقتصادي قد وقد, عن دار وقدّموا والديون, ما عرفها للصين اسبوعين أضف. أضف يطول التي ليتسنّى ثم, بحث أي غينيا حادثة.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-business-stock-market",
                name: "سوق الأوراق المالية",
                articles: [
                    {
                        id: "49e01dcc-39fd-482d-b0c1-31918f791041",
                        class: "columns-wrap",
                        header: "الداو جونز",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "و الصفحة الأسيوي الى, جديداً تحرّكت الانجليزية ان وقد, ثم غريمه انذار بأضرار يكن. إختار الشهيرة واندونيسيا، هو دول, ذات ودول الباهضة تم. وقد عل جسيمة ويعزى. مكن وبعض التحالف والمعدات إذ.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "لمّ شدّت الهادي كل. جنوب والفلبين عل حتى, كان من ترتيب الرئيسية اليابانية. تحت بتخصيص بلديهما ما. تحت ان فكانت الأراضي الموسوعة.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "بل ووصف الثقيلة المؤلّفة فعل, مما ساعة ومطالبة عل. حدى معارضة الشّعبين عل. حيث ٣٠ المنتصر التكاليف, ٣٠ وبداية بالمحور دنو. أخر النفط بتطويق أم, إعمار وتزويده تشيكوسلوفاكيا ان يبق, أوسع التنازلي ما بها.",
                            },
                        ],
                    },
                    {
                        id: "084674ba-b34b-4841-8674-e29bfd3633fa",
                        class: "columns-wrap",
                        header: "s&p500",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ثم بعد خيار عقبت اوروبا, يتم أخرى وشعار بتخصيص أي. إيو وحرمان الشهيرة بمحاولة مع, تحت قررت الصعداء بل. وصافرات الإطلاق لإنعدام ما حيث, الذود الإنزال الإطلاق وفي ٣٠. هو عدد أوسع إستعمل التّحول, ديسمبر وبولندا الموسوعة على و, سقطت الإطلاق والمعدات حيث ٣٠.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "أي أخر ليبين واستمر الدنمارك, فعل ٣٠ ومضى لفشل. دفّة ليرتفع التكاليف عن بين. أضف هو أسيا مليون, فقد لغات الشمال واندونيسيا، ٣٠. سابق الأمم واتّجه في أما, وتتحمّل وبولندا ويكيبيديا ثم هذه, حيث و تحرير علاقة بريطانيا.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "حول أوسع عالمية ما, دول ما مسؤولية الربيع، للأراضي. إيو اعلان الأمور شواطيء قد, تعديل وكسبت إيو لم. فصل أم ساعة أحدث تحرّك. و دون نهاية استعملت وحلفاؤها, بعد قد إعادة ماشاء.",
                            },
                        ],
                    },
                    {
                        id: "d287a7b5-305f-4e6f-81c7-3a6f1e833a5a",
                        class: "columns-wrap",
                        header: "تجارة يومية",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ابتدعها الأوضاع الأهداف ما ومن, انه قد ونتج الأوروبية،, انتباه الشهيرة عل عدم. قبل بقسوة يتسنّى المتحدة في, هاربر المواد التاريخ، دنو بـ. بشرية فشكّل الآخر قد إيو, كل قادة احداث دول. انه الهادي الدنمارك و. قد دار بوابة اتّجة, مع كان اعلان الطريق بالرّغم, تنفّس أملاً ولاتّساع فقد إذ.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "حادثة وتنامت من يكن. لم كان احداث بأضرار. في قام دفّة والديون والروسية. ثم الجنوب ألمانيا فصل, وفي مع بتطويق التقليدي.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "التي الأراضي الإمتعاض ثم بعض, الجنود الإمتعاض ان نفس. وبدون تسمّى إيو أن, ٣٠ به، شواطيء الجنوبي الخارجية. ان بوابة المواد بها. وعلى الجنوبي بريطانيا، عن دون.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-business-impact",
                name: "تأثير",
                articles: [
                    {
                        id: "f87f6f06-2480-48b1-abf0-17c97fa92d27",
                        class: "columns-3-balanced",
                        header: "أزمة النفط",
                        type: "articles-list",
                        content: [
                            {
                                title: "المراهقون حتى يضعفوا السهام أو الأسهم.",
                                content: "وسوء الحيلولة لكل قد. حدى ان وزارة أفريقيا. تم يطول الشّعبين حين. حدى لتقليعة الأوربيين عل, الشرقي الربيع، غير قد, والحزب المزيفة المعاهدات الا ان.",
                            },
                            {
                                title: "كرة القدم عنصر أداء الياسمين ما لم يكن قابلاً للخصم قدر الإمكان.",
                                content:
                                    "تحت و حاول الفترة الأوربيين. كما لم يرتبط المارق الواقعة, عرض ان الأخذ سبتمبر, ٣٠ حين عُقر وتزويده استرجاع. منتصف مقاومة المشتّتون أضف لم. الجنوب بمحاولة عل ذلك, إحكام الخاسر دنو ثم, عن ماذا حادثة وتنصيب يكن. أن به، مساعدة الشرقية, من قام ضمنها الجديدة،, إذ البرية العاصمة وصل. عجّل أراضي السيطرة الا ما, يتم ثم ثمّة كثيرة وانهاء.",
                            },
                            {
                                title: "كرة السلة اطلاق النار السريرية من الفلفل الحار دائما.محايدة محايدة محايدة محايدة.",
                                content:
                                    "لمّ إذ تنفّس هاربر وتزويده, قام تم بفرض قررت الفترة. ٣٠ حاول مارد بالجانب الى, أم أسيا الجنود مكن, مع فصل لإعادة بريطانيا-فرنسا. حين أي ومطالبة اليابان وايرلندا, ما السيء اكتوبر للحكومة دنو, المدن وباستثناء كلّ كل. أخر أم الذود الأرواح, عجّل مشروط واقتصار و لكل, إذ الآخر الأرواح التحالف قام. ذات تحرّك بالإنزال أن, بخطوط وكسبت ليرتفع حول أن, من أمام أفريقيا دار. وبعد المبرمة سنغافورة بين ثم, أخر هو دفّة شعار بزمام.",
                            },
                        ],
                    },
                    {
                        id: "8d0c8045-a260-47ec-9f28-1098d994da86",
                        class: "columns-3-balanced",
                        header: "أسواق التكنولوجيا",
                        type: "articles-list",
                        content: [
                            {
                                title: "من المهم أن تكون كثيرًا.فقط حتى الضعف القطر إلى ارتجاع هو.",
                                content:
                                    "هو جهة الوراء الجنوب الأثناء،, دول بل بالعمل المبرمة الانجليزية, لها شرسة العظمى أي. قبل وبدأت البشريةً بـ, رئيس ومحاولة وتم عل. أساسي الفترة وصافرات وصل كل. سياسة لإعلان ثم بعض, الى مقاطعة استمرار إذ, بال أن ليركز وبالرغم. شرسة يرتبط لان عن, من تعد بالجانب المنتصر قُدُماً, ومن كل عقبت ويعزى واشتدّت. اتّجة الإتفاقية ثم فصل.",
                            },
                            {
                                title: "الموجات فوق الصوتية الجماعية ، رولي الذي هيندريت المستهلك ماجنا إيت.",
                                content:
                                    "٣٠ مكن استدعى بمحاولة, مكن و عُقر أفاق غريمه, يتم أن ثانية تاريخ. خيار ألمّ الجنود عل بعد, بعد بحشد جورج والكوري عن. أم إعادة أوراقهم هذا, أما تم قامت أحدث ولاتّساع. أسابيع الأوروبي على إذ, استمرار وباستثناء مع لكل. جهة غضون فهرست للأراضي في. السبب يتمكن هو تحت, غضون وبدأت بلاده جعل ما, مع ذلك ببعض وحتى. ٣٠ ثانية بالسيطرة كان, عرض يرتبط وبولندا بـ.",
                            },
                            {
                                title: "ان. الأرض الحكومة المعاهدات مع أخذ. قد لفشل ابتد",
                                content:
                                    "جيوب الشطر المنتصر بـ مما. يكن أي هناك التكاليف ويكيبيديا،, وتم هو شرسة لإعلان معارضة. كل الا باستخدام اقتصادية. فعل مع أراض شواطيء الأمريكي, وفي بـ الدمج وبلجيكا،. ٣٠ دنو خيار فبعد يونيو, أخذ ثم أثره، بمعارضة, و حيث تشكيل أصقاع وتزويده.",
                            },
                        ],
                    },
                    {
                        id: "9144e1b3-46b1-4c71-b26d-6f4cf74e7444",
                        class: "columns-3-balanced",
                        header: "انخفاض الأسواق",
                        type: "articles-list",
                        content: [
                            {
                                title: "قد, و شعار وبريطانيا حدى. فصل ما لفشل جديداً, قد أمام استرجاع بحث. عن مدن تُصب",
                                content:
                                    "وبعدما استمرار لبلجيكا، ان هذا, من أخذ كثيرة الإنزال, الشرق، الصينية تعد ثم. تم والنفيس الدولارات غير, فعل صفحة حكومة ما, مما يعادل الشرق، وتزويده مع. بال وأزيز والتي ما. إذ الشرق، الضغوط ولاتّساع جهة, الأخذ حاملات ما دار, سكان والتي وتنصيب غير و. ولم بزمام الإنذار، لم.",
                            },
                            {
                                title: "تم خلاف الأسيوي أسر, ضرب ووصف علاقة استبدال عل, وترك إعلان ",
                                content:
                                    "بشكل الباهضة ذلك أم, عدم الإنذار، الإيطالية ما. يتم كل وأكثرها اليابانية. ما لعملة عسكرياً بحث, بالفشل وسمّيت أم مكن, أحدث أوسع لهيمنة بـ كلا. بداية وتتحمّل التاريخ، بها ان. ان وقد جيما الطريق. دار بـ للصين أعمال والحزب.",
                            },
                            {
                                title: "عجّل أراض الواقعة عدد في, طوكيو الأراضي التخطيط الا إذ.",
                                content: "حدى غضون منتصف عل. شيء إعادة ويعزى أوروبا عل, لها مشاركة ومحاولة الأوروبيّون هو. ساعة وبغطاء المتحدة مكن هو. عدد المزيفة والفلبين لبلجيكا، و, و قام مرجع مرمى الكونجرس.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-business-hot-topics",
                name: "مواضيع مثيرة",
                articles: [
                    {
                        id: "1e60235c-0198-4448-9267-f3f86542d7dc",
                        class: "columns-2-balanced",
                        header: "هذا أولا",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "جهة ٢٠٠٤ وبحلول وبعدما من. هو هُزم الشطر بالإنزال أسر, لدحر وبدأت الربيع، الا أي. مع جمعت جديدة أعمال حين, للجزر عسكرياً أن دار. خطّة ثمّة بريطانيا-فرنسا أن وقد, فصل غينيا الآلاف الأوربيين مع, عن الا سقطت أوزار. أخر أن إجلاء الفرنسية استراليا،, قام مسارح بتحدّي مقاومة من. عُقر قررت الشهير لم تلك, ان لإعادة الرئيسية تحت.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "شدّت والحزب هو ذات, فعل قد وبعدما بالفشل بالمحور, مع بحشد وكسبت والمانيا كان. جُل ٣٠ ثمّة عليها. أضف كل تحرير الخارجية الفرنسية, كل على حقول السيء بالمحور. إيو تونس وسوء الستار أي, أي لكل قامت وبدون العالمية, ان أخذ لكون الأرواح واقتصار. ثم الساحة التنازلي به،. قد تسبب المحيط لتقليعة تلك, دفّة الحرة ان حيث.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "46e89da3-b39c-43a7-9178-efeeb91e973d",
                        class: "columns-2-balanced",
                        header: "هذا الثاني",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "يبق وحتى بريطانيا-فرنسا أن, الثالث، الأمريكي أما قد, إيو انتهت مهمّات بل. ثم قادة وقوعها، الصينية وفي, مكن ان أدنى وجهان شواطيء. إذ قادة ولكسمبورغ وصل, أم الشرقية الإطلاق لمّ. الوراء إيطاليا واشتدّت قد دول, وصغار باستحداث ان عرض. أدوات وبريطانيا قد عدد, قررت الضغوط انه ما, فصل للصين الربيع، التّحول أن.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "قد فرنسا الحيلولة كلّ, كلّ عن أملاً مشروط منتصف. إعمار السيطرة لم جُل, بين أم أعمال الثقيل. تم على معقل استبدال التكاليف, تم وسفن وصغار باستحداث فقد. وعلى أساسي باستخدام حول في, إذ وبولندا الأمريكية ذات. كلا تكبّد الخاسرة وبريطانيا أم.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-business-paid-content",
                name: "المحتوى المدفوع",
                articles: [
                    {
                        id: "d6c99f00-e45b-4da3-abb8-2a0a3bd27cc7",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "الوعاء عظيم ، حتى منطقة الكرتون لكرة القدم الإكلينيكية.كرة القدم هي الآن الحلق من جزر الأطفال المبتكرة.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "قرض تشغيل أو المطور.أي عنصر أداء لكرة السلة أو كرة القدم الياسمين ما لم.الموز الاتحاد الأوروبي في الرهان في ذلك الوقت.",
                            },
                        ],
                    },
                    {
                        id: "2b905eee-c666-4704-9658-1e0757b02253",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "الكثير من قطر.جزر كبيرة الحامل الحامل أي جلوس.الضحك ولا حاجة لكرة القدم تحتاج الآن.وكرة القدم حتى أكره راحة قطر الأطفال في عطلة نهاية الأسبوع ولكن.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "الفكين المكسيكيين من تدليك كرة القدم ولكن فقط التصحيح الآن أو ابتسامة الراحة.سعر المعرف السريري يرجى عمل مستحضرات سحب أسعار الماكرو.",
                            },
                        ],
                    },
                    {
                        id: "1acc8fc3-74bb-46b0-8d67-bee9bfb7667a",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "شرب الكحول عناصر الحياة الدردشة.مرض الجزر الأطفال الذكي الوظيفي ليس كذلك.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "الميكروفون في مؤلف القدر الآن ، وهذا هو مسار الخوف من البعض كبيرة حتى الوقت orci.لاعبي كرة القدم الآن ، موز حياتي الحلق للغاية.",
                            },
                        ],
                    },
                    {
                        id: "a005c941-9e4b-4219-88df-d6a553b3c237",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "مجاملة التلفزيون مستهدف.لا حاجة للمادة الآن.مسح معرف الميكروفون المحدد ميكروويف معرف صلصة نيسل.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "أريوس لكرة القدم هي الآن الحلق من شركة الطيران جزر الأطفال.اجلس عطلة نهاية أسبوع مجانية ولكن غدًا.لكن اسحب نفسها الآن يشرب الموز.",
                            },
                        ],
                    },
                ],
            },
        ],
    },
    opinion: {
        name: "رأي",
        url: "/opinion",
        priority: 2,
        sections: [
            {
                id: "content-opinion-a-deeper-look",
                name: "نظرة أعمق",
                articles: [
                    {
                        id: "7c4b6a7e-1f91-4e43-b099-a72aea0fa6c7",
                        class: "columns-3-wide",
                        header: "أحدث الحقائق",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        title: "الجوع القديم ونيتوس و وإنفاذ القانون القبيح.كراهية مضادات الأكسدة موريس الجلوس القداس .لن كرة القدم لكرة القدم السهام لكرة القدم في نهاية الأسبوع الكراهية.",
                        type: "text",
                        content: "ومن كل يعبأ الصفحات التخطيط. يتم ان أطراف إنطلاق. بل أسر مقاطعة الأثناء،, جعل أي منتصف المنتصر. ذات إذ بالجانب واعتلاء اليابانية, يتعلّق ا قُدُماً تم وتم. هُزم جزيرتي الإمتعاض الى مع.",
                    },
                    {
                        id: "0d292bbd-e6da-499b-8008-652d51e3b26d",
                        class: "columns-3-narrow",
                        header: "قمة أذهاننا",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "سعر من الهوية السريرية يرجى جعل سعر درجة الحرارة.تحقيق تشغيل.",
                        type: "text",
                        content:
                            "لكون إعلان حيث في, ثم لها واتّجه ماليزيا،. الخاصّة الفرنسية في بين. وقام لفرنسا ما لها, ولم كل وسفن تعداد الآخر. قبضتهم ليتسنّى مع وتم, مع وقام ارتكبها غير. بل العالم إستيلاء والمعدات حدى, بل فرنسا التبرعات ولكسمبورغ شيء. إيو كل استبدال تشيكوسلوفاكيا.\n\nما يتبقّ مقاومة معاملة وقد, عجّل أمّا الثانية هذه قد, لم أوزار وتتحمّل كما. مايو بريطانيا، ان مما, حيث من أوسع الأمور. هو يكن ونتج لعملة. بل مكثّفة بالرغم الانجليزية مما. بعد كانت البشريةً كل, شعار استعملت ايطاليا، وصل و. هو مايو أصقاع بلا.",
                    },
                    {
                        id: "75c1fa44-8c39-48a0-9db7-b30c0ffc6606",
                        class: "columns-3-narrow",
                        header: "تقرير المحرر",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "كرة القدم هي الكثير من الدورة المعقمة.",
                        type: "text",
                        content:
                            "لم وكسبت بمباركة لبولندا، دنو, قام استطاعوا الدولارات و. الأرض الجنرال الأمريكية إذ ذلك. عن وفي وعُرفت المبرمة. وعلى الثالث، مما ما. ما وفي خلاف الشتوية والديون, مدن السفن الثقيل بريطانيا، أي, قد أما غرّة، رجوعهم التقليدية.\n\nمع مرجع الإقتصادي فقد, في دنو الأجل الصين بالعمل. ذات الطرفين التحالف التغييرات أن. أواخر الشمل الاندونيسية أم مدن. لم تلك أدوات معاملة. حدى أن بمحاولة الخارجية, اليها سبتمبر قبل إذ, بزمام تاريخ تحرّك جعل ما.",
                    },
                ],
            },
            {
                id: "content-opinion-top-issues",
                name: "أعلى القضايا",
                articles: [
                    {
                        id: "68c63699-7843-4f2c-8893-3cd0043ce6c7",
                        class: "columns-3-balanced",
                        header: "أفكار",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "مطورو كرة القدم احتياجات كرة القدم.",
                        type: "list",
                        content: [
                            {
                                content: "هو بحق مسرح الحدود, رئيس واستمرت المتساقطة، أم حتى",
                            },
                            {
                                content: "أما إعمار الأراضي اليابانية, وجهان لعملة كلّ قد, قائمة والحزب ٣٠",
                            },
                            {
                                content: "اليميني الأبرياء في. مكن إذ أكثر الأراضي, وصل بل فرنسية العالمي.",
                            },
                            {
                                content: "حصدت وجهان. تلك عل وبدأت لليابان بالرّغم. ٢٠٠٤ احداث قد فصل, ",
                            },
                        ],
                    },
                    {
                        id: "f293245c-cbdc-4538-8ca8-0181ba5709a0",
                        class: "columns-3-balanced",
                        header: "التعليق الاجتماعي",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "سهام القوس من الكحول.",
                        type: "list",
                        content: [
                            {
                                content: "مع وتم, فقد أن إختار نتيجة, أهّل القوى إذ بلا. فقامت ارتكبها ما فعل,",
                            },
                            {
                                content: "أحكم التي العدّ فعل مع. حول ما رجوعهم وصافرات.",
                            },
                            {
                                content: "تلك الدول الصين بمعارضة بل, اتفاقية الأولية وفي ان. لك",
                            },
                            {
                                content: "استعملت اليابان، هو, يكن قائمة والمانيا التنازلي عل. ما ولم هُزم بريطانيا.",
                            },
                        ],
                    },
                    {
                        id: "0f38830e-3f1d-43ee-9f24-dc3f1422e9d7",
                        class: "columns-3-balanced",
                        header: "مشاريع خاصة",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "عدد لعدم وفرنسا أي, وتزويده الأرضية يتم هو. جورج مس",
                        type: "text",
                        content:
                            "اليابانية استراليا، إذ فعل. من دارت الشطر فاتّبع عدم, كل مما مساعدة الشتاء، ولاتّساع. عن شرسة اعلان بعد, أي سابق الشهيرة فقد. التي أمدها قد كما, إذ تلك النفط الشرق، الخاسر. قد خطّة وبالرغم شموليةً أخذ.\n\nلليابان بمعارضة ما وقد, مئات أحدث لإنعدام هو حتى. مرجع يتبقّ بتخصيص الا ما, إجلاء عسكرياً أم عدم. إعادة الأوضاع أم قبل, المتحدة ولاتّساع بريطانيا لم شيء. شيء هناك أدنى إبّان عن. يبق أن تزامناً الأراضي لبلجيكا،, لكل و مكّن وشعار الثقيلة. و اللا وبعدما الربيع، أسر, بين في جسيمة للصين الأوروبيّون, يعبأ المدن الشتوية نفس كل.",
                    },
                ],
            },
            {
                id: "content-opinon-trending",
                name: "الشائع",
                articles: [
                    {
                        id: "7ca7daac-f4d0-4a57-a396-b8bb485796b4",
                        class: "columns-wrap",
                        header: "حول العالم",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "إيو كل وباءت وبداية الضغوط, بحشد تجهيز حدى بـ. قد معقل عجّل الساحلية حيث, دون ما والحزب الفترة. أن الأمور البشريةً دار, مع أمّا أخرى الطرفين فقد. و كرسي الثقيل جعل. تعد بولندا، إستيلاء أي, عل جيوب الوراء العمليات ذلك. حاملات إتفاقية وبلجيكا، ٣٠ فقد, بقسوة سبتمبر وايرلندا جهة ما.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "من هذه بقصف ومحاولة لبولندا،, أوروبا معارضة الفرنسي نفس إذ. كل مدن تشكيل اتّجة, و حتى وجزر الآخر, وتم لإعلان الثقيلة الواقعة كل. هذا هو المارق ويتّفق, هو عسكرياً الإثنان شيء. لكل ارتكبها المتساقطة، ثم, عل حتى حصدت وصافرات. قد ثمّة واحدة واتّجه ذلك.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ثم فكان وبولندا التغييرات بال, أخذ للجزر الخطّة الإنذار، ما. فعل كل بشرية وايرلندا, بـ حول وقرى حادثة والنرويج. وفي ودول العالمي العاصمة عل. جعل بـ لغزو إحتار واعتلاء.",
                            },
                        ],
                    },
                    {
                        id: "89639a03-5c46-45c1-ad54-ba8548521eea",
                        class: "columns-wrap",
                        header: "يدعم",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "وبدون الصفحات بها في, جيوب وبعد مكن عن. وسفن الستار النزاع وقد بل. وفي عن فرنسا واتّجه المنتصر, ان الأحمر وتنامت تلك. الثالث والفرنسي وصل بل, كل تحرّك المارق عدم. ٣٠ ومن ودول العصبة المواد, عجّل أراض ٣٠ وفي. ودول الواقعة الدنمارك بحث بـ, هذا بالعمل والفرنسي ٣٠.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "بل لان الله المجتمع, لمّ ثم غضون ليركز. أم الدول طوكيو بلديهما يكن, أعلنت وصافرات وفي كل, أحدث العالمي عل كلّ. أم عدم مسارح للصين عملية, حصدت الثقيلة لمّ أم. الله الطريق عل كلا, ٣٠ وقد حقول ميناء والعتاد. دفّة ألمّ الإمتعاض بـ حين. استبدال وقدّموا والنرويج تلك تم, للصين الشتوية فصل أي.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "وصل أن بحشد أساسي, وبدأت الأمم واشتدّت جهة ما. الحرة بينما الإثنان أن يبق. ضرب ان دخول تشكيل الانجليزية, القوى المشترك بمباركة ثم فعل. كل دار أفاق أوسع, نفس عل قادة الثانية الشّعبين.",
                            },
                        ],
                    },
                    {
                        id: "b4c36ecf-7d2f-4715-842c-a1fe99c0475e",
                        class: "columns-wrap",
                        header: "تعرف أكثر",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "كل السبب وتزويده حين, حقول الطريق وحرمان كل فقد. ما لان عُقر قتيل، أوراقهم. والقرى الشهير مع أسر, انه حاول مكّن بالفشل عل, مدن و وسمّيت الثانية. مقاومة الساحل لليابان أن كلا, يرتبط استعملت بل وقد. يتم جيما وجزر أم, و بال أمام الأوروبي الأوروبية،. لم أخذ إعمار واتّجه.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "في كلّ تعداد وزارة اعتداء, إذ فقد أطراف والمانيا. دنو ٣٠ خطّة وصافرات. كلا بأضرار تكتيكاً بـ. إذ كثيرة اليابانية قبل, ٣٠ أسر بتطويق وايرلندا وبريطانيا. أخر غريمه وتنصيب المعاهدات أي, هنا؟ فشكّل والإتحاد أم وتم, ولم أن الله وصغار استطاعوا.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "كل بين للصين لفرنسا. لبلجيكا، التقليدية مع ومن, تسبب وتتحمّل عن ذات. كل عرض الشمل لتقليعة. فصل لكون ديسمبر ثم, مع أعلنت واُسدل ذات. لان كل تصفح وأزيز الثانية, حيث غرّة، ويتّفق بريطانيا تم, الهادي والنرويج شيء كل. و حتى لكون كانتا, فعل سابق أملاً العناد عن, بلديهما للإتحاد والمعدات وتم ما.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-opinion-think-about-it",
                name: "فكر في الأمر",
                articles: [
                    {
                        id: "a1034d17-1add-49f8-b258-27de86bea9e4",
                        class: "columns-3-balanced",
                        header: "الصحة النفسية",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "ومطورين الحياة الذين تخرجوا دائمًا في أي وقت من الأوقات.ليس أكثر من قطعة من فكي التدليك في بعض الأحيان يضع لوريم ..",
                        type: "list",
                        display: "bullets",
                        content: [
                            {
                                content: "بوابة معرف التصوير الفوتوغرافي الماكرو تعقيم غدًا ، ولكن كرة القدم.لا يوجد أي كرة قدم تصنيع يركض ضحكًا في كرة السلة.",
                                url: "#",
                            },
                            {
                                content: "يرجى القيام بأي مطورين جماعيين تمويل الآن.قط ، ولكن لسيناريو سحب الموز.",
                                url: "#",
                            },
                            {
                                content: "شرب الكحول عناصر الحياة الدردشة.أي شخص له يشدد على كرة السلة الحامل الإكلينيكي للاستثمار.",
                                url: "#",
                            },
                            {
                                content: "من هو تخمير الشوكولاته الكرتون. غدًا ، لكن كرة القدم تحتاج إلى مسح في الهواء الطلق.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "c344dac6-35bf-44af-9c55-ae5ca7ab7f41",
                        class: "columns-3-balanced",
                        header: "حياة أفضل",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "ضع مدخل محاضرة كرة السلة.الفول السوداني في سياق القداس المدرسي.",
                        type: "list",
                        display: "bullets",
                        content: [
                            {
                                content: "في هذه الدورة التدريبية ، فإن مجموعة التغذية هي مطور التغذية.لكنني تخرجت من في بعض الأحيان.",
                                url: "#",
                            },
                            {
                                content: "كرة السلة الفول السوداني في الجري المطورين الديمقراطيين القبيح.وقتي التمويل لا التغذية.",
                                url: "#",
                            },
                            {
                                content: "مسح الحياة الحنجرة جدا أو هو.المراهقون حتى يضعفوا السهام أو الأسهم.",
                                url: "#",
                            },
                            {
                                content: "في هذا المسار من الشارع.السعر الجذاب السهام بعض تشرب الكحول.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "a1724b6d-085c-4467-b413-e3332a4a4af6",
                        class: "columns-3-balanced",
                        header: "الاختيار الصحيح",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "الحلق أو الموظف والاتحاد الأوروبي.بالنسبة للجزر المعقم وعاء الجري تحتاج الآن كرتون الشوكولاتة.",
                        type: "list",
                        display: "bullets",
                        content: [
                            {
                                content: "مجموعة من جرة من الفلفل الحار الذكي.يحتاج إلى الكثير من المرح غدا الجامعة ل.",
                                url: "#",
                            },
                            {
                                content: "موظف الأسد في مضادات الأكسدة لكرة القدم.كانت المخاوف في وقت الراحة الدببة.",
                                url: "#",
                            },
                            {
                                content: "لا تكره تنورة الأداء في أي ابتسامة ولكن لحوم البقر.",
                                url: "#",
                            },
                            {
                                content: "فقط حتى الضعف القطر.عنصر الأداء ما لم يكن أي خصم.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-opinion-latest-media",
                name: "أحدث الوسائط",
                articles: [
                    {
                        id: "c3ed8428-cf45-4f9d-86d1-391bd9e9ad80",
                        class: "columns-1",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-opinion-in-case-you-missed-it",
                name: "في حال فوته على نفسك",
                articles: [
                    {
                        id: "9ecce31e-6d76-44c4-a518-b881b6877724",
                        class: "columns-3-balanced",
                        header: "الأفكار النقدية",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "وقت كرة القدم معرف الوعا غدا ماتيس الآن ولكن.",
                        type: "list",
                        content: [
                            {
                                content: "طلب كرة القدم الآن الكثير من المسرحيات في الكثير من المرح.",
                            },
                            {
                                content: "الأهم من ذلك المطور مثل الجزر الفلفل الحار الحداد تعقيم.",
                            },
                            {
                                content: "الاتحاد الأوروبي عطلة نهاية الأسبوع الكراهية مضادات الأكسدة موريس الكثير من القداس.",
                            },
                            {
                                content: "لأمريكية ما. السيطرة للإتحاد لبولندا، بل فقد. وحرمان الهادي المزيفة يبق ما.",
                            },
                        ],
                    },
                    {
                        id: "f80bc40c-0c9c-4567-8b79-fd29ef77659b",
                        class: "columns-3-balanced",
                        header: "التفكير النقدي",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "الأداء إذا كانت بوابة لورم لينة بعضها كأسد مبتكر.",
                        type: "list",
                        content: [
                            {
                                content: "لمضادات الأكسدة الحوامل أو الوادي من.",
                            },
                            {
                                content: "للجزر بريطانيا، تعد هو. أما أراض إعلان كل, إبّان أسابيع كل عدد, دار جورج",
                            },
                            {
                                content: "جُل بـ بزمام الأسيوي, إذ يبق وشعار يتبقّ, به، مشارف مواقعها هو. لم مليون المعاهدات",
                            },
                            {
                                content: "مع. لم بداية لإعلان بين, ضرب أفاق شاسعة الإيطالية هو. لك",
                            },
                        ],
                    },
                    {
                        id: "1bb6984e-a18f-47b7-9bbb-6888b74b58da",
                        class: "columns-3-balanced",
                        header: "الإجراءات الحرجة",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "وقال إلزامي العلاج بالجزر حتى القطر.",
                        type: "list",
                        content: [
                            {
                                content: "كان الخوف في وقت الراحة رقعة من التصنيع.",
                            },
                            {
                                content: "في اللاعبين فقط كرة السلة الشوكولاتة كرة القدم.الخميرة والرعاية والمغذية السريرية.",
                            },
                            {
                                content: "من أجل أخذ بعض الجزر الفلفل الحار الحداد المعقم مع تخرج مع بيئية كبيرة.",
                            },
                            {
                                content: "كرة القدم هي الآن الحلق من الأطفال.حنجرتي للغاية من الحياة والمسح أو.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-opinion-environmental-issues",
                name: "القضايا البيئية",
                articles: [
                    {
                        id: "d55b5489-7ed3-4215-9e45-ef5ae8072210",
                        class: "columns-3-balanced",
                        header: "الاحتباس الحرارى",
                        type: "articles-list",
                        content: [
                            {
                                title: "عجّل أراض الواقعة عدد في, طوكيو الأراضي التخطيط الا إذ. قبل ان ليرك",
                                content:
                                    "دون الفترة واستمرت بالتوقيع قد, إبّان استدعى ألمانيا الى ثم. هو التاريخ، التقليدية دنو. تعد ما حكومة الأهداف, الى جيوب المحيط أم, أسر بـ تحرّكت الربيع،. في انه دارت العناد لبلجيكا،, إيو أدنى قائمة كنقطة أم, ٣٠ الا الساحل واندونيسيا،",
                            },
                            {
                                title: "الحياة القبيحة للحياة ولكن عنصر الوقت الأرنب ولكن ابتسم.",
                                content:
                                    "من دول استعملت المتاخمة, يبق ثم دخول تجهيز القوى. ان حول لأداء ألمانيا. فرنسية الثقيلة ويكيبيديا، أسر لم, وصل عالمية الساحل ايطاليا، مع. ٢٠٠٤ وبالرغم الثقيلة وقد ٣٠, لان مع اتفاقية مليارات. سقطت بالجانب وباستثناء قد جُل, أخر جيما الأحمر ٣٠. هو كلا قدما أطراف.",
                            },
                            {
                                title: "منطقة مكياج التغذية مطوري كرة القدم درجة الحرارة.إلغاء ولكن غد كرة القدم قوس.",
                                content: "لم مكن جيوب بلديهما. فهرست المضي مع حول. عقبت بالفشل وأكثرها مدن ثم, مع دول بينما للسيطرة استراليا،. قد يبق تغييرات الدّفاع, ودول استدعى الا هو, بال لم أجزاء الضغوط الخاصّة.",
                            },
                        ],
                    },
                    {
                        id: "dcb3d636-542f-49ea-aaa0-e829fc87ab3d",
                        class: "columns-3-balanced",
                        header: "إعادة التدوير",
                        type: "articles-list",
                        content: [
                            {
                                title: "الأرض معرف البروتين معرف الكحول.",
                                content: "المزيفة عسكرياً بحق و. الأمم عسكرياً ويكيبيديا و بال, ديسمبر عسكرياً إذ شيء. دون لم الأجل مقاطعة مليارات, ذلك خلاف المنتصر الاندونيسية بـ. حصدت الفرنسي أخذ و. لمّ لأداء معاملة بـ.",
                            },
                            {
                                title: "كرتون الشوكولاتة موريس في بعض النظام البيئي للسلطة.",
                                content:
                                    "الدمج الأثنان بالتوقيع كل بال. بعض عليها التبرعات من, هامش فكانت التغييرات بل فقد. ا السادس دون ما, دار بل أعلنت بالحرب بولندا،. قد سكان تكتيكاً الولايات هذا, بل وتم وترك فبعد وبدأت. دول لهيمنة ماليزيا، اليابانية بل.",
                            },
                            {
                                title: "تمويل القطط الشوكولاتة الشوكولاتة الجذابة.ليس أكثر من رقعة تدليك الحلق في بعض الأحيان.",
                                content:
                                    "الذود التنازلي وبالتحديد، لم ضرب. ولم أم بلاده واستمر والروسية, نقطة الضغوط بل هذا. أي مكن واتّجه وباستثناء بالمطالبة, بقيادة بمعارضة والكوري كما ٣٠. بها ٠٨٠٤ وصغار و, مع بقصف كرسي ومحاولة يبق. حصدت الوراء اوروبا على من, قد قام جمعت العالم. هناك لهذه الخاسر جُل بـ.",
                            },
                        ],
                    },
                    {
                        id: "500a214a-8186-49bf-96f0-38e42014460b",
                        class: "columns-3-balanced",
                        header: "أبحاث جديدة",
                        type: "articles-list",
                        content: [
                            {
                                title: "ليس أكثر من قطعة من الحلق التدليك.",
                                content:
                                    "بلا الطرفين للسيطرة عل. أم الى فاتّبع الأهداف وانتهاءً, عرض أي بالعمل وسمّيت. مع ذات قررت بالولايات, ان القادة الولايات وبريطانيا عرض. أي سقوط وبدون واندونيسيا، حول, أن ولم تونس لبولندا،, وبداية الثقيلة المؤلّفة أخر في.",
                            },
                            {
                                title: "الكثير من مطور المرحلة الجامعية.لوريم ولكن ابتسامة الموجات فوق الصوتية حزينة لا مسح.",
                                content:
                                    "وانهاء الوزراء ثم وقد, تحرّكت وسمّيت الأبرياء لان لم. القادة ليتسنّى على كل. ٣٠ به، جزيرتي النزاع بالمحور. جعل الضغوط السيطرة لم. الهادي وسمّيت التحالف دون أي, بـ لان لعدم أخرى الحكومة. مكن الدنمارك ايطاليا، الشّعبين و, فعل فقامت الشمل ٣٠. إذ مرمى تحرير والقرى دول, تصرّف إعلان الواقعة مع حدى, أم غينيا الشطر انتباه عرض.",
                            },
                            {
                                title: "تم خلاف الأسيوي أسر, ضرب ووصف علاقة استبدال عل, وت",
                                content:
                                    "بحث بـ هنا؟ اقتصادية, ضرب اكتوبر الأمريكية ثم. حول وترك وبداية اليميني أي, وبحلول الثقيل الواقعة ثم يكن. مع حصدت وبدأت مساعدة الا, دنو إعادة اللازمة وبريطانيا قد. رئيس وقوعها، ألمانيا بحق إذ, أم الى جيوب وإيطالي, تم وفي أعمال الصعداء.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-opinion-underscored",
                name: "يؤكد",
                articles: [
                    {
                        id: "8096212a-bfab-494b-b4d9-a04c2bd80b17",
                        class: "columns-2-balanced",
                        header: "هذا أولا",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "٣٠ وقدّموا الجنرال بحق. و هذا تجهيز والحزب سنغافورة, عرض لم فكان مكثّفة الأولية. ميناء عسكرياً الأهداف حدى تم, ما وحتى مساعدة بالحرب جهة. أضف كل الأول الدّفاع. هو وصغار الصفحات شيء. تحرّك الشمل قد حيث. دون كل ماشاء الأبرياء.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "لان الدمج كثيرة وإيطالي كل. بعد الأخذ استرجاع أي. القادة وأكثرها وحلفاؤها فعل من. مرجع اليها ذات أم, أم تلك غضون تكاليف.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "8945566e-82d2-419c-8ec5-750294e2aaf4",
                        class: "columns-2-balanced",
                        header: "هذا الثاني",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "أدوات الإقتصادي أي تحت, وفي نقطة تحرير التحالف بـ. كل بحق بريطانيا، الأوروبيّون, يبق مرمى غضون واستمر أي. أم لان الستار ديسمبر. بل لإعادة الطريق الخاطفة أخذ.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "لم أخذ فهرست وإيطالي أوراقهم. حيث و الدمج الإكتفاء, بها هو منتصف وتزويده. لها قررت ومطالبة والروسية ما, يذكر ليبين الجنرال حتى تم. عدم وتزويده العالم، تم, بعد موالية الشتوية مع.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-opinon-what-matters-most",
                name: "أكثر مايهم",
                articles: [
                    {
                        id: "2fe9dc69-e459-46d6-8b9b-8bce7c60f694",
                        class: "columns-wrap",
                        header: "مناقشة",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "يكن بل بسبب تعديل إعادة, أخر مكثّفة استدعى الطرفين في. ما مهمّات استدعى وباستثناء انه, هو تحت استبدال للحكومة. فصل أن جيما الأولى الشمال, أي ليبين الصفحة اليابان بلا. عن سياسة بالجانب حدى, لم ضرب مدينة وباءت الخاسر. لهيمنة الدنمارك ٣٠ وفي. حدى ما هُزم إعادة, أسر كنقطة الصين استمرار لم, حالية بوابة معزّزة وفي قد.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "أوسع يتعلّق هو لكل, هو واتّجه وحرمان لان, ومن الجنرال والمعدات أم. من أمام تاريخ أما. حقول بينما والقرى أن ومن, ثمّة الثقيل واقتصار جعل أي, كلّ حلّت غضون بل. قد الخطّة البرية بمعارضة بال, قبل يرتبط بتخصيص بـ.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "غير بشرية الخارجية من, فمرّ لمحاكم مساعدة عدد قد. عن حيث وبحلول الضروري. من الله الصين الا. وحرمان تزامناً أم عرض. واستمرت واقتصار الفرنسي عدد هو, قام والتي استبدال وأكثرها من. جنوب مهمّات انتباه كلا مع.",
                            },
                        ],
                    },
                    {
                        id: "fa068dc1-0a5c-459a-9e38-7fb8cd9d5fa5",
                        class: "columns-wrap",
                        header: "هل تستحق ذلك؟",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "بداية ترتيب الشرقي حول قد. مع حدى بشكل مسرح يتبقّ, ثم العالم شموليةً يتم. كان تُصب الضروري أن, من لمّ كانت فهرست. ثم لمّ شعار أملاً. أم بحق ٢٠٠٤ أمّا السبب, أملاً أوراقهم لها عن, حتى بـ الغالي والنفيس. دأبوا بالرغم وسمّيت عل أخر, يكن هو وشعار وسمّيت المتاخمة, جُل بـ مارد حاملات بالجانب.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "و ٠٨٠٤ حكومة السفن دنو, يتم من لكون أدوات بالرّد. احداث أعمال كل عدم, مع ووصف وصغار فهرست تلك, بقعة غضون بداية ضرب عل. دنو تاريخ الربيع، استطاعوا مع, أي وسمّيت التاريخ، عرض. العالم، مليارات ايطاليا، إذ وقد, إحتار غينيا المبرمة لم ومن. عل عقبت لعملة الأولية قبل, به، وعُرفت التغييرات كل. يتم كل الصفحة الساحة الأوضاع, بال أكثر الإتحاد لم, قبل أن عملية الشهيرة مواقعها. خلاف أوروبا واقتصار كلا من, مكن في تعداد الحدود تكتيكاً.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "دون عن لغات المضي السيطرة, يرتبط الأوروبيّون جهة ان, غير الدنمارك الإنذار، بـ. جعل من حقول مواقعها, المعاهدات الاندونيسية دون في. في غير أواخر إنطلاق رجوعهم. تم بها قدما لأداء الأراضي, عرفها وإعلان الإتحاد من انه. ٣٠ لغات ضمنها كلّ, أم بين ألمّ مقاطعة, الأخذ معارضة بمباركة ما مما. بلا عن غينيا الضغوط للحكومة, جعل عالمية الطريق أن, بعد فبعد السيء لم.",
                            },
                        ],
                    },
                    {
                        id: "31082ef2-8a41-4ea5-9c40-3d87ff73ad5f",
                        class: "columns-wrap",
                        header: "افعل ذلك",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "أي مكن وقبل الإتحاد, بشرية سبتمبر العظمى تم حدى. قد بشرية مدينة الجديدة، نفس. تم يبق تكتيكاً الصفحات. ماشاء للإتحاد بالإنزال بل هذه.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "أسر بل دفّة المواد مليارات. الا أن عقبت الخاطفة, لفشل إعمار أن على, إستعمل الخارجية وفي عل. ٣٠ تعد غينيا ولكسمبورغ المتساقطة،, حتى نقطة غريمه السبب بل. كلّ تونس الجوي و. وصغار ليبين وتم من, أسر هو مسارح الفترة العالم،. ضمنها إيطاليا لم وتم, دارت والكوري بعض ان, ومن كُلفة ارتكبها بل.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "عقبت غرّة، أخر ما. و بمحاولة التحالف أخذ. تلك أم شواطيء بتخصيص اسبوعين, الصفحة شموليةً والنفيس تم فصل. بل أما ٢٠٠٤ السادس الإثنان.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-opinion-hot-topics",
                name: "مواضيع مثيرة",
                articles: [
                    {
                        id: "20b1f11f-8da5-4614-82b9-80c15aed568c",
                        class: "columns-2-balanced",
                        header: "هذا أولا",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "لم ولم بوابة الأخذ بمحاولة, حيث بل هناك مسؤولية. يرتبط أوروبا الثانية ثم تحت, أن تحرّك حادثة بحق, وجزر الأخذ استرجاع و فقد. بـ تحت طوكيو جديداً, كل انه بقصف اعتداء. مرجع المارق إذ أضف, وصل وقامت ممثّلة يتعلّق أم, ان جُل بالولايات الأوروبيّون. كلّ بل للصين العالم،. من أدوات تكاليف بمحاولة كان.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "من أسر فسقط والحزب بالتوقيع, وتم وعلى إحتار ٣٠. مع بلاده ابتدعها أخذ, لغزو الإنزال تلك بـ. فهرست الخاسرة مع بلا, ذات مع هاربر مقاومة. من عدم وباءت إتفاقية وبريطانيا. معقل قادة ممثّلة و دون, و جمعت الدمج المؤلّفة دول, قد يتم والقرى تغييرات. بداية ألمانيا هو مما, فعل الساحة والفرنسي ثم. قد كُلفة وبولندا يبق.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "662f09bf-45ab-445f-a096-cede68c5dab8",
                        class: "columns-2-balanced",
                        header: "هذا الثاني",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "بال من شمال أوزار وعُرفت, نفس وقامت واستمرت الأثناء، ان, تصرّف حاملات والنرويج أي نفس. ثم بقسوة ويكيبيديا، جعل, لعملة المعاهدات مكن أم. بال اتّجة الجنوب محاولات أي, إختار تحرّكت من فصل. ومن بشرية المؤلّفة بالمطالبة عل, يقوم الجنود وبالرغم ٣٠ دنو.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "عدد فقامت قتيل، التحالف ان, من حتى وسوء الجنوب استطاعوا. بال الخطّة الساحلية و, وأزيز اعتداء وبعدما كان أم. انه قد الأخذ اعتداء. يكن هناك الأراضي الرئيسية من, والقرى الثانية هو بعد, ان كان بتحدّي مشاركة.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-opinion-paid-content",
                name: "المحتوى المدفوع",
                articles: [
                    {
                        id: "c7f1b2e8-3e7e-4cea-b8fd-97da6aaa217a",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "لا فيوليسي نولام مركبة نفسها.الكثير من المرح غدًا في المرحلة الجامعية الأولى لسعر التنفيذ القبيح لكرة القدم.قطر التصنيعالضحك",
                            },
                        ],
                    },
                    {
                        id: "f047187b-7651-45f5-8e13-362d82b59e91",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "سريري سريري سريري سريري.أي شخص له يشدد على كرة السلة الحامل الإكلينيكي للاستثمار.",
                            },
                        ],
                    },
                    {
                        id: "fc748387-cfdb-4659-bf00-14984869c3f4",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "ومع ذلك ، غد كرة القدم.وظيفية الآ الكثير من الحلق في.لا مركبات.لكن حلق قبيح على كرة القدم ، مشروب بلدي.",
                            },
                        ],
                    },
                    {
                        id: "ad88b542-6ac0-4525-b6be-581cb2b67762",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "موريس الآن الواجب المنزلي ما لم تكن المهنة.مؤلف الدعاية موريس أوغو أو حامل.",
                            },
                        ],
                    },
                ],
            },
        ],
    },
    health: {
        name: "صحة",
        url: "/health",
        priority: 2,
        sections: [
            {
                id: "content-health-trending",
                name: "الشائع",
                articles: [
                    {
                        id: "b5d84dfb-d80f-4ba1-ab4e-c33e255b3157",
                        class: "columns-3-balanced",
                        header: "تركيز كامل للذهن",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "مينيابوليس لوريم حتى كتلة سابين الحلق.",
                        type: "list",
                        content: [
                            {
                                content: "كرة القدم إنفاذ القبيح سعر الجيش الياسمين.معرف الصلصة المعقمة بواسطة صلصة.",
                            },
                            {
                                content: "الثانية ثم تحت, أن تحرّك حادثة بحق, وجزر الأخذ استرجاع",
                            },
                            {
                                content: "الجوي و. وصغار ليبين وتم من, أسر هو مسارح الفترة العالم،. ضمنها إيطاليا لم وتم, ",
                            },
                            {
                                content: "الجوع والقبيح.يحتاج كتلة الطفل إلى كتلة من الرسوم المتحركة الفلفل الحار.",
                            },
                        ],
                    },
                    {
                        id: "a1822776-68b2-4d24-95e2-917756de0c12",
                        class: "columns-3-balanced",
                        header: "أحدث الأبحاث",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "ومع ذلك ، فهو يريد أعضاء كرة القدم مثل حياة سلطة كرة القدم.",
                        type: "list",
                        content: [
                            {
                                content: "عرض نقطة والمعدات عن. جديدة الأهداف الإثنان حتى بـ, يتم ثمّة كرسي.",
                            },
                            {
                                content: "لأمريكية بل, تكتيكاً الربيع، بين و. إحكام الأوروبية عن مدن",
                            },
                            {
                                content: "عن أواخر إستعمل الطريق وصل. قد وحرمان بمباركة والمعدات جُل",
                            },
                            {
                                content: "ثمّة أساسي الاندونيسية أم هذه. اسبوعين الإمداد الجنوبي بحق عن.",
                            },
                        ],
                    },
                    {
                        id: "0a522480-9f37-43e3-bbf2-c5398450a921",
                        class: "columns-3-balanced",
                        header: "صحية كبار",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "لا يتم تعزيز الشوكولاتة من قبل.",
                        type: "list",
                        content: [
                            {
                                content: "تنورة الأداء الكراهية في أي ابتسامة ولكن الكراهية الجذابة.لا يحتاج إلى أي ميدليسي أيضًا.",
                            },
                            {
                                content: "نفسها لوصف اللاعبين أو الدفع.ما لم تتلقى الحياة أكبر قطر في المنطقة.",
                            },
                            {
                                content: "الشطر من, كردة تسبب الإتحاد في كلا. أم ليس الأعضاء أو الأعضاء.",
                            },
                            {
                                content: "في قطر عطلة نهاية الأسبوع كمنطقة معقمة في كرة القدم الخوف.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-health-latest-facts",
                name: "أحدث الحقائق",
                articles: [
                    {
                        id: "db2abfd6-b4d4-4237-850a-7f34de938739",
                        class: "columns-3-balanced",
                        header: "المزيد من الحياة ، ولكن أفضل",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "ولكن الوقت وعاء والارتجال الكتلة كتلة الكتل.",
                        type: "list",
                        content: [
                            {
                                content: "جعبة أو التذاكر تحتاج الآن.كرة القدم ومن من السادس وصفة شبكة.",
                            },
                            {
                                content: "إيو علاقة الوراء, بقيادة الشتوية إيو في. حالية التخطيط تم بعض. اكتوبر وحلفاؤها وبريطانيا دن",
                            },
                            {
                                content: "اضي للأراضي أن, ان بلاده وتنامت مما. بعد في مليون استبدال الإنذار،, لان مع",
                            },
                        ],
                    },
                    {
                        id: "8cfeff8c-94cb-4eca-b5e2-b4214b761705",
                        class: "columns-3-balanced",
                        header: "في حال فوته على نفسك",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "أرنب سعر جعبة كبيرة.",
                        type: "text",
                        content:
                            "عُقر الجديدة، الأوروبيّون في فقد, لم سقوط أوزار بتحدّي دار. بحق و استبدال وفنلندا, قِبل أخرى الوزراء عن وفي. في وباءت بالرغم ويكيبيديا دون, من لها أطراف إتفاقية. إذ جهة الشرق، بالولايات. عل عدد اوروبا لليابان, قبل أحكم السبب الأولى و. ثم فصل للحكومة الإتفاقية الاندونيسية, في حيث قامت تشكيل وحلفاؤها.\n\nحين حالية الحكم وانهاء و, ان فبعد الغالي وقد, عل حول وكسبت للأراضي. لمّ حقول والكوري استعملت ثم, ثم ذلك اللا بوابة الأرضية, شرسة جسيمة تصرّف تعد ثم. يتم إذ الآلاف شموليةً, مع فقد وبعض كردة الأثنان. لهذه غريمه بال لم. مما في الشّعبين ويكيبيديا. وقام سليمان، البولندي بل أخر.",
                    },
                    {
                        id: "ae3f3c45-b7fe-4729-8374-f3ba8d11eeff",
                        class: "columns-3-balanced",
                        header: "الفضاء والعلوم",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "قد, و شعار وبريطانيا حدى. فصل ما لفشل جديداً, قد أمام ",
                        type: "list",
                        display: "bullets",
                        content: [
                            {
                                content: "وبعض المتساقطة، الإقتصادية من مما, مع بحشد مليون إحكام بعض.",
                                url: "#",
                            },
                            {
                                content: "ضرب مايو والتي من. عشوائية الجنرال دار ما, جُل المدن انتصارهم إذ.",
                                url: "#",
                            },
                            {
                                content: "بعد مع وقام تكبّد الإمتعاض, حين دأبوا وكسبت من.",
                                url: "#",
                            },
                            {
                                content: "الأرض كما هو. وفي أوسع أوروبا ليرتفع ٣٠, بـ ومن هامش لأداء",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-health-medical-breakthroughs",
                name: "الاختراقات الطبية",
                articles: [
                    {
                        id: "2afaf4ee-4d1c-4f54-a970-bc8222cc3090",
                        class: "columns-3-wide",
                        header: "الاختراعات الجراحية",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                            tag: {
                                type: "breaking",
                                label: "كسر",
                            },
                        },
                        title: "هو الكثير من الوقت لفترة طويلة جدا.بالطبع بحاجة الآن إلى كرتون الشوكولاتة موريس في البيئة المنحدرة.",
                        type: "text",
                        content:
                            "عرض أن ألمّ وكسبت, مع يتمكن الجنوب التجارية مما, أم وبعد اللا والقرى دول. دول مكّن الصفحات والفرنسي أم, بحق ٣٠ شاسعة أسابيع معزّزة, دارت الشهيرة على بـ. قد المسرح أوروبا الضروري وقد, شدّت للحكومة حول كل. أما حاول أثره، الإطلاق قد. يتم عن الحكم المحيط مقاومة.",
                    },
                    {
                        id: "7213a42c-c2eb-486a-bb2e-b59f6667fb4a",
                        class: "columns-3-narrow",
                        header: "الرعاية الطبية",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "غدا دائما هوثتور أو الحياة.أو قبيح الآن بحاجة إلى ألم لوريم ولكن اسحب نفسك الآن.",
                        type: "text",
                        content:
                            "غير بفرض إستعمل ليتسنّى ٣٠, كلّ ديسمبر بالمطالبة ثم. أم تعداد لأداء العالمية الى, هنا؟ أسيا وبالرغم أضف في. تسمّى فهرست باستخدام هذه أي, عن حين غضون مدينة أعلنت, إحتار التجارية الا بل. من رئيس واُسدل شيء, بشكل شمال بشرية بـ جُل, عدم ألمّ الأمم العظمى في. أوسع الستار إتفاقية ذلك أن, في أضف تصفح اكتوبر ابتدعها, ما كلّ لفرنسا وبريطانيا. حول إبّان بتحدّي لبولندا، ما, إذ حيث أراض الربيع، الواقعة. بعد هو الجو نهاية المارق, مكثّفة مقاومة ٣٠ وتم.",
                    },
                    {
                        id: "9323f56f-d3b3-4b86-bd4c-014392b62272",
                        class: "columns-3-narrow",
                        header: "دواء",
                        url: "#",
                        image: {
                            src: "placeholder_light.jpg",
                            alt: "عنصر نائب",
                            width: "1280",
                            height: "720",
                        },
                        meta: {
                            captions: "الصورة التي التقطها شخص ما.",
                        },
                        title: "الج المطور الجامعي.إنه يرغب في عدم تعزيز الشوكولاتة فيها.",
                        type: "text",
                        content:
                            "عدم وشعار وحلفاؤها مع, حالية واحدة و كان, قامت فرنسا الأجل لم هذا. عدد عل وباءت الإنذار، التغييرات, عجّل أفاق به، هو, وصل بحشد بقسوة و. في اللا اسبوعين الصينية أسر, تشكيل وتزويده اسبوعين ثم عدد. بل دار شدّت أسيا المشتّتون, فقد ما شعار أدنى, لكون ممثّلة يبق في. قامت الغالي العناد لم نفس, مع وتم ليرتفع واشتدّت والنفيس.",
                    },
                ],
            },
            {
                id: "content-health-latest-videos",
                name: "أحدث مقاطع الفيديو",
                articles: [
                    {
                        id: "c1f811ca-284b-4e7b-9bfb-bb5a7c72211d",
                        class: "columns-1",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "watch",
                                        label: "يشاهد",
                                    },
                                },
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-health-educational",
                name: "تعليمية",
                articles: [
                    {
                        id: "c2dc8f88-8a0a-4a3f-aadd-a5f83e291081",
                        class: "columns-1",
                        type: "grid",
                        display: "grid-wrap",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "كلّ أن الخاطفة بالرّغم بريطانيا،, الشتاء الشهيرة ان هذا, حقول وإقامة كلّ مع. وبدون المضي الإقتصادية عرض هو. لم العدّ مهمّات أوروبا مما. أي وتم التي الأجل سبتمبر, الى ما فكانت مساعدة. مع الشهير والديون اقتصادية يبق.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "ببعض ولاتّساع جهة أي, إذ الحكومة الإمداد غير. أضف لم كانت تصرّف وفرنسا, عل شمال منتصف الجنوبي تعد. كما ثم وفنلندا الحكومة, تلك و اسبوعين إتفاقية التقليدي. غريمه الأسيوي بل يكن, لان شدّت قِبل واندونيسيا، ان, يبق أعمال مواقعها باستخدام كل. لفشل أمام الإمداد أن وقد, حدى وبعض تسمّى منتصف هو. الأراضي البولندي الأمريكية فقد في, ومن و الأولى ابتدعها.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "جُل بل تحرّك استعملت. فقد الولايات الإنذار، من, مرمى فمرّ الطرفين ان دنو. للجزر الفترة عن الا, ثم اعلان اليابان، أخر. بل ويعزى ولاتّساع وتم, وقد أي عرفها انتباه. ٣٠ هذه قائمة واُسدل, حتى فقامت ألمانيا مع.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "تم رئيس أفاق ولم, فعل هو سكان الأوروبية. وجهان العظمى هو كان, إذ دنو الأولى لليابان العمليات. يتسنّى بتطويق الصفحات يكن هو. بعض مئات ونتج اتّجة بل, بل ببعض الأرضية بين. مع تجهيز وتنصيب واستمرت شيء, يتمكن السيطرة مع دار.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "المضي للسيطرة لبلجيكا، هو الا, تم لها قادة يتعلّق, الثقيل لتقليعة استمرار كلّ و. لها الأولى الصينية بمعارضة عل, غرّة، وقامت عل بحث. ضرب الدمج تاريخ السفن قد, العالمي وقدّموا حيث هو. يكن ثم لغزو استمرار بالتوقيع, مئات وحتى مع مدن. يقوم يتسنّى سليمان، بـ دنو.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-health-fitness",
                name: "لياقة بدنية",
                articles: [
                    {
                        id: "4e6716eb-0430-49b0-9d95-352333d760a0",
                        class: "columns-wrap",
                        header: "حرق السعرات الحرارية الخاصة بك",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "مدن عل جنوب الجوي, عل جدول لتقليعة التجارية عدم. بين ٣٠ علاقة تكتيكاً. يرتبط وأكثرها تم كلا, الا مارد دأبوا العالم ثم. وترك غرّة، بلديهما أخذ قد, هو وبعدما الخاسر كان. تم الى أطراف الحكومة. حتى أي أمّا بهيئة الإطلاق.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "حقول الأولى إذ إيو, معقل الشمال وصل لم. قد وتم ميناء الأولى العالمية, ان حادثة واُسدل انه. ودول قررت الواقعة حول عل. أسر ما وعُرفت للسيطرة, جدول تحرير كلّ لم. يبق أفريقيا الأرضية قد, ثم جدول واُسدل دون.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "استدعى مساعدة ديسمبر حول بل, تلك هو السفن واعتلاء بريطانيا،, أن بشرية الأمريكية ومن. فرنسا اقتصادية الانجليزية بل كلا, أفاق للسيطرة كما في. تحت أي العناد تغييرات وهولندا،, بل بخطوط البرية عدد, عن والحزب معارضة وأكثرها شيء. عرفها وأزيز سبتمبر ان عرض. الأراضي المتاخمة بريطانيا-فرنسا مع بال.",
                            },
                        ],
                    },
                    {
                        id: "056698a8-0ac8-4342-9e67-25993d574866",
                        class: "columns-wrap",
                        header: "مفضلات الصالة الرياضية",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "عدد انتصارهم الأوروبية ما, إذ انه بأيدي سليمان، وبولندا, بحث أم بوابة وايرلندا. أم دارت الثالث دول, الدول النفط وتنامت الا بـ, بشرية لأداء الساحة عل يكن. ما لمّ حقول إستعمل بولندا،, على قد وتتحمّل الإحتفاظ. من مما إختار لأداء العدّ, تسبب بداية عدد لم. وإيطالي المؤلّفة عل بال, بعض والتي الصعداء في, غير عن السفن الأوربيين.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "وتم من شاسعة يتمكن. هو عُقر الحكومة استراليا، حيث, تعد عقبت الصفحة اسبوعين بل. لم شيء وبداية التجارية, هو وقد جزيرتي شموليةً الأوروبي. للصين الضروري عل لها, نفس ثم الشتوية الأسيوي. وصل تم نتيجة الإطلاق. اتفاقية الدولارات ما أخذ, تطوير كنقطة العناد هو بال.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ساعة مسؤولية والديون ما لكل, وتم جسيمة والتي الإنذار، أي, حين من أوسع البشريةً التنازلي. ان هذه أدنى وبحلول. لأداء واتّجه لم هذه, أي هامش عرفها المنتصر عدم, قام بل وبالرغم الأرضية لبولندا،. لمّ عرفها غينيا بل, به، كرسي أعلنت تم. مارد بالحرب الحيلولة ٣٠ دون, إيو ليركز للجزر تحرّكت و.",
                            },
                        ],
                    },
                    {
                        id: "389c5495-b37c-423f-8950-a1845317e41c",
                        class: "columns-wrap",
                        header: "بيلاتيس",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "قد الا جمعت حقول ويكيبيديا. لها حادثة التّحول ما. أم صفحة الخطّة الحكومة كما. مرجع غرّة، ما بحث, اوروبا الأثنان ومن و. بداية الثالث، يكن ما. عدد مع وبدون غينيا انتباه. كل نتيجة الأولى الشرقي يكن.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "هناك تغييرات واشتدّت حيث في, شدّت للمجهود التجارية ومن ان, لم وسوء وأزيز الستار مكن. تحرّكت الإطلاق بمعارضة تحت لم, من وقد تجهيز الجنوبي. بعض وسفن أراض الأخذ أي, ليبين ويعزى أم دون. مكّن بهيئة وتنصيب هو كلا, وقرى الأوروبية، عن وصل.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "كلا أم أفاق ممثّلة ألمانيا, فعل تم تونس الشمل وتتحمّل, سكان التّحول جهة أي. تصفح دأبوا الأثناء، يبق لم, قد أخر الأمم وتزويده ماليزيا،, بال تم تزامناً وهولندا،. لم الحكم الطريق انه, لان أم هامش وأكثرها والديون. من بقسوة تجهيز حول. ليبين وقدّموا ويكيبيديا تم يتم, جعل أي وبولندا بمعارضة, بها أي واُسدل الأمريكية.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-health-guides",
                name: "خطوط إرشاد",
                articles: [
                    {
                        id: "9a1282a2-e227-4d96-8f3e-99c580f2939a",
                        class: "columns-3-balanced",
                        header: "الصحة بعد 50",
                        type: "articles-list",
                        content: [
                            {
                                title: "وكما أن الوصفة تسحب دائمًا للعلاج المجاني.",
                                content: "من تنفّس وتنامت الاندونيسية كما. ما لكل شدّت عشوائية, من جُل يعبأ قِبل. أي وصل وقوعها، اليابان. في ذات مرمى الثقيل الاندونيسية, فعل ما وجهان واحدة. و جعل القوى الكونجرس الأمريكية, ٣٠ تكتيكاً المعاهدات يكن.",
                            },
                            {
                                title: "تتطلب شركة طيران الجزر أمراضًا ذكية أو ضحك القوس.",
                                content:
                                    "وشعار النزاع في وصل, تم أطراف بقيادة وفنلندا بحث. اليها المواد كما ما. و بتطويق الربيع، انه. أم الدول وزارة فقامت بحق, بحث و حاول الدول باستخدام. عن أدوات الأسيوي انه, بل أساسي سليمان، تغييرات أسر, أم الأجل المتساقطة، يتم.",
                            },
                            {
                                title: "ذلك الحرة لمحاكم الأهداف تم. ديسمبر الخاصّة الإثنان أس",
                                content: "حتى الساحل المجتمع أن, يعبأ فرنسية الشرقي ان لان, بل حول هنا؟ شدّت بخطوط. اللا تاريخ مليون أي وتم. أم شرسة الأمم دون, وبعض الأمور لمّ ان. دار مع رئيس أراض, إذ مدن موالية اليميني, شيء و واستمر البشريةً.",
                            },
                        ],
                    },
                    {
                        id: "7b268ec3-8ac2-42fc-ab0f-ac650d2493f1",
                        class: "columns-3-balanced",
                        header: "قلب صحي",
                        type: "articles-list",
                        content: [
                            {
                                title: "حامل مع شركائه ويسحب الأشعة ودفع كبير للجبال.",
                                content:
                                    "بلا ببعض الشهيرة اللازمة أم. التغييرات الأوروبيّون لها قد, إيو أي خطّة غريمه فرنسية, بال قد ممثّلة المبرمة. حتى وشعار الموسوعة ما, مكن الصينية الإكتفاء أم. الأبرياء الأوروبية إيو في, ما حول وبعدما ليتسنّى بالإنزال. هذه عن الحكم بالرّد, تكبّد والتي به، لم, أن وسفن أجزاء مما. بال ترتيب وقامت تم, وحتّى لإعلان مسؤولية و عرض.",
                            },
                            {
                                title: "ليس الكثير من الوقت فقط للجزر ، أيضًا ، الكثير من الوقت.",
                                content:
                                    "ما وصل كردة وحلفاؤها, إذ كانت إعلان الثقيلة شيء. أمدها تشيكوسلوفاكيا بلا عن. بقعة الأولى الإقتصادية و حيث, وهولندا، التقليدي تم ذلك. الأحمر مهمّات ٣٠ كلّ. كلّ أوزار العالم من. يتم ومطالبة بالمحور في. إيو رجوعهم المتحدة بـ.",
                            },
                            {
                                title: "الكثير من العلاج حتى القطر الجذاب للارتجاع.",
                                content: "اوروبا الأسيوي الولايات مع وقد, ما دنو عرفها أوروبا بأضرار. قام عن يعبأ عقبت وحرمان, و حلّت تحرّكت الا. هذه يذكر ٢٠٠٤ المضي عل. بل لبولندا، اليابانية لها, التي الأمريكي بعض ثم.",
                            },
                        ],
                    },
                    {
                        id: "f3907983-9885-4211-8878-0f85750bbaa7",
                        class: "columns-3-balanced",
                        header: "الجهاز الهضمي الصحي",
                        type: "articles-list",
                        content: [
                            {
                                title: "يخشى بعض المراهقين ، يا عزيزتي في أي رعاية.",
                                content:
                                    "كلّ ماذا الشتوية اليابانية عن. الحكم المتّبعة ٣٠ فقد, ضرب واُسدل المسرح النزاع إذ, أي استرجاع الإيطالية ذلك. مما فكان أدنى أم, تحرّكت العسكري إذ بلا. ان لان قادة السفن النزاع, دنو بداية والمعدات ما. لها تجهيز إتفاقية كل, تعد وسوء والقرى ومطالبة بل. أعلنت العناد بالرغم لم كما.",
                            },
                            {
                                title: "استثمر تجمع الموجات فوق الصوتية للواجبات المنزلية ولكن.حتى لحوم البقر القطر.",
                                content:
                                    "أن مكّن التقليدية دار, وتم حكومة ليركز عالمية ما, ثم الصعداء وانتهاءً حين. وصل الأجل بالمطالبة كل, لعملة الأوروبية، ومن ٣٠, ان وشعار اليابان الإتفاقية تحت. إذ تكبّد الجنوب على. دون مشارف ألمانيا الدّفاع ما, سقطت أدوات الثانية وقد أن.",
                            },
                            {
                                title: "نطاق الألم ليس عنصرًا حاليًا من مضادات الأكسدة.",
                                content: "فقد إذ دفّة سليمان، ابتدعها, إذ أهّل حالية ايطاليا، أخذ. الوزراء والإتحاد كلّ من. لغزو لتقليعة البولندي ٣٠ قام. دنو وسوء واندونيسيا، عن, على ٣٠ وشعار وبالتحديد،.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-health-underscored",
                name: "يؤكد",
                articles: [
                    {
                        id: "851b619c-0d4b-478a-8991-d39394660b96",
                        class: "columns-2-balanced",
                        header: "هذا أولا",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "بال قد والروسية الولايات. حاول وبعد ثانية ان الى, أواخر واتّجه بـ الى. أي أسر حقول استبدال, قد ودول الأجل هذا, جزيرتي وتنصيب التاريخ، عن الا. هو ومضى الدول للجزر فصل. تلك يطول أوروبا ثم, ما الدمج هاربر وبداية كلا, كل بال أخرى والديون الأبرياء.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "قائمة الساحة وبالرغم من بعد. العالمي تشيكوسلوفاكيا أي على, الصفحات الأعمال الجنرال بـ يبق. تسمّى ليركز بها و, عن أسر وقبل الحرة. تمهيد إجلاء في ومن. عدم وانهاء بالرغم اليابان، أي, كما قامت الأرض بأيدي ثم.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "1080c9e5-4d40-4b28-9398-c03c9f94c74e",
                        class: "columns-2-balanced",
                        header: "هذا الثاني",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "دار الدنمارك ولكسمبورغ بـ, تم بحث الإنزال الرئيسية. حصدت فرنسية المنتصر بحث ان. ان حالية الأولية دول, إعمار اتّجة جعل بل. لم وحتّى قائمة اعلان على. سليمان، التاريخ، مما مع. بخطوط وأزيز وبعدما أي الى, في خيار فبعد والفرنسي به،.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "لكل عن ألمانيا والروسية, بـ وكسبت الشرقي الخاطفة تحت. ٣٠ أضف أهّل الوراء الأوروبية, جيوب الوزراء سنغافورة أم انه, ليركز إبّان أم لها. ومن قد الأحمر محاولات وانتهاءً, لها من مشارف وبحلول لإنعدام. تم كان البرية المبرمة التبرعات. بلا بـ الغالي الثقيلة ولكسمبورغ. بمعارضة شموليةً و أضف, كما فكانت يتمكن وتنصيب بـ.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-health-what-to-eat",
                name: "ما الذي تريد أن تأكله",
                articles: [
                    {
                        id: "8ed51654-db6a-4826-bd1c-25213bc4200b",
                        class: "columns-wrap",
                        header: "الكربوهيدرات منخفضة",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "حدى عن يعبأ الفترة حاملات, وسوء الأثنان ثم انه, الى ان والقرى حاملات. قام ان تمهيد العناد بالتوقيع, ذلك بهيئة والمعدات بـ. جعل الشتاء الأوربيين هو, قدما تصرّف إبّان يتم ان, بـ كلّ أمدها كانتا المنتصر. ضرب عل سقوط المتساقطة،, لمّ و تصرّف الوراء بمحاولة. تسبب الأثناء، وصل ثم, بـ أعلنت والمانيا به،, حدى بمباركة الأسيوي التنازلي من.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "عن مكن لغات الإمداد, ٣٠ تلك مسرح الجنوبي, إذ الإكتفاء الأوربيين تلك. من مكن واتّجه والكوري عشوائية, بلاده بمباركة الرئيسية مع عدم. أراض ألمانيا عل مكن, بـ بداية الخاسر يبق. دون أي الأعمال الدّفاع والفلبين. بل عملية استرجاع تحت, ما مما مايو والتي الإقتصادي. مما من احداث اتفاق.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "قام لم تغييرات الجنوبي. أم أراضي الثقيل نفس, جمعت السيء مع أخذ. إذ لان ويعزى الوراء ومطالبة, فعل بفرض حالية أطراف ما, تحرير يتعلّق ومطالبة عن تحت. دنو والحزب معاملة العمليات ما, في حتى هنا؟ بتحدّي, وأزيز وصافرات الصفحات على في. من بعد الأجل اليميني البولندي, هذا لعدم والإتحاد بالتوقيع مع. بالعمل الجنود إذ بحق.",
                            },
                        ],
                    },
                    {
                        id: "692a6213-1024-4d3e-8e6d-34aed2bb3616",
                        class: "columns-wrap",
                        header: "نباتي",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "في ولم جمعت عشوائية. لان ماذا ٢٠٠٤ وفنلندا ثم. يتم جمعت وقبل اللا تم, كما وصغار السادس ان. فكان واستمر تعد بل. عن جديدة الساحل دنو. مما بل خطّة معزّزة الأوروبي, بداية وأزيز الخارجية وصل مع.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "٣٠ كما أفاق والروسية الإقتصادية, أم مسرح وترك اسبوعين يتم, الا وبحلول يتعلّق ان. تصفح الخطّة الشتاء، في بين, عن الخاطفة الخارجية دار. ان ذلك زهاء مشروط. كلا مع قادة العظمى, كلا مليون وبالرغم بل, حدى و كردة بالعمل الفرنسي. يذكر الأراضي عن دول, ٣٠ لأداء اسبوعين ذلك, بال أثره، السيء إذ.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "مكّن المدن لم جعل. بعد أم أدوات ويكيبيديا وبريطانيا. مع بعض الوزراء تشيكوسلوفاكيا, لم حول تونس الضغوط. بـ الحكم مهمّات بحق, سياسة بالعمل تم تحت. مساعدة وتنصيب ويكيبيديا كما أم, فعل بقصف المزيفة التقليدي من.",
                            },
                        ],
                    },
                    {
                        id: "f264a46c-4e7e-4c9f-bf04-d4ed1fa6639a",
                        class: "columns-wrap",
                        header: "إفطار",
                        type: "excerpt",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "ما وقد كانت تسبب الإنذار،, اتّجة الاندونيسية بعض قد. تم الى عليها وسمّيت. عل لكون بالفشل عرض, اسبوعين والنرويج قد حول. بها الأمور رجوعهم الإمتعاض عل.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "هناك والمانيا الا مع. هو تلك تكبّد نتيجة ويتّفق, كانت الشرق، الرئيسية لكل كل. كل المبرمة الفرنسي ذات, زهاء الثالث وبولندا عرض و. ان تحت ليبين وبغطاء الهجوم. غضون الأرواح قُدُماً ٣٠ عدد, حتى مشارف والحزب أي. قائمة الأوربيين لمّ عل.",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                text: "وصغار أطراف أي ذات. هذه عن واحدة أوزار التخطيط, لم وجزر بالحرب مدن. لان ان ثانية والإتحاد. نهاية التقليدي حدى عل, مكن السيطرة الثالث، الأرضية لم.",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-health-hot-topics",
                name: "مواضيع مثيرة",
                articles: [
                    {
                        id: "dde55759-06c6-46bc-9f16-bed37ae3d77f",
                        class: "columns-2-balanced",
                        header: "هذا أولا",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "ان الجو للسيطرة الأثنان شيء. مما عن أدوات يتعلّق المنتصر, شاسعة الصين سنغافورة ولم ثم. بعض بقعة والحزب التجارية عن. فقد وإيطالي الشتاء، وايرلندا أن, من يطول فقامت الشتوية كلا, إذ كانتا اكتوبر أسر.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "new",
                                        label: "جديد",
                                    },
                                },
                                text: "مليارات الأراضي عن بعض. بال سقطت دأبوا من, أن بوابة بالسيطرة باستحداث كان. بعد لعدم بالولايات أم. احداث أعمال القوى أسر و.",
                                url: "#",
                            },
                        ],
                    },
                    {
                        id: "17f26d05-24ef-4a12-80b0-611a43449aae",
                        class: "columns-2-balanced",
                        header: "هذا الثاني",
                        type: "grid",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "حصدت وترك بقيادة ذلك أن, ذلك مايو فرنسية قد. حكومة وحلفاؤها الأوربيين بل مما, وفي عن هُزم بالفشل العالمية. المتحدة والمعدات من بعد, مدن من الصين الإقتصادي. تعد أي غريمه النفط استدعى, بل المارق الشهير العمليات قبل. لكون الشطر عدم أن, أخرى كُلفة إستعمل عن ومن, مع ضرب عقبت الهادي.",
                                url: "#",
                            },
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                meta: {
                                    tag: {
                                        type: "breaking",
                                        label: "كسر",
                                    },
                                },
                                text: "بعد كل انتباه بالرّغم بالولايات, مدن بـ وبعد إستعمل. مع العدّ استدعى الأمريكي وفي, بعض وقامت بتحدّي والعتاد في. وأزيز قائمة أم تحت. أمام وباءت مواقعها كل الى, حقول بخطوط بأضرار أي مكن. سكان استدعى ذات مع, وقد ٣٠ خيار الفترة الرئيسية, و أما اتفاق مكثّفة إستعمل.",
                                url: "#",
                            },
                        ],
                    },
                ],
            },
            {
                id: "content-health-paid-content",
                name: "المحتوى المدفوع",
                articles: [
                    {
                        id: "cbaac182-d046-43ee-b6d7-41a382e959ad",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "سلطة كرة القدم حياة مجرد عملية الاحماء العظيمة.جعبة كبيرة واستثمر تصنيع تخرج.الراحة الإلزامية لا تتابع الذروة.",
                            },
                        ],
                    },
                    {
                        id: "ae883d3e-ef62-4f6e-ac2d-5555ca35f11a",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "مركبات في زيارة من دورة الحياة المدرسية.بالنسبة إلى أسهم عنصر الحياة في المنطقة والواجب المنزلي الأسد.لا احتياجات مطور التغذية ماليسوادا.",
                            },
                        ],
                    },
                    {
                        id: "d8f20994-0098-4367-bc3a-131faa8f768d",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "إنها أتمنى أن ترغب في إزالة القوس الكراهية.جرة هي الآن الخوف.مطور الراحة الجامعي في في تمويل هو.في كرة السلة ، وقتي تمويل أي مطور التغذية.",
                            },
                        ],
                    },
                    {
                        id: "51f4b351-5916-4422-b661-61b65b911ee5",
                        class: "columns-4-balanced",
                        type: "preview",
                        content: [
                            {
                                image: {
                                    src: "placeholder_light.jpg",
                                    alt: "عنصر نائب",
                                    width: "1280",
                                    height: "720",
                                },
                                title: "كان التمويل ولكن الأداء ولكن البوابة.نولام ودرجة حرارة الحلق الفلفل الحار سعر المعرف السريري.الكتلة ليست واقعية الآن لعنصر المنطقة.",
                            },
                        ],
                    },
                ],
            },
        ],
    },
};
